import { Schema } from 'js-data'
import * as PASchema from './PAdbSchema'
import * as _ from 'lodash'
import { IKeyGeneratorSpecs } from './lib/libIF'

import {
    dctLogicalKeysByEntitySet,
    dctMapperToKeyGenSpecs,
    dctNonParentForeignKeysByEntitySet,
    dctSchemaByEntitySet,
    dctTableNameByEntitySet, esWB_ScnConstraint, esWB_ScnPlannerCalc,
    esWB_ScnPlannerCnstr,
    esWB_ScnPlannerCR,
    esWB_ScnPlannerESR, esWB_ScnPlannerPPR,
    esWB_ScnPlannerPR, esWB_ScnPlannerPrdPPR, esWB_ScnPlannerPrdPR, esWB_ScnPlannerPrmR,
    esWB_ScnPlannerTrial, esWB_ScnPlannerTrialEvt,
    KeyGenSpecs_default
} from './PAdbSchema'

// Affinity Set

export const WB_AffinitySet = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_AffinitySet', // optional
    description: 'Schema for WB_AffinitySet records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_AFFINITYSET_ID: {
            type: 'number',
            id: true,
            required: true
        },
        AFFINITYSET_ID: {
            type: 'string',
            length: 50
        },
        AFFINITYSET_NAME: {
            type: 'string',
            length: 256
        },
        AFFINITYSET_TYPE: {
            type: 'string',
            length: 50
        },
        WB_MODEL_CANNIBALIZATIONM_ID: {
            type: 'number'
        },
        EQUIV_UOM: {
            type: 'string',
            length: 50
        },
        WB_MDSET_ID: {
            type: 'number'
        },
        WB_SALESORG_ID: {
            type: 'number'
        },
        WB_ENTITY_ID_CUSTOMER: {
            type: 'number'
        },
        WB_CUSTH_ID: {
            type: 'number'
        },
        WB_ENTITY_ID_PRODUCT: {
            type: 'number'
        },
        WB_PRDH_ID: {
            type: 'number'
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_AffinitySet_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Cannibalization_Type]: {
            foreignKey: 'WB_MODEL_CANNIBALIZATIONM_ID',
            foreignKeyImmutable: true,
            localField: 'CannibalizationType'
        },
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: 'WB_MDSET_ID',
            foreignKeyImmutable: true,
            localField: 'MasterDataSet'
        },
        [PASchema.esWB_SalesOrg]: { foreignKey: 'WB_SALESORG_ID', foreignKeyImmutable: true, localField: 'SalesOrg' },
        [PASchema.esWB_Entity]: [
            { foreignKey: 'WB_ENTITY_ID_CUSTOMER', foreignKeyImmutable: true, localField: 'CustomerType' },
            { foreignKey: 'WB_ENTITY_ID_PRODUCT', foreignKeyImmutable: true, localField: 'ProductType' },
            { foreignKey: 'WB_ENTITY_ID_PERIOD', foreignKeyImmutable: true, localField: 'PeriodType' }
        ],
        [PASchema.esWB_Customer_Hierarchy]: {
            foreignKey: 'WB_CUSTH_ID',
            foreignKeyImmutable: true,
            localField: 'CustomerHierarchy'
        },
        [PASchema.esWB_Product_Hierarchy]: {
            foreignKey: 'WB_PRDH_ID',
            foreignKeyImmutable: true,
            localField: 'ProductHierarchy'
        }
    },
    hasMany: {
        [PASchema.esWB_AffinityGroup]: {
            foreignKey: 'WB_AFFINITYSET_ID',
            foreignKeyImmutable: true,
            localField: 'AffinityGroups'
        },
        [PASchema.esWB_Modeling_Session_AffinitySet_Relationship]: {
            foreignKey: 'WB_AFFINITYSET_ID',
            foreignKeyImmutable: true,
            localField: 'AffinitySetMdlSessionRs'
        }
    }
}

export const WB_AffinityGroup = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_AffinityGroup', // optional
    description: 'Schema for WB_AffinityGroup records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_AFFINITYGROUP_ID: {
            type: 'number',
            id: true,
            required: true
        },
        AFFINITYGROUP_ID: {
            type: 'string',
            length: 50
        },
        AFFINITYGROUP_NAME: {
            type: 'string',
            length: 256
        },
        AFFINITYGROUP_TYPE: {
            type: 'string',
            length: 50
        },
        WB_AFFINITYSET_ID: {
            type: 'number'
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_AffinityGroup_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_AffinitySet]: {
            foreignKey: 'WB_AFFINITYSET_ID',
            foreignKeyImmutable: true,
            localField: 'AffinitySet'
        }
    },
    hasMany: {
        [PASchema.esWB_AffinityGroupItem]: {
            foreignKey: 'WB_AFFINITYGROUP_ID',
            foreignKeyImmutable: true,
            localField: 'Items'
        }
    }
}

export const WB_AffinityGroupItem = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_AffinityGroupItem', // optional
    description: 'Schema for WB_AffinityGroupItem records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_AFFINITYGROUPITEM_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_AFFINITYGROUP_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        EQV_UNIT_RATE: {
            type: 'number'
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_AffinityGroupItem_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_AffinityGroup]: {
            foreignKey: 'WB_AFFINITYGROUP_ID',
            foreignKeyImmutable: true,
            localField: 'AffinityGroup'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    }
}

// Cannibalization Set BO
export const WB_Cannibalization_Set = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Cann', // optional
    description: 'Schema for WB_Cann records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_CANN_ID: {
            type: 'number',
            id: true,
            required: true
        },
        CANN_NAME: {
            type: 'string',
            length: 256
        },
        CANNIB_TYPE_ID: {
            type: 'number'
        },
        EFFECTIVE_START_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: 'string',
            default: '99991231',
            length: 8
        },
        WB_PRDGRP_ID_AFFSET: {
            type: 'number'
        },
        WB_AUTHUSR_ID: {
            type: 'number'
        },
        TREE_PATH: {
            type: 'string',
            length: 256
        }
    }
})
export const WB_Cannibalization_Set_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Domain_Item]: {
            foreignKey: 'CANNIB_TYPE_ID',
            foreignKeyImmutable: true,
            localField: 'CannibalizationSetType'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID_AFFSET',
            foreignKeyImmutable: true,
            localField: 'AffinitySet'
        },
        [PASchema.esWB_User]: { foreignKey: 'WB_AUTHUSR_ID', foreignKeyImmutable: true, localField: 'User' }
    },
    hasMany: {
        [PASchema.esWB_Cannibalization_Set_Customer]: {
            foreignKey: 'WB_CANN_ID',
            foreignKeyImmutable: true,
            localField: 'CannCustomers'
        },
        [PASchema.esWB_Cannibalization_Set_Product_Group]: {
            foreignKey: 'WB_CANN_ID',
            foreignKeyImmutable: true,
            localField: 'CannProductGroups'
        }
    }
}

export const WB_Cannibalization_Set_Customer = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_CannCst', // optional
    description: 'Schema for WB_CannCst records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_CANNCST_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_CANN_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        CUST_ROLE: {
            type: 'string',
            length: 20
        }
    }
})
export const WB_Cannibalization_Set_Customer_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Cannibalization_Set]: {
            foreignKey: 'WB_CANN_ID',
            foreignKeyImmutable: true,
            localField: 'CannibalizationSet'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' }
    }
}

export const WB_Cannibalization_Set_Product_Group = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_CannPG', // optional
    description: 'Schema for WB_CannPG records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_CANNPG_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_CANN_ID: {
            type: 'number'
        },
        WB_CUST_ID_PLANNING_VICT: {
            type: 'number'
        },
        WB_PRDGRP_ID_VICT: {
            type: 'number'
        },
        EFFECTIVE_DT_VICT: {
            type: 'string',
            length: 8
        },
        WB_CUST_ID_PLANNING_AGGR: {
            type: 'number'
        },
        WB_PRDGRP_ID_AGGR: {
            type: 'number'
        },
        EFFECTIVE_DT_AGGR: {
            type: 'string',
            length: 8
        },
        CANNIB_QTY: {
            type: 'number'
        },
        CANNIB_UOM: {
            type: 'string',
            length: 20
        },
        VICTIM_EQV: {
            type: 'number'
        },
        VICTIM_UNITS: {
            type: 'number'
        },
        VICTIM_RTLSLS: {
            type: 'number'
        },
        VICTIM_PROFIT: {
            type: 'number'
        },
        VICTIM_LSTSLS: {
            type: 'number'
        },
        AGGR_INCR_UNITS: {
            type: 'number'
        },
        AGGR_INCR_RTLSLS: {
            type: 'number'
        },
        AGGR_INCR_PROFIT: {
            type: 'number'
        },
        AGGR_INCR_LSTSLS: {
            type: 'number'
        },
        AGGR_UNITS: {
            type: 'number'
        },
        AGGR_RTLSLS: {
            type: 'number'
        },
        AGGR_PROFIT: {
            type: 'number'
        },
        AGGR_LSTSLS: {
            type: 'number'
        },
        AGGR_TOTAL_UNITS: {
            type: 'number'
        },
        AGGR_TOTAL_RTLSLS: {
            type: 'number'
        },
        AGGR_TOTAL_PROFIT: {
            type: 'number'
        },
        AGGR_TOTAL_LSTSLS: {
            type: 'number'
        },
        AGGR_BASE_UNITS: {
            type: 'number'
        },
        AGGR_BASE_RTLSLS: {
            type: 'number'
        },
        AGGR_BASE_PROFIT: {
            type: 'number'
        },
        AGGR_BASE_LSTSLS: {
            type: 'number'
        },
        ANY_FEAT_WO_DISPLAY_ACV: {
            type: 'number'
        },
        ANY_DISPLAY_WO_FEAT_ACV: {
            type: 'number'
        },
        ANY_FEAT_DISPLAY_ACV: {
            type: 'number'
        },
        PRICE_DECREASE_ACV: {
            type: 'number'
        },
        ANY_PROMO_ACV: {
            type: 'number'
        },
        CURRENCY: {
            type: 'string',
            length: 20
        }
    }
})
export const WB_Cannibalization_Set_Product_Group_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Cannibalization_Set]: {
            foreignKey: 'WB_CANN_ID',
            foreignKeyImmutable: true,
            localField: 'CannibalizationSet'
        },
        [PASchema.esWB_Product_Group]: [
            {
                foreignKey: 'WB_PRDGRP_ID_VICT',
                foreignKeyImmutable: true,
                localField: 'VictimProductGroup'
            },
            { foreignKey: 'WB_PRDGRP_ID_AGGR', foreignKeyImmutable: true, localField: 'AggressorProductGroup' }
        ],
        [PASchema.esWB_Customer]: [
            {
                foreignKey: 'WB_CUST_ID_PLANNING_VICT',
                foreignKeyImmutable: true,
                localField: 'VictimPlanningCustomer'
            },
            {
                foreignKey: 'WB_CUST_ID_PLANNING_AGGR',
                foreignKeyImmutable: true,
                localField: 'AggressorPlanningCustomer'
            }
        ]
    },
    hasMany: {
        [PASchema.esWB_Cannibalization_Set_Product]: {
            foreignKey: 'WB_CANNPG_ID',
            foreignKeyImmutable: true,
            localField: 'CannProducts'
        }
    }
}

export const WB_Cannibalization_Set_Product = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_CannPrd', // optional
    description: 'Schema for WB_CannPrd records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_CANNPRD_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_CANNPG_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        EFFECTIVE_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        PRDGRP_ROLE: {
            type: 'string',
            length: 20
        },
        VICTIM_EQV: {
            type: 'number'
        },
        VICTIM_UNITS: {
            type: 'number'
        },
        VICTIM_RTLSLS: {
            type: 'number'
        },
        VICTIM_PROFIT: {
            type: 'number'
        },
        VICTIM_LSTSLS: {
            type: 'number'
        },
        AGGR_INCR_UNITS: {
            type: 'number'
        },
        AGGR_INCR_RTLSLS: {
            type: 'number'
        },
        AGGR_INCR_PROFIT: {
            type: 'number'
        },
        AGGR_INCR_LSTSLS: {
            type: 'number'
        },
        AGGR_UNITS: {
            type: 'number'
        },
        AGGR_RTLSLS: {
            type: 'number'
        },
        AGGR_PROFIT: {
            type: 'number'
        },
        AGGR_LSTSLS: {
            type: 'number'
        },
        AGGR_TOTAL_UNITS: {
            type: 'number'
        },
        AGGR_TOTAL_RTLSLS: {
            type: 'number'
        },
        AGGR_TOTAL_PROFIT: {
            type: 'number'
        },
        AGGR_TOTAL_LSTSLS: {
            type: 'number'
        },
        AGGR_BASE_UNITS: {
            type: 'number'
        },
        AGGR_BASE_RTLSLS: {
            type: 'number'
        },
        AGGR_BASE_PROFIT: {
            type: 'number'
        },
        AGGR_BASE_LSTSLS: {
            type: 'number'
        }
    }
})
export const WB_Cannibalization_Set_Product_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        },
        [PASchema.esWB_Cannibalization_Set_Product_Group]: {
            foreignKey: 'WB_CANNPG_ID',
            foreignKeyImmutable: true,
            localField: 'CannibalizationSetPG'
        }
    }
}

// Model - Master Data

export const WB_Model_Predictor = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Model Predictor', // optional
    description: 'Schema for WB_Model_Predictor records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_PREDICTOR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        MODEL_PREDICTOR_ID: {
            type: 'string',
            length: 256
        },
        MODEL_PREDICTOR_NAME: {
            type: 'string',
            length: 256
        },
        MODEL_PREDICTOR_TYPE: {
            type: 'string',
            length: 256
        },
        PREDICTOR_META_ID: {
            type: 'string',
            length: 256
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        AGGREGATION_METHOD: {
            type: 'string',
            length: 50
        },
        NUMBER_TYPE: {
            type: 'string',
            length: 50
        },
        DECIMAL_COUNT: {
            type: 'number'
        },
        MIN_VALUE_IND: {
            type: 'string',
            length: 1
        },
        MIN_VALUE: {
            type: 'number',
            default: ''
        },
        MAX_VALUE_IND: {
            type: 'string',
            length: 1
        },
        MAX_VALUE: {
            type: 'number',
            default: ''
        },
        SORT_ORDER_UI: {
            type: 'number'
        },
        RENDER_OPTIONS: {
            type: 'string',
            length: 1333
        },
        SOURCE_TABLENAME: {
            type: 'string',
            length: 128
        },
        SOURCE_FIELDNAME: {
            type: 'string',
            length: 128
        },
        WEIGHT_AVERAGING_FIELDNAME: {
            type: 'string',
            length: 128
        },
        CUSTOMER_FIELDNAME: {
            type: 'string',
            length: 128
        },
        ENTITY_ID_CUSTOMER: {
            type: 'string',
            length: 50
        },
        PRODUCT_FIELDNAME: {
            type: 'string',
            length: 128
        },
        ENTITY_ID_PRODUCT: {
            type: 'string',
            length: 50
        },
        PERIOD_METHOD: {
            type: 'string',
            length: 128
        },
        PERIOD_FIELDNAME: {
            type: 'string',
            length: 128
        },
        ENTITY_ID_PERIOD: {
            type: 'string',
            length: 50
        },
        PARTITION_ID_FIELDNAME: {
            type: 'string',
            length: 128
        },
        SOURCE_CUSTOMER_ID_FIELDNAME: {
            type: 'string',
            length: 128
        },
        DEFAULT_VALUE: {
            type: 'number',
            default: ''
        },
        EFFECTIVE_START_DT_FIELDNAME: {
            type: 'string',
            length: 128
        },
        EFFECTIVE_END_DT_FIELDNAME: {
            type: 'string',
            length: 128
        },
        WB_TAG_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID_A: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID_B: {
            type: 'number'
        },
        COMPOUND_OPERATION: {
            type: 'string',
            length: 128
        },
        PLOT_AXIS_NAME: {
            type: 'string',
            length: 256
        },
        PLOT_DATA_SHAPE: {
            type: 'string',
            length: 50
        },
        PLOT_DATA_COLOR: {
            type: 'string',
            length: 50
        },
        PLOT_DATA_PATTERN: {
            type: 'string',
            length: 50
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Predictor_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Entity]: [
            { foreignKey: 'WB_ENTITY_ID_CUSTOMER', foreignKeyImmutable: true, localField: 'CustomerType' },
            { foreignKey: 'WB_ENTITY_ID_PRODUCT', foreignKeyImmutable: true, localField: 'ProductType' },
            { foreignKey: 'WB_ENTITY_ID_PERIOD', foreignKeyImmutable: true, localField: 'PeriodType' }
        ]
    },
    hasMany: {
        [PASchema.esWB_Modeling_Session_Trial_PredictorR_Metric]: {
            foreignKey: 'WB_MODELING_SESSION_TRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'PredRMetrics'
        }
    }
}

export const WB_Model_Function = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Function', // optional
    description: 'Schema for WB_Model_Function records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_FUNCTION_ID: {
            type: 'number',
            id: true,
            required: true
        },
        MODEL_FUNCTION_ID: {
            type: 'string',
            length: 50
        },
        MODEL_FUNCTION_NAME: {
            type: 'string',
            length: 256
        },
        MODEL_FUNCTION_TYPE: {
            type: 'string',
            length: 50
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        CLASS_ID: {
            type: 'string',
            length: 50
        },
        FUNCTION_DEFN_SRC: {
            type: 'string',
            length: 1333
        },
        PREDICTOR_COUNT: {
            type: 'number'
        },
        PREDICTOR1_NUMBER_TYPE: {
            type: 'string',
            length: 50
        },
        PREDICTOR2_NUMBER_TYPE: {
            type: 'string',
            length: 50
        },
        PREDICTOR3_NUMBER_TYPE: {
            type: 'string',
            length: 50
        },
        COEFFICIENT_COUNT: {
            type: 'number'
        },
        CONSTANT_COUNT: {
            type: 'number'
        },
        PERIOD_OFFSET_MAX: {
            type: 'number'
        },
        RENDER_OPTIONS: {
            type: 'string',
            length: 1333
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        REFERENCE_VALUE_REQD_IND: {
            type: 'string',
            length: 1
        },
        NEUTRALIZED_VALUE: {
            "type": "number"
        }
    }
})
export const WB_Model_Function_JSData_RELs = {}

export const WB_Model_Input = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Model Input', // optional
    description: 'Schema for WB_Model_Input records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_INPUT_ID: {
            type: 'number',
            id: true,
            required: true
        },
        MODEL_INPUT_ID: {
            type: 'string',
            length: 256
        },
        MODEL_INPUT_NAME: {
            type: 'string',
            length: 256
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        AGGREGATION_METHOD: {
            type: 'string',
            length: 50
        },
        NUMBER_TYPE: {
            type: 'string',
            length: 50
        },
        DECIMAL_COUNT: {
            type: 'number'
        },
        MIN_VALUE_IND: {
            type: 'string',
            length: 1
        },
        MIN_VALUE: {
            type: 'number',
            default: ''
        },
        MAX_VALUE_IND: {
            type: 'string',
            length: 1
        },
        MAX_VALUE: {
            type: 'number',
            default: ''
        },
        SORT_ORDER_UI: {
            type: 'number'
        },
        INPUT_FIELDNAME: {
            type: 'string',
            length: 128
        },
        RENDER_OPTIONS: {
            type: 'string',
            length: 1333
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Model_Input_JSData_RELs = {}

export const WB_Model_Volume_Component = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Vol_Comp', // optional
    description: 'Schema for WB_Periodh records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_VOLUME_COMPONENT_ID: {
            type: 'number',
            id: true,
            required: true
        },
        VOLUME_COMPONENT_ID: {
            type: 'string',
            length: 50
        },
        VOLUME_COMPONENT_NAME: {
            type: 'string',
            length: 256
        },
        VOLUME_COMPONENT_TYPE: {
            type: 'string',
            length: 50
        },
        VOLUME_COMPONENT_SUBTYPE: {
            type: 'string',
            length: 50
        },
        RENDER_OPTIONS: {
            type: 'string',
            length: 256
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Volume_Component_JSData_RELs = {}

// Model
export const WB_Model = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model', // optional
    description: 'Schema for Wb_Model records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_ID: {
            type: 'number',
            id: true,
            required: true
        },
        MODEL_ID: {
            type: 'string',
            length: 50
        },
        MODEL_NAME: {
            type: 'string',
            length: 256
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        MODEL_TYPE: {
            type: 'string',
            length: 50
        },
        CANNIBALIZATION_IND: {
            type: 'string',
            length: 1
        },
        CANNIBALIZATION_CALC_MODE: {
            type: 'string',
            length: 50
        },
        MODEL_UOM: {
            type: 'string',
            length: 50
        },
        MODEL_FORMULA: {
            type: 'string',
            length: 2500
        },
        RESIDUAL_METHOD: {
            type: 'string',
            length: 50
        },
        WB_MODEL_DATASOURCE_ID: {
            type: 'number'
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Model_Term_Relationship]: {
            foreignKey: 'WB_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelTermRels'
        },
        [PASchema.esWB_Model_Predictor_Relationship]: {
            foreignKey: 'WB_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictorRels'
        },
        [PASchema.esWB_Model_Volume_ComponentR]: {
            foreignKey: 'WB_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelVolumeComponentRels'
        },

        [PASchema.esWB_Model_Cannibalization_Relationship]: {
            foreignKey: 'WB_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCannRels'
        },

        [PASchema.esWB_Model_Cannibalization_Const_Relationship]: {
            foreignKey: 'WB_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCannConstRels'
        },

        [PASchema.esWB_Model_Tag_Relationship]: {
            foreignKey: 'WB_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelTagRels'
        },
        [PASchema.esWB_Model_Profile]: {
            foreignKey: 'WB_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelProfiles'
        },
        [PASchema.esWB_Model_Event_Type_Relationship]: {
            foreignKey: 'WB_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelEvtTypeRs'
        }

    },
    belongsTo: {
        [PASchema.esWB_User]: {
            foreignKey: 'WB_AUTHUSR_ID_CREATEDBY',
            foreignKeyImmutable: true,
            localField: 'Creator'
        }
    }
}

export const WB_Model_Constant = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Constant', // optional
    description: 'Schema for WB_Model_Constant records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_CONSTANT_ID: {
            type: 'number',
            id: true,
            required: true
        },
        CONSTANT_ID: {
            type: 'string',
            length: 50
        },
        CONSTANT_NAME: {
            type: 'string',
            length: 256
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        USAGE: {
            type: 'string',
            length: 50
        },
        CONSTANT_TYPE: {
            type: 'string',
            length: 50
        },
        PERIOD_INDEX_IND: {
            type: 'string',
            length: 1
        },
        CUSTOMER_IND: {
            type: 'string',
            length: 1
        },
        PRODUCT_IND: {
            type: 'string',
            length: 1
        },
        SUBMODEL_IND: {
            type: 'string',
            length: 1
        },
        AFFINITY_SET_IND: {
            type: 'string',
            length: 1
        },
        AGGRESSOR_SUBMODEL_IND: {
            type: 'string',
            length: 1
        },
        VICTIM_SUBMODEL_IND: {
            type: 'string',
            length: 1
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Constant_JSData_RELs = {
    belongsTo: {},
    hasMany: {}
}

export const WB_Model_Term = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Term', // optional
    description: 'Schema for WB_Model_Term records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_TERM_ID: {
            type: 'number',
            id: true,
            required: true
        },
        TERM_ID: {
            type: 'string',
            length: 50
        },
        TERM_NAME: {
            type: 'string',
            length: 256
        },
        TERM_TYPE: {
            type: 'string',
            length: 50
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        WB_MODEL_FUNCTION_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID2: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID3: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID4: {
            type: 'number'
        },
        WB_MODEL_COEFFICIENT_ID: {
            type: 'number'
        },
        WB_MODEL_COEFFICIENT_ID2: {
            type: 'number'
        },
        WB_MODEL_COEFFICIENT_ID3: {
            type: 'number'
        },
        WB_MODEL_COEFFICIENT_ID4: {
            type: 'number'
        },
        WB_MODEL_CONSTANT_ID: {
            type: 'number'
        },
        WB_MODEL_CONSTANT_ID2: {
            type: 'number'
        },
        WB_MODEL_CONSTANT_ID3: {
            type: 'number'
        },
        WB_MODEL_CONSTANT_ID4: {
            type: 'number'
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Term_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Function]: {
            foreignKey: 'WB_MODEL_FUNCTION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelFunction'
        }
    },
    hasMany: {
        [PASchema.esWB_Model_Term_Relationship]: {
            foreignKey: 'WB_MODEL_TERM_ID',
            foreignKeyImmutable: true,
            localField: 'ModelTermRels'
        }
    }
}

export const WB_Model_Term_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Term', // optional
    description: 'Schema for WB_Model_TermR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_TERMR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_ID: {
            type: 'number'
        },
        WB_MODEL_TERM_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Term_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model]: { foreignKey: 'WB_MODEL_ID', foreignKeyImmutable: true, localField: 'Model' },
        [PASchema.esWB_Model_Term]: {
            foreignKey: 'WB_MODEL_TERM_ID',
            foreignKeyImmutable: true,
            localField: 'ModelTerm'
        }
    }
}

export const WB_Model_Cannibalization_Type = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_CannibalizationM', // optional
    description: 'Schema for WB_Model_CannibalizationM records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_CANNIBALIZATIONM_ID: {
            type: 'number',
            id: true,
            required: true
        },
        CANNIBALIZATION_TYPE_ID: {
            type: 'string',
            length: 50
        },
        CANNIBALIZATION_TYPE_NAME: {
            type: 'string',
            length: 256
        },
        RENDER_OPTIONS: {
            type: 'string',
            length: 1333
        },
        CUSTOMER_CANN_METHOD: {
            type: 'string',
            length: 50
        },
        PRODUCT_CANN_METHOD: {
            type: 'string',
            length: 50
        },
        TIME_CANN_METHOD: {
            type: 'string',
            length: 50
        },
        WB_MODEL_VOLUME_COMPONENT_ID: {
            type: 'number',
            id: true
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Model_Cannibalization_Type_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Model_Cannibalization_Relationship]: {
            foreignKey: 'WB_MODEL_CANNIBALIZATIONM_ID',
            foreignKeyImmutable: true,
            localField: 'CannTypes'
        },
        [PASchema.esWB_Modeling_Session_Cannibalization_Type_Relationship]: {
            foreignKey: 'WB_MODELING_SESSION_CANNMR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCannMR'
        }
    },
    belongsTo: {
        [PASchema.esWB_Model_Volume_Component]: {
            foreignKey: 'WB_MODEL_VOLUME_COMPONENT_ID',
            foreignKeyImmutable: true,
            localField: 'ModelVolumeComponent'
        }
    }
}

export const WB_Model_Cannibalization_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_CannR', // optional
    description: 'Schema for WB_Model_CannR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_CANNR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_CANNIBALIZATIONM_ID: {
            type: 'number'
        },
        WB_MODEL_ID: {
            type: 'number'
        },
        WB_MODEL_FUNCTION_ID: {
            type: 'number'
        },
        WB_MODEL_FUNCTION_ID_DECAY: {
            type: 'number'
        },
        WB_MODEL_COEFFICIENT_ID: {
            type: 'number'
        },
        WB_MODEL_COEFFICIENT_ID2: {
            type: 'number'
        },
        WB_MODEL_POWERMETRIC_ID: {
            type: 'number'
        },
        EVALUATION_ORDER: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Model_Cannibalization_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model]: {
            foreignKey: 'WB_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'Model'
        },
        [PASchema.esWB_Model_Cannibalization_Type]: {
            foreignKey: 'WB_MODEL_CANNIBALIZATIONM_ID',
            foreignKeyImmutable: true,
            localField: 'CannType'
        },

        [PASchema.esWB_Power_Metric]: {
            foreignKey: 'WB_MODEL_POWERMETRIC_ID',
            foreignKeyImmutable: true,
            localField: 'PowerMetric'
        },
        [PASchema.esWB_Model_Function]: [
            {
                foreignKey: 'WB_MODEL_FUNCTION_ID',
                foreignKeyImmutable: true,
                localField: 'ModelFunction'
            },
            {
                foreignKey: 'WB_MODEL_FUNCTION_ID_DECAY',
                foreignKeyImmutable: true,
                localField: 'ModelFunctionDecay'
            }
        ],

        [PASchema.esWB_Model_Coefficient]: [
            {
                foreignKey: 'WB_MODEL_COEFFICIENT_ID',
                foreignKeyImmutable: true,
                localField: 'ModelCoeff1'
            },
            {
                foreignKey: 'WB_MODEL_COEFFICIENT_ID2',
                foreignKeyImmutable: true,
                localField: 'ModelCoeff2'
            }
        ]
    },
    hasMany: {
        [PASchema.esWB_Model_Cannibalization_Term_Relationship]: {
            foreignKey: 'WB_MODEL_CANNR_ID',
            foreignKeyImmutable: true,
            localField: 'CannTermRels'
        }
    }
}

export const WB_Model_Cannibalization_Const_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_CannCR', // optional
    description: 'Schema for WB_Model_CannCR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_CANNCR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_ID: {
            type: 'number'
        },
        WB_MODEL_CONSTANT_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Model_Cannibalization_Const_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model]: {
            foreignKey: 'WB_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'Model'
        },
        [PASchema.esWB_Model_Constant]: {
            foreignKey: 'WB_MODEL_CONSTANT_ID',
            foreignKeyImmutable: true,
            localField: 'ModelConstant'
        }
    }
}

export const WB_Model_Cannibalization_Term_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_CannTermR', // optional
    description: 'Schema for WB_Model_CannTermR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_CANNTERMR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_CANNR_ID: {
            type: 'number'
        },
        WB_MODEL_TERM_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Cannibalization_Term_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Cannibalization_Relationship]: {
            foreignKey: 'WB_MODEL_CANNR_ID',
            foreignKeyImmutable: true,
            localField: 'CannTypeR'
        },
        [PASchema.esWB_Model_Term]: {
            foreignKey: 'WB_MODEL_TERM_ID',
            foreignKeyImmutable: true,
            localField: 'ModelTerm'
        }
    }
}

export const WB_Model_Predictor_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Wb_Model_PredictorR', // optional
    description: 'Schema for Wb_Model_PredictorR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_PREDICTORR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        UI_GROUP_NAME: {
            type: 'string',
            length: 256
        },
        ITEM_SORT_ORDER: {
            type: 'number'
        },
        WB_REPORTTILE_ID: {
            type: 'number'
        },
        CBO_UI_GROUP_NAME: {
            type: 'string',
            length: 256
        },
        CBO_ITEM_SORT_ORDER: {
            type: 'number'
        },
        CBO_INPUT_TYPE: {
            type: 'string',
            length: 50
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Predictor_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model]: { foreignKey: 'WB_MODEL_ID', foreignKeyImmutable: true, localField: 'Model' },
        [PASchema.esWB_Model_Predictor]: {
            foreignKey: 'WB_MODEL_PREDICTOR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        }
    }
}

export const WB_Model_Tag_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Model Tag Relationship', // optional
    description: 'Schema for WB_Model_TagR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_TAGR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_ID: {
            type: 'number'
        },
        WB_TAG_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Tag_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model]: { foreignKey: 'WB_MODEL_ID', foreignKeyImmutable: true, localField: 'Model' },
        [PASchema.esWB_Tag]: { foreignKey: 'WB_TAG_ID', foreignKeyImmutable: true, localField: 'Tag' }
    }
}

export const WB_Model_Volume_Component_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Volume_ComponentR', // optional
    description: 'Schema for WB_Model_Volume_ComponentR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_VOLUME_COMPONENTR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_ID: {
            type: 'number'
        },
        WB_MODEL_VOLUME_COMPONENT_ID: {
            type: 'number'
        },
        DECOMPOSITION_ORDER: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Volume_Component_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model]: { foreignKey: 'WB_MODEL_ID', foreignKeyImmutable: true, localField: 'Model' },
        [PASchema.esWB_Model_Volume_Component]: {
            foreignKey: 'WB_MODEL_VOLUME_COMPONENT_ID',
            foreignKeyImmutable: true,
            localField: 'ModelVolumeComponent'
        }
    },
    hasMany: {
        [PASchema.esWB_Model_Volume_Component_ItemR]: {
            foreignKey: 'WB_MODEL_VOLUME_COMPONENTR_ID',
            foreignKeyImmutable: true,
            localField: 'Items'
        }
    }
}

export const WB_Model_Volume_Component_ItemR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Volume_Component_ItemR', // optional
    description: 'Schema for WB_Model_Volume_Component_ItemR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_VOLUME_COMPONENT_ITEMR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_VOLUME_COMPONENTR_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        VALUE_TYPE: {
            type: 'string',
            length: 50
        },
        CONSTANT_VALUE: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID_SRC: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Volume_Component_ItemR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Volume_ComponentR]: {
            foreignKey: 'WB_MODEL_VOLUME_COMPONENTR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelVolumeComponentRel'
        }
    }
}

export const WB_Model_Event_Type_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Event_Type_Relationship', // optional
    description: 'Schema for WB_Model_Event_Type_Relationship records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_EVTTYPER_ID: {
            type: 'number',
            id: true,
            required: true

        },
        TYPE_NAME: {
            type: 'string',
            length: 256

        },
        METATYPE_ID: {
            type: 'string',
            length: 50

        },
        WB_MODEL_VOLUME_COMPONENT_ID: {
            type: 'number'

        },
        WB_MODEL_ID: {
            type: 'number'

        },
        MANUAL_IND: {
            type: 'string',
            default: '18000101',
            length: 8

        },
        CREATED_DTTS: {
            type: 'number'

        },
        MODIFIED_DTTS: {
            type: 'number'

        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8

        },
        DELETED_IND: {
            type: 'string',
            length: 1

        }
    }
})
export const WB_Model_Event_Type_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model]: {
            foreignKey: 'WB_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'Model'
        }
    }
}


// Model Profile Configuration
export const WB_Model_Profile = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Profile', // optional
    description: 'Schema for WB_Model_Profile records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_PROFILE_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_ID: {
            type: 'number'
        },
        PROFILE_TYPE: {
            type: 'string',
            length: 50
        },
        PROFILE_NAME: {
            type: 'string',
            length: 256
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        WB_MODEL_EVTTYPER_ID: {
            type: 'number'
        },
        DEFAULT_IND: {
            type: 'string',
            length: 1
        },
        VOLUME_TYPE: {
            type: 'string',
            length: 50
        },
        WB_MODEL_PROFILE_ID_PRM: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }

})
export const WB_Model_Profile_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model]: { foreignKey: 'WB_MODEL_ID', foreignKeyImmutable: true, localField: 'Model' },
        [PASchema.esWB_Model_Event_Type_Relationship]: {
            foreignKey: 'WB_MODEL_EVTTYPER_ID',
            localField: 'ModelEventType'
        }
    },
    hasMany: {
        [PASchema.esWB_Model_Profile_Predictor]: {
            foreignKey: 'WB_MODEL_PROFILE_ID',
            foreignKeyImmutable: true,
            localField: 'ModelProfilePredictors'
        },
        [PASchema.esWB_Model_Profile_Group]: {
            foreignKey: 'WB_MODEL_PROFILE_ID',
            foreignKeyImmutable: true,
            localField: 'ModelProfileGroups'
        },
        [PASchema.esWB_Model_Profile_Spend_Function]: {
            foreignKey: 'WB_MODEL_PROFILE_ID',
            foreignKeyImmutable: true,
            localField: 'ModelProfileSpendFunction'
        }
    }
}

export const WB_Model_Profile_Predictor = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Profile_Predictor', // optional
    description: 'Schema for WB_Model_Profile_Predictor records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_PROFILEPR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_PROFILE_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        INPUT_METHOD: {
            type: 'string',
            length: 50
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Profile_Predictor_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Profile]: {
            foreignKey: 'WB_MODEL_PROFILE_ID',
            foreignKeyImmutable: true,
            localField: 'ModelProfile'
        },
        [PASchema.esWB_Model_Predictor]: {
            foreignKey: 'WB_MODEL_PREDICTOR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        }
    },
    hasMany: {}
}

export const WB_Model_Profile_Group = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Profile_Group', // optional
    description: 'Schema for WB_Model_Profile_Group records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_PROFILEGR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_PROFILE_ID: {
            type: 'number'
        },
        GROUP_NAME: {
            type: 'string',
            length: 256
        },
        GROUP_SORT: {
            type: 'number'
        },
        WIDGET_TYPE: {
            type: 'string',
            length: 50
        },
        CUST_IND: {
            type: 'string',
            length: 1
        },
        PRD_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Profile_Group_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Profile]: {
            foreignKey: 'WB_MODEL_PROFILE_ID',
            foreignKeyImmutable: true,
            localField: 'ModelProfile'
        }
    },
    hasMany: {
        [PASchema.esWB_Model_Profile_Group_Predictor]: {
            foreignKey: 'WB_MODEL_PROFILEGR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelProfileGroupPredictors'
        }
    }
}

export const WB_Model_Profile_Group_Predictor = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Profile_Group_Predictor', // optional
    description: 'Schema for WB_Model_Profile_Group_Predictor records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_PROFILEGPR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_PROFILEGR_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        PREDICTOR_LABEL: {
            type: 'string',
            length: 256
        },
        SORT_ORDER: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Profile_Group_Predictor_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Profile_Group]: {
            foreignKey: 'WB_MODEL_PROFILEGR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelProfileGroup'
        },
        [PASchema.esWB_Model_Predictor]: {
            foreignKey: 'WB_MODEL_PREDICTOR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        }
    },
    hasMany: {}
}

export const WB_Model_Profile_Spend_Function = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Profile_Spend_Function', // optional
    description: 'Schema for WB_Model_Profile_Spend_Function records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_PROFILESFR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_PROFILE_ID: {
            type: 'number'
        },
        WB_SPEND_FUNCTION_ID: {
            type: 'number'
        },
        INCLUDE_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Profile_Spend_Function_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Profile]: {
            foreignKey: 'WB_MODEL_PROFILE_ID',
            foreignKeyImmutable: true,
            localField: 'ModelProfile'
        },
        [PASchema.esWB_Spend_Function]: {
            foreignKey: 'WB_SPEND_FUNCTION_ID',
            foreignKeyImmutable: true,
            localField: 'SpendFunction'
        }
    },
    hasMany: {}
}

//Model Data Source
export const WB_Model_DataSource = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_DataSource', // optional
    description: 'Schema for WB_Model_DataSource records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_DATASOURCE_ID: {
            type: 'number',
            id: true,
            required: true
        },
        DATASOURCE_ID: {
            type: 'string',
            length: 256
        },
        DATASOURCE_NAME: {
            type: 'string',
            length: 256
        },
        TARGET_TABLENAME: {
            type: 'string',
            length: 128
        },
        TARGET_FIELDNAME: {
            type: 'string',
            length: 128
        },
        CUSTOMER_FIELDNAME: {
            type: 'string',
            length: 128
        },
        ENTITY_ID_CUSTOMER: {
            type: 'string',
            length: 50
        },
        PRODUCT_FIELDNAME: {
            type: 'string',
            length: 128
        },
        ENTITY_ID_PRODUCT: {
            type: 'string',
            length: 50
        },
        PERIOD_METHOD: {
            type: 'string',
            length: 128
        },
        PERIOD_FIELDNAME: {
            type: 'string',
            length: 128
        },
        ENTITY_ID_PERIOD: {
            type: 'string',
            length: 50
        },
        EFFECTIVE_START_DT_FIELDNAME: {
            type: 'string',
            length: 128
        },
        EFFECTIVE_END_DT_FIELDNAME: {
            type: 'string',
            length: 128
        },
        PARTITION_ID_FIELDNAME: {
            type: 'string',
            length: 128
        },
        SOURCE_CUSTOMER_ID_FIELDNAME: {
            type: 'string',
            length: 128
        },
        SCALEFACTOR_FIELDNAME: {
            type: 'string',
            length: 128
        },
        PLOT_AXIS_NAME: {
            type: 'string',
            length: 256
        },
        PLOT_DATA_SHAPE: {
            type: 'string',
            length: 50
        },
        PLOT_DATA_SHAPE_PREDICT: {
            type: 'string',
            length: 50
        },
        PLOT_DATA_COLOR: {
            type: 'string',
            length: 50
        },
        PLOT_DATA_COLOR_PREDICT: {
            type: 'string',
            length: 50
        },
        PLOT_DATA_PATTERN: {
            type: 'string',
            length: 50
        },
        PLOT_DATA_PATTERN_PREDICT: {
            type: 'string',
            length: 50
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_DataSource_JSData_RELs = {
    hasMany: {},
    belongsTo: {
        [PASchema.esWB_Entity]: [
            { foreignKey: 'WB_ENTITY_ID_CUSTOMER', foreignKeyImmutable: true, localField: 'CustomerType' },
            { foreignKey: 'WB_ENTITY_ID_PRODUCT', foreignKeyImmutable: true, localField: 'ProductType' },
            { foreignKey: 'WB_ENTITY_ID_PERIOD', foreignKeyImmutable: true, localField: 'PeriodType' }
        ]
    }
}

// Model Coefficients
export const WB_Model_Coefficient = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Coefficient', // optional
    description: 'Schema for WB_Model_Coefficient records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_COEFFICIENT_ID: {
            type: 'number',
            id: true,
            required: true
        },
        MODEL_COEFFICIENT_ID: {
            type: 'string',
            length: 50
        },
        MODEL_COEFFICIENT_NAME: {
            type: 'string',
            length: 256
        },
        MODEL_COEFFICIENT_TYPE: {
            type: 'string',
            length: 256
        },
        NUMBER_TYPE: {
            type: 'string',
            length: 50
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        SORT_ORDER_UI: {
            type: 'number'
        },
        RENDER_OPTIONS: {
            type: 'string',
            length: 1333
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})

export const WB_Model_Coeff_Set = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Coeff_Set', // optional
    description: 'Schema for WB_Model_Coeff_Set records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_COEFF_SET_ID: {
            type: 'number',
            id: true,
            required: true
        },
        MODEL_COEFF_SET_ID: {
            type: 'string',
            length: 50
        },
        MODEL_COEFF_SET_NAME: {
            type: 'string',
            length: 256
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        SOURCE_ID: {
            type: 'string',
            length: 50
        },
        WB_MODEL_ID: {
            type: 'number'
        },
        WB_MDSET_ID: {
            type: 'number'
        },
        WB_SALESORG_ID: {
            type: 'number'
        },
        WB_ENTITY_ID_CUSTOMER: {
            type: 'number'
        },
        WB_ENTITY_ID_PRODUCT: {
            type: 'number'
        },
        WB_ENTITY_ID_PERIOD: {
            type: 'number'
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_MODELING_SESSION_TRIAL_ID: {
            type: 'number'
        },
        COEFFICIENT_SET_RANK: {
            type: 'number'
        },
        WB_PERIOD_ID_ANCHOR: {
            type: 'number'
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: 'number'
        },
        METRIC_REFRESH_DTTS: {
            type: 'number'
        },
        R2_TOTAL: {
            type: 'number'
        },
        MAPE_TOTAL: {
            type: 'number'
        },
        CUSTOMER_COUNT: {
            type: 'number'
        },
        PRODUCT_COUNT: {
            type: 'number'
        },
        AFFINITY_SET_COUNT: {
            type: 'number'
        },
        COEFFICIENT_COUNT: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Coeff_Set_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Model_Coeff_SetR]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSetR'
        },
        [PASchema.esWB_Model_Coeff_SetCR]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSetCR'
        },
        [PASchema.esWB_Model_Coeff_Set_Rule]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSetRules'
        },
        [PASchema.esWB_Model_Coeff_SetRR]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'RefValues'
        },
        [PASchema.esWB_Model_Coeff_SetTR]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSetTR'
        },
        [PASchema.esWB_Model_Coeff_SetConstR]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSetConstR'
        }
    },
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: 'WB_MDSET_ID',
            foreignKeyImmutable: true,
            localField: 'MasterDataSet'
        },
        [PASchema.esWB_SalesOrg]: { foreignKey: 'WB_SALESORG_ID', foreignKeyImmutable: true, localField: 'SalesOrg' },
        [PASchema.esWB_Entity]: [
            { foreignKey: 'WB_ENTITY_ID_CUSTOMER', foreignKeyImmutable: true, localField: 'CustomerType' },
            { foreignKey: 'WB_ENTITY_ID_PRODUCT', foreignKeyImmutable: true, localField: 'ProductType' },
            { foreignKey: 'WB_ENTITY_ID_PERIOD', foreignKeyImmutable: true, localField: 'PeriodType' }
        ],
        [PASchema.esWB_Model]: { foreignKey: 'WB_MODEL_ID', foreignKeyImmutable: true, localField: 'Model' },
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Modeling_Session_Trial]: {
            foreignKey: 'WB_MODELING_SESSION_TRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionTrial'
        }
    }
}

//Model Coefficient Set Constant Relationship
export const WB_Model_Coeff_SetConstR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Seasonality_DepMt', // optional
    description: 'Schema for WB_Modeling_Session_Seasonality_DepMt records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_COEFF_SETCONSTR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_COEFF_SET_ID: {
            type: 'number'
        },
        WB_MODEL_CONSTANT_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        WB_CUST_ID_AGGR: {
            type: 'number'
        },
        WB_PRDGRP_ID_AGGR: {
            type: 'number'
        },
        WB_PROD_ID_AGGR: {
            type: 'number'
        },
        WB_CUST_ID_VICT: {
            type: 'number'
        },
        WB_PRDGRP_ID_VICT: {
            type: 'number'
        },
        WB_PROD_ID_VICT: {
            type: 'number'
        },
        WB_AFFINITYSET_ID: {
            type: 'number'
        },
        INDEX: {
            type: 'number'
        },
        CONSTANT_VALUE: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Model_Coeff_SetConstR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Coeff_Set]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSet'
        },
        [PASchema.esWB_Model_Constant]: {
            foreignKey: 'WB_MODEL_CONSTANT_ID',
            foreignKeyImmutable: true,
            localField: 'ModelConstant'
        },
        [PASchema.esWB_Customer]: [
            {
                foreignKey: 'WB_CUST_ID',
                foreignKeyImmutable: true,
                localField: 'Customer'
            },
            {
                foreignKey: 'WB_CUST_ID_AGGR',
                foreignKeyImmutable: true,
                localField: 'CustomerAggr'
            },
            {
                foreignKey: 'WB_CUST_ID_VICT',
                foreignKeyImmutable: true,
                localField: 'CustomerVict'
            }
        ],
        [PASchema.esWB_Product_Group]: [
            {
                foreignKey: 'WB_PRDGRP_ID',
                foreignKeyImmutable: true,
                localField: 'ProductGroup'
            },
            {
                foreignKey: 'WB_PRDGRP_ID_AGGR',
                foreignKeyImmutable: true,
                localField: 'ProductGroupAggr'
            },
            {
                foreignKey: 'WB_PRDGRP_ID_VICT',
                foreignKeyImmutable: true,
                localField: 'ProductGroupVict'
            }
        ],
        [PASchema.esWB_Finished_Product]: [
            {
                foreignKey: 'WB_PROD_ID',
                foreignKeyImmutable: true,
                localField: 'Product'
            },
            {
                foreignKey: 'WB_PROD_ID_AGGR',
                foreignKeyImmutable: true,
                localField: 'ProductAggr'
            },
            {
                foreignKey: 'WB_PROD_ID_VICT',
                foreignKeyImmutable: true,
                localField: 'ProductVict'
            }
        ],
        [PASchema.esWB_AffinitySet]: {
            foreignKey: 'WB_AFFINITYSET_ID',
            foreignKeyImmutable: true,
            localField: 'AffinitySet'
        }
    },
    hasMany: {}
}

export const WB_Model_Coeff_SetR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Coeff_SetR', // optional
    description: 'Schema for WB_Model_Coeff_SetR', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_COEFF_SETR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_COEFF_SET_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Model_Coeff_SetR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Coeff_Set]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSet'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    }
}

export const WB_Model_Coeff_SetCR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Coeff_SetCR', // optional
    description: 'Schema for WB_Model_Coeff_SetCR', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_COEFF_SETCR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_COEFF_SET_ID: {
            type: 'number'
        },
        WB_MODEL_CANNIBALIZATIONM_ID: {
            type: 'number'
        },
        WB_AFFINITYGROUP_ID_AGGR: {
            type: 'number'
        },
        WB_AFFINITYGROUP_ID_VCTM: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Model_Coeff_SetCR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Coeff_Set]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSet'
        },
        [PASchema.esWB_Model_Cannibalization_Type]: {
            foreignKey: 'WB_MODEL_CANNIBALIZATIONM_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCannibalizationType'
        },
        [PASchema.esWB_AffinityGroup]: [
            {
                foreignKey: 'WB_PRDGRP_ID_AGGR',
                foreignKeyImmutable: true,
                localField: 'AggressorGroup'
            },
            { foreignKey: 'WB_PRDGRP_ID_VCTM', foreignKeyImmutable: true, localField: 'VictimGroup' }
        ]
    }
}

export const WB_Model_Coeff_Set_Rule = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Coeff_Set_Rule', // optional
    description: 'Schema for WB_Model_Coeff_Set_Rule records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_COEFF_SET_RULE_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_COEFF_SET_ID: {
            type: 'number'
        },
        COEFF_FIELDNAME: {
            type: 'string',
            length: 128
        },
        COEFF_RULE_TYPE: {
            type: 'string',
            length: 50
        },
        WB_PRDH_ID: {
            type: 'number'
        },
        PRODUCT_LEVEL: {
            type: 'string',
            length: 50
        },
        WB_PERIODH_ID: {
            type: 'number'
        },
        WB_PERIODM_ID: {
            type: 'number'
        },
        COEFFICIENT_VALUE: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Coeff_Set_Rule_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Coeff_Set]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSet'
        }
    }
}

export const WB_Model_Coeff_SetASR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Coeff_SetASR', // optional
    description: 'Schema for WB_Model_Coeff_SetASR', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_COEFF_SETASR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_COEFF_SET_ID: {
            type: 'number',
            required: true
        },
        WB_AFFINITYSET_ID: {
            type: 'number'
        },
        STOCKPILING_PERIODS: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Coeff_SetASR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Coeff_Set]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSet'
        },
        [PASchema.esWB_AffinitySet]: {
            foreignKey: 'WB_AFFINITYSET_ID',
            foreignKeyImmutable: true,
            localField: 'AffinitySet'
        }
    }
}

export const WB_Model_Coeff_SetPMR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Coeff_SetPMR', // optional
    description: 'Schema for WB_Model_Coeff_SetPMR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_COEFF_SETPMR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_COEFF_SET_ID: {
            type: 'number',
            required: true
        },
        WB_MODEL_CANNIBALIZATIONM_ID: {
            type: 'number',
            required: true
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        WEIGHT: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Coeff_SetPMR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Coeff_Set]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSet'
        },
        [PASchema.esWB_Model_Cannibalization_Type]: {
            foreignKey: 'WB_MODEL_CANNIBALIZATIONM_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCannibalizationType'
        }
    }
}

export const WB_Model_Coeff_SetRR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Coeff_SetRR', // optional
    description: 'Schema for WB_Model_Coeff_SetRR', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_COEFF_SETRR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_COEFF_SET_ID: {
            type: 'number',
            required: true
        },
        WB_CUST_ID: {
            type: 'number',
            required: true
        },
        WB_PROD_ID: {
            type: 'number',
            required: true
        },
        WB_PRDGRP_ID: {
            type: 'number',
            required: true
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        REF_VALUE: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Coeff_SetRR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Coeff_Set]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSet'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        },
        [PASchema.esWB_Model_Predictor]: {
            foreignKey: 'WB_MODEL_PREDICTOR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        }
    }
}

export const WB_Model_Coeff_SetTR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Coeff_SetTR', // optional
    description: 'Schema for WB_Model_Coeff_SetTR', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_COEFF_SETTR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_COEFF_SET_ID: {
            type: 'number'
        },
        WB_MODEL_TERM_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        NEUTRALIZED_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Model_Coeff_SetTR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Coeff_Set]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSet'
        },
        [PASchema.esWB_Model_Term]: {
            foreignKey: 'WB_MODEL_TERM_ID',
            foreignKeyImmutable: true,
            localField: 'ModelTerm'
        },
        [PASchema.esWB_Customer]: {
            foreignKey: 'WB_CUST_ID',
            foreignKeyImmutable: true,
            localField: 'Customer'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    }
}

// Modeling Session
export const WB_Modeling_Session = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session', // optional
    description: 'Schema for WB_Modeling_Session records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_ID: {
            type: 'number',
            id: true,
            required: true
        },
        MODELING_SESSION_ID: {
            type: 'string',
            length: 50
        },
        MODELING_SESSION_NAME: {
            type: 'string',
            length: 256
        },
        WB_MODEL_ID: {
            type: 'number'
        },
        WB_MDSET_ID: {
            type: 'number'
        },
        WB_SALESORG_ID: {
            type: 'number'
        },
        WB_ENTITY_ID_CUSTOMER: {
            type: 'number'
        },
        WB_ENTITY_ID_PRODUCT: {
            type: 'number'
        },
        WB_ENTITY_ID_PERIOD: {
            type: 'number'
        },
        WB_CUSTH_ID: {
            type: 'number'
        },
        WB_PRDH_ID: {
            type: 'number'
        },
        WB_PERIODH_ID: {
            type: 'number'
        },
        START_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        END_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        HOLDOUT_START_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        HOLDOUT_END_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        ELASTICITY_START_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        ELASTICITY_END_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        ELASTICITY_EVAL_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        ELASTICITY_NUM_STEPS: {
            type: 'number'
        },
        ELASTICITY_NEIGHBORHOOD_PCT: {
            type: 'number'
        },
        OBJECTIVE_FCN_ID: {
            type: 'string',
            length: 50
        },
        WB_AUTOMATION_FLOW_ID: {
            type: 'number'
        },
        DIAGNOSTIC_PERSPECTIVE: {
            type: 'string',
            length: 50
        },
        DIAGNOSTIC_FILTER_MODE: {
            type: 'string',
            length: 50
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        WB_MODEL_CANNIBALIZATIONM_ID_DIAGNOSTIC: {
            type: 'number'
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        FILTER_OPTIONS: {
            'type': 'string',
            'length': 1333
        }
    }
})
export const WB_Modeling_Session_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model]: { foreignKey: 'WB_MODEL_ID', foreignKeyImmutable: true, localField: 'Model' },
        [PASchema.esWB_User]: {
            foreignKey: 'WB_AUTHUSR_ID_CREATEDBY',
            foreignKeyImmutable: true,
            localField: 'Creator'
        },
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: 'WB_MDSET_ID',
            foreignKeyImmutable: true,
            localField: 'MasterDataSet'
        },
        [PASchema.esWB_SalesOrg]: { foreignKey: 'WB_SALESORG_ID', foreignKeyImmutable: true, localField: 'SalesOrg' },
        [PASchema.esWB_Entity]: [
            { foreignKey: 'WB_ENTITY_ID_CUSTOMER', foreignKeyImmutable: true, localField: 'CustomerType' },
            { foreignKey: 'WB_ENTITY_ID_PRODUCT', foreignKeyImmutable: true, localField: 'ProductType' },
            { foreignKey: 'WB_ENTITY_ID_PERIOD', foreignKeyImmutable: true, localField: 'PeriodType' }
        ],
        [PASchema.esWB_Customer_Hierarchy]: {
            foreignKey: 'WB_CUSTH_ID',
            foreignKeyImmutable: true,
            localField: 'CustomerHierarchy'
        },
        [PASchema.esWB_Product_Hierarchy]: {
            foreignKey: 'WB_PRDH_ID',
            foreignKeyImmutable: true,
            localField: 'ProductHierarchy'
        },
        [PASchema.esWB_Period_Hierarchy]: {
            foreignKey: 'WB_PERIODH_ID',
            foreignKeyImmutable: true,
            localField: 'PeriodHierarchy'
        },
        [PASchema.esWB_Automation_Flow]: {
            foreignKey: 'WB_AUTOMATION_FLOW_ID',
            foreignKeyImmutable: true,
            localField: 'AutomationFlow'
        }
    },
    hasMany: {
        [PASchema.esWB_Modeling_Session_CustR]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'Customers'
        },
        [PASchema.esWB_Modeling_Session_ProdR]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'Products'
        },
        [PASchema.esWB_Modeling_Session_Trial]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'Trials'
        },
        [PASchema.esWB_Modeling_Session_Range]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'Ranges'
        },
        [PASchema.esWB_Modeling_Session_Log]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionLogs'
        },
        [PASchema.esWB_Modeling_Session_Tag_RuleR]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionTagRuleR'
        },
        [PASchema.esWB_Modeling_Session_Coeff_Rule]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCoeffRule'
        },
        [PASchema.esWB_Modeling_Session_Observation]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionObservations'
        },
        [PASchema.esWB_Modeling_Session_Reference_Predictor_Relationship]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionRefPredRel'
        },
        [PASchema.esWB_Modeling_Session_Cannibalization_Type_Relationship]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCannTypeRel'
        },
        [PASchema.esWB_Modeling_Session_Reference_Relationship]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionRefRel'
        },
        [PASchema.esWB_Modeling_Session_El]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionEls'
        },
        [PASchema.esWB_Modeling_Session_ElR]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionElRs'
        },
        [PASchema.esWB_Modeling_Session_ElCR]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionElCRs'
        },
        [PASchema.esWB_Modeling_Session_TermR]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionTermRs'
        },
        [PASchema.esWB_Modeling_SessionPR]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionPRs'
        },
        [PASchema.esWB_Modeling_Session_Coeff_Grp]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCoeffGrps'
        },
        [PASchema.esWB_Modeling_Session_ConstantR]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionConstantRs'
        },
        [PASchema.esWB_Modeling_Session_ConstantFR]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionConstantFRs'
        },
        [PASchema.esWB_Modeling_Session_Stage]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionStages'
        }
    }
}

// Modeling Session Stage
export const WB_Modeling_Session_Stage = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Stage', // optional
    description: 'Schema for WB_Modeling_Session_Stage records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_STAGE_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_MODELING_SESSION_STAGECRP_ID: {
            type: 'number'
        },
        STEP_NUMBER: {
            type: 'number'
        },
        CORE_TERMS_SOLVE_IND: {
            type: 'string',
            length: 1
        },
        WB_MODEL_CANNIBALIZATIONM_IDS: {
            type: 'string'
        },
        INTELLIGENT_INTERCEPT_IND: {
            type: 'string',
            length: 1
        },
        CALCULATE_CONSTANTS_IND: {
            type: 'string',
            length: 1
        },
        INTERCEPT_MAX_CONSTRAINT_PCT: {
            type: 'number'
        },
        INTERCEPT_CALC_ACCURACY_PCT: {
            type: 'number'
        },
        INTERCEPT_THRESHOLD_BASE_PCT: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_Stage_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Modeling_Session_StageCoeffRangePolicy]: {
            foreignKey: 'WB_MODELING_SESSION_STAGECRP_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCoeffRangePolicy'
        }
    },
    hasMany: {
        [PASchema.esWB_Modeling_Session_StageAlgorithm]: {
            foreignKey: 'WB_MODELING_SESSION_STAGE_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionStageAlgorithms'
        }
    }
}

// Modeling Session Stage Coefficient Range Policy
export const WB_Modeling_Session_StageCRP = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_StageCRP', // optional
    description: 'Schema for WB_Modeling_Session_StageCRP records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_STAGECRP_ID: {
            type: 'number',
            id: true,
            required: true
        },
        STAGE_POLICY_ID: {
            type: 'string',
            length: 50
        },
        WB_MODELING_SESSION_STAGECRP_META_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_StageCRP_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_StageCoeffRangePolicyMeta]: {
            foreignKey: 'WB_MODELING_SESSION_STAGECRP_META_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCoeffRangePolicyType'
        },
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        }
    },
    hasMany: {
        [PASchema.esWB_Modeling_Session_StageCoeffRangePolicyR]: {
            foreignKey: 'WB_MODELING_SESSION_STAGECRP_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCoeffRangePolicyRs'
        }
    }
}

// Modeling Session Stage Coefficient Range Policy Type
export const WB_Modeling_Session_StageCRP_Meta = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_StageCRP_Meta', // optional
    description: 'Schema for WB_Modeling_Session_StageCRP_Meta records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_STAGECRP_META_ID: {
            type: 'number',
            id: true,
            required: true
        },
        POLICY_ID: {
            type: 'string',
            length: 50
        },
        POLICY_NAME: {
            type: 'string',
            length: 256
        },
        SHOW_MODEL_TERM_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_StageCRP_Meta_JSData_RELs = {
    belongsTo: {},
    hasMany: {}
}

// Modeling Session Stage Coefficient Range Policy
export const WB_Modeling_Session_StageCRPR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_StageCRPR', // optional
    description: 'Schema for WB_Modeling_Session_StageCRPR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_STAGECRPR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_STAGECRP_ID: {
            type: 'number'
        },
        WB_MODEL_TERM_ID: {
            type: 'number'
        },
        WB_MODEL_CANNIBALIZATIONM_ID: {
            type: 'number'
        },
        SCALE_FACTOR: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_StageCRPR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_StageCoeffRangePolicy]: {
            foreignKey: 'WB_MODELING_SESSION_STAGECRP_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCoeffRangePolicy'
        },
        [PASchema.esWB_Model_Term]: {
            foreignKey: 'WB_MODEL_TERM_ID',
            foreignKeyImmutable: true,
            localField: 'ModelTerm'
        },
        [PASchema.esWB_Model_Cannibalization_Type]: {
            foreignKey: 'WB_MODEL_CANNIBALIZATIONM_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCannibalizationType'
        }
    },
    hasMany: {}
}

// Modeling Session Stage Algorithm
export const WB_Modeling_Session_StageAR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_StageAR', // optional
    description: 'Schema for WB_Modeling_Session_StageAR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_STAGEAR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_STAGE_ID: {
            type: 'number'
        },
        ALGORITHM_ID: {
            type: 'string',
            length: 100
        },
        CNVG_SSE_IND: {
            type: 'string',
            length: 1
        },
        CNVG_SSE_PCNT: {
            type: 'number'
        },
        CNVG_SSE_NOI: {
            type: 'number'
        },
        CNVG_R2_IND: {
            type: 'string',
            length: 1
        },
        CNVG_R2_PCNT: {
            type: 'number'
        },
        STOP_TRIAL_HRS_IND: {
            type: 'string',
            length: 1
        },
        STOP_TRIAL_HRS: {
            type: 'number'
        },
        STOP_SUBTRIAL_HRS_IND: {
            type: 'string',
            length: 1
        },
        STOP_SUBTRIAL_HRS: {
            type: 'number'
        },
        STOP_TRIAL_NOI_IND: {
            type: 'string',
            length: 1
        },
        STOP_TRIAL_NOI: {
            type: 'number'
        },
        STOP_SUBTRIAL_NOI_IND: {
            type: 'string',
            length: 1
        },
        STOP_SUBTRIAL_NOI: {
            type: 'number'
        },
        CNVG_R2_CANNREF_IND: {
            type: 'string',
            length: 1
        },
        CNVG_R2_CANNREF_PCNT: {
            type: 'number'
        },
        CNVG_R2_CANNREF_NOI: {
            type: 'number'
        },
        STOP_SUBTRIAL_CANN_NOI_IND: {
            type: 'string',
            length: 1
        },
        STOP_SUBTRIAL_CANN_NOI: {
            type: 'number'
        },
        CRITICAL_VALUE_INTERVAL_PCNT: {
            type: 'number'
        },
        WORKER_COUNT: {
            type: 'number'
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_StageAR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_Stage]: {
            foreignKey: 'WB_MODELING_SESSION_STAGE_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionStage'
        }
    },
    hasMany: {}
}

// Modeling Session Coefficient Rule
export const WB_Modeling_Session_Coeff_Rule = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Coeff_Rule', // optional
    description: 'Schema for WB_Modeling_Session_Coeff_Rule records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_COEFF_RULE_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        RULE_ID: {
            type: 'string',
            length: 50
        },
        RULE_NAME: {
            type: 'string',
            length: 256
        },
        RULE_TYPE: {
            type: 'string',
            length: 50
        },
        WB_MODEL_COEFFICIENT_ID: {
            type: 'number'
        },
        CUSTOMER_DIM_IND: {
            type: 'string',
            length: 1
        },
        PRODUCT_DIM_IND: {
            type: 'string',
            length: 1
        },
        CUSTOMER_LEVEL: {
            type: 'string',
            length: 50
        },
        PRODUCT_LEVEL: {
            type: 'string',
            length: 50
        },
        FIXED_VALUE: {
            type: 'number',
            default: ''
        },
        FIXED_VALUE_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_Coeff_Rule_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Model_Coefficient]: {
            foreignKey: 'WB_MODEL_COEFFICIENT_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoefficient'
        }
    },
    hasMany: {
        [PASchema.esWB_Modeling_Session_Coeff_RuleR]: {
            foreignKey: 'WB_MODELING_SESSION_COEFF_RULE_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCoeffRuleRs'
        }
    }
}

// Modeling Session Coefficient Rule
export const WB_Modeling_Session_Coeff_RuleR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Coeff_Rule', // optional
    description: 'Schema for WB_Modeling_Session_Coeff_Rule records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_COEFF_RULER_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_COEFF_RULE_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        FIXED_VALUE: {
            type: 'number',
            default: ''
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_Coeff_RuleR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_Coeff_Rule]: {
            foreignKey: 'WB_MODELING_SESSION_COEFF_RULE_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCoeffRule'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    },
    hasMany: {}
}

// Modeling Session Coefficient Group
export const WB_Modeling_Session_Coeff_Grp = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Coeff_Grp', // optional
    description: 'Schema for WB_Modeling_Session_Coeff_Grp records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_COEFF_GRP_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        GROUP_NAME: {
            type: 'string',
            length: 256
        },
        GROUP_TYPE: {
            type: 'string',
            length: 50
        },
        GROUP_META_ID: {
            type: 'string',
            length: 50
        },
        WB_MODEL_COEFFICIENT_ID: {
            type: 'number'
        },
        WB_MODEL_CONSTANT_ID: {
            type: 'number'
        },
        CUSTOMER_LEVEL: {
            type: 'string',
            length: 50
        },
        PRODUCT_LEVEL: {
            type: 'string',
            length: 50
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_Coeff_Grp_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Model_Coefficient]: {
            foreignKey: 'WB_MODEL_COEFFICIENT_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoefficient'
        },
        [PASchema.esWB_Model_Constant]: {
            foreignKey: 'WB_MODEL_CONSTANT_ID',
            foreignKeyImmutable: true,
            localField: 'ModelConstant'
        }
    },
    hasMany: {
        [PASchema.esWB_Modeling_Session_Coeff_GrpSt]: {
            foreignKey: 'WB_MODELING_SESSION_COEFF_GRP_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCoeffGrpSts'
        }
    }
}

// Modeling Session Coefficient Group Set
export const WB_Modeling_Session_Coeff_GrpSt = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Coeff_GrpSt', // optional
    description: 'Schema for WB_Modeling_Session_Coeff_GrpSt records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_COEFF_GRPST_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_COEFF_GRP_ID: {
            type: 'number'
        },
        CUSTOMER_NAME: {
            type: 'string',
            length: 256
        },
        PRODUCT_NAME: {
            type: 'string',
            length: 256
        },
        FIXED_IND: {
            type: 'string',
            length: 1
        },
        MIN_IND: {
            type: 'string',
            length: 1
        },
        MAX_IND: {
            type: 'string',
            length: 1
        },
        COEFFICIENT_FIXED_VALUE: {
            type: 'number'
        },
        COEFFICIENT_MIN_VALUE: {
            type: 'number'
        },
        COEFFICIENT_MAX_VALUE: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_Coeff_GrpSt_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_Coeff_Grp]: {
            foreignKey: 'WB_MODELING_SESSION_COEFF_GRP_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCoeffGrp'
        }
    },
    hasMany: {
        [PASchema.esWB_Modeling_Session_Coeff_GrpStR]: {
            foreignKey: 'WB_MODELING_SESSION_COEFF_GRPST_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCoeffGrpStRs'
        }
    }
}

// Modeling Session Coefficient Group SetR
export const WB_Modeling_Session_Coeff_GrpStR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Coeff_GrpStR', // optional
    description: 'Schema for WB_Modeling_Session_Coeff_GrpStR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_COEFF_GRPSTR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_COEFF_GRPST_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_Coeff_GrpStR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_Coeff_GrpSt]: {
            foreignKey: 'WB_MODELING_SESSION_COEFF_GRPST_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCoeffGrpSt'
        },
        [PASchema.esWB_Customer]: {
            foreignKey: 'WB_CUST_ID',
            foreignKeyImmutable: true,
            localField: 'Customer'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    },
    hasMany: {}
}

export const WB_Modeling_Session_CustR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_CustR', // optional
    description: 'Schema for WB_Modeling_Session_CustR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_CUSTR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_CustR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' }
    }
}

export const WB_Modeling_Session_ProdR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_ProdR', // optional
    description: 'Schema for WB_Modeling_Session_ProdR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_PRODR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        REL_TYPE: {
            type: 'string',
            length: 20
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_ProdR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    }
}

export const WB_Modeling_Session_Range = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Range', // optional
    description: 'Schema for WB_Modeling_Session_Range records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_RANGE_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_MODEL_COEFFICIENT_ID: {
            type: 'number'
        },
        COEFFICIENT_MIN_VALUE: {
            type: 'number'
        },
        COEFFICIENT_MAX_VALUE: {
            type: 'number'
        },
        COEFFICIENT_STEPS: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_Range_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Model_Coefficient]: {
            foreignKey: 'WB_MODEL_COEFFICIENT_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoefficient'
        }
    }
}

export const WB_Modeling_Session_Trial = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Trial', // optional
    description: 'Schema for WB_Modeling_Session_Trial records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_TRIAL_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        TRIAL_ID: {
            type: 'string',
            length: 50
        },
        TRIAL_NOTES: {
            type: 'string',
            length: 256
        },
        WB_MODEL_COEFF_SET_ID: {
            type: 'number'
        },
        CALC_START_DTTS: {
            type: 'number'
        },
        CALC_END_DTTS: {
            type: 'number'
        },
        CALC_ERROR_IND: {
            type: 'string',
            length: 1
        },
        CALC_ERROR_DTTS: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_Trial_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Model_Coeff_Set]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSet'
        }
    },
    hasMany: {
        [PASchema.esWB_Modeling_Session_Trial_Metric]: {
            foreignKey: 'WB_MODELING_SESSION_TRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'Metrics'
        },
        [PASchema.esWB_Modeling_Session_Trial_Residual_Metric]: {
            foreignKey: 'WB_MODELING_SESSION_TRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'RsdMetrics'
        },
        [PASchema.esWB_Modeling_Session_Trial_Predictor_Metric]: {
            foreignKey: 'WB_MODELING_SESSION_TRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'PredMetrics'
        },
        [PASchema.esWB_Modeling_Session_Trial_PredictorR_Metric]: {
            foreignKey: 'WB_MODELING_SESSION_TRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'PredRMetrics'
        },
        [PASchema.esWB_Modeling_Session_Log]: {
            foreignKey: 'WB_MODELING_SESSION_TRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'Logs'
        }
    }
}

export const WB_Modeling_Session_Trial_Metric = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Trial_Metric', // optional
    description: 'Schema for WB_Modeling_Session_TrialMt records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_TRIALMT_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_TRIAL_ID: {
            type: 'number'
        },
        DATASET_ID: {
            type: 'string',
            length: 50
        },
        SUMMARY_ID: {
            type: 'string',
            length: 50
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PERIOD_ID: {
            type: 'number'
        },
        SSE_RESIDUAL_TOTAL: {
            type: 'number'
        },
        SSE_RESIDUAL_BASE: {
            type: 'number'
        },
        SSE_RESIDUAL_PROMOTED: {
            type: 'number'
        },
        SSE_MEAN_TOTAL: {
            type: 'number'
        },
        SSE_MEAN_BASE: {
            type: 'number'
        },
        SSE_MEAN_PROMOTED: {
            type: 'number'
        },
        R2_TOTAL: {
            type: 'number'
        },
        R2_BASE: {
            type: 'number'
        },
        R2_PROMOTED: {
            type: 'number'
        },
        R2_SSE_TOTAL: {
            type: 'number'
        },
        R2_SSE_BASE: {
            type: 'number'
        },
        R2_SSE_PROMOTED: {
            type: 'number'
        },
        MAPE_TOTAL: {
            type: 'number'
        },
        MAPE_BASE: {
            type: 'number'
        },
        MAPE_PROMOTED: {
            type: 'number'
        },
        MAPE_SSE_TOTAL: {
            type: 'number'
        },
        MAPE_SSE_BASE: {
            type: 'number'
        },
        MAPE_SSE_PROMOTED: {
            type: 'number'
        },
        MAPE_WEIGHTED_TOTAL: {
            type: 'number'
        },
        MAPE_WEIGHTED_BASE: {
            type: 'number'
        },
        MAPE_WEIGHTED_PROMOTED: {
            type: 'number'
        },
        RESIDUAL_MEAN: {
            type: 'number'
        },
        RESIDUAL_STD_DEV: {
            type: 'number'
        },
        OBSERVATION_COUNT: {
            type: 'number'
        },
        OBSERVATION_BASE_COUNT: {
            type: 'number'
        },
        INDEPEDENT_COEFF_COUNT: {
            type: 'number'
        },
        PREDICTED_UNITS: {
            type: 'number'
        },
        PREDICTED_UNITS_CORE: {
            type: 'number'
        },
        PREDICTED_RTLSLS: {
            type: 'number'
        },
        PREDICTED_RTLSLS_CORE: {
            type: 'number'
        },
        PREDICTED_BASE_UNITS: {
            type: 'number'
        },
        PREDICTED_BASE_RTLSLS: {
            type: 'number'
        },
        TOTAL_OBSERVATION_UNITS: {
            type: 'number'
        },
        TOTAL_OBSERVATION_RTLSLS: {
            type: 'number'
        },
        CRITICAL_VALUE: {
            type: 'number'
        },
        OUTLIER_IND: {
            type: 'string',
            length: 1
        },
        TARGET_OBSERVATION_UNITS: {
            type: 'number'
        },
        TARGET_OBSERVATION_RTLSLS: {
            type: 'number'
        },
        CRITICAL_VALUE_WILCOXON: {
            type: 'number'
        },
        TSTATISTIC_WILCOXON: {
            type: 'number'
        },
        PVALUE_WILCOXON: {
            type: 'number'
        },
        PASS_IND_WILCOXON: {
            type: 'string',
            length: 1
        },
        CRITICAL_VALUE_TTEST: {
            type: 'number'
        },
        TSTATISTIC_TTEST: {
            type: 'number'
        },
        PVALUE_TTEST: {
            type: 'number'
        },
        PASS_IND_TTEST: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        }
    }
})
export const WB_Modeling_Session_Trial_Metric_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_Trial]: {
            foreignKey: 'WB_MODELING_SESSION_TRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionTrial'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Period]: { foreignKey: 'WB_PERIOD_ID', foreignKeyImmutable: true, localField: 'Period' }
    }
}

export const WB_Modeling_Session_Trial_Rsd_Metric = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_TrialRsdMt', // optional
    description: 'Schema for WB_Modeling_Session_TrialRsdMt records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_TRIALRSDMT_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_TRIAL_ID: {
            type: 'number',
            required: true
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number',
            required: true
        },
        SUMMARY_ID: {
            type: 'string',
            required: true,
            length: 50
        },
        WB_CUST_ID: {
            type: 'number',
            required: true
        },
        WB_PRDGRP_ID: {
            type: 'number',
            required: true
        },
        WB_PERIOD_ID: {
            type: 'number',
            required: true
        },
        PREDICTOR_VALUE: {
            type: 'number'
        },
        PREDICTOR_VALUEGROUPSIZE: {
            type: 'number'
        },
        OBSERVATION_COUNT: {
            type: 'number'
        },
        RESIDUAL_MEAN: {
            type: 'number'
        },
        RESIDUAL_STDDEV: {
            type: 'number'
        },
        RESIDUAL_MIN: {
            type: 'number'
        },
        RESIDUAL_MAX: {
            type: 'number'
        },
        ACTUAL_MEAN: {
            type: 'number'
        },
        PREDICTION_MEAN: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        }
    }
})
export const WB_Modeling_Session_Trial_Rsd_Metric_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_Trial]: {
            foreignKey: 'WB_MODELING_SESSION_TRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionTrial'
        },
        [PASchema.esWB_Model_Predictor]: {
            foreignKey: 'WB_MODEL_PREDICTOR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Period]: { foreignKey: 'WB_PERIOD_ID', foreignKeyImmutable: true, localField: 'Period' }
    }
}

export const WB_Modeling_Session_Trial_Pred_Metric = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_TrialPMt', // optional
    description: 'Schema for WB_Modeling_Session_TrialPMt records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_TRIAL_PMT_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_TRIAL_ID: {
            type: 'number'
        },
        DATASET_ID: {
            type: 'string',
            length: 50
        },
        SUMMARY_ID: {
            type: 'string',
            length: 50
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PERIOD_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        CRITICAL_VALUE_SKEWTEST: {
            type: 'number'
        },
        TSTATISTIC_SKEWTEST: {
            type: 'number'
        },
        PVALUE_SKEWTEST: {
            type: 'number'
        },
        PASS_IND_SKEWTEST: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        }
    }
})
export const WB_Modeling_Session_Trial_Pred_Metric_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_Trial]: {
            foreignKey: 'WB_MODELING_SESSION_TRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionTrial'
        },
        [PASchema.esWB_Model_Predictor]: {
            foreignKey: 'WB_MODEL_PREDICTOR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Period]: { foreignKey: 'WB_PERIOD_ID', foreignKeyImmutable: true, localField: 'Period' }
    }
}

export const WB_Modeling_Session_Trial_PredR_Metric = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_TrialPRMt', // optional
    description: 'Schema for WB_Modeling_Session_TrialPRMt records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_TRIAL_PRMT_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_TRIAL_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        SUMMARY_ID: {
            type: 'string',
            length: 50
        },
        WB_MODEL_PREDICTOR_ID_A: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID_B: {
            type: 'number'
        },
        DATASET_ID: {
            type: 'string',
            length: 50
        },
        COLLINEARITY_VALUE: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        }
    }
})
export const WB_Modeling_Session_Trial_PredR_Metric_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_Trial]: {
            foreignKey: 'WB_MODELING_SESSION_TRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionTrial'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Model_Predictor]: [
            {
                foreignKey: 'WB_MODEL_PREDICTOR_ID_A',
                foreignKeyImmutable: true,
                localField: 'ModelPredictorA'
            },
            {
                foreignKey: 'WB_MODEL_PREDICTOR_ID_B',
                foreignKeyImmutable: true,
                localField: 'ModelPredictorB'
            }
        ]
    }
}

export const WB_Modeling_Session_TrialPartitionStage = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_TrialPS', // optional
    description: 'Schema for WB_Modeling_Session_TrialPS records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_TRIALPS_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_TRIAL_ID: {
            type: 'number'
        },
        STAGE_NUM: {
            type: 'number'
        },
        PARTITION_ID: {
            type: 'string',
            length: 50
        },
        ALGORITHM_ID: {
            type: 'string',
            length: 50
        },
        ITERATION_CNT: {
            type: 'number'
        },
        STATUS_ID: {
            type: 'string',
            length: 50
        },
        START_DTTS: {
            type: 'number'
        },
        END_DTTS: {
            type: 'number'
        }
    }
})
export const WB_Modeling_Session_TrialPartitionStage_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_Trial]: {
            foreignKey: 'WB_MODELING_SESSION_TRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionTrial'
        }
    },
    hasMany: {
        [PASchema.esWB_Modeling_Session_Trial_PartitionStageS]: {
            foreignKey: 'WB_MODELING_SESSION_TRIALPS_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionTrialPSSs'
        }
    }
}

export const WB_Modeling_Session_TrialPartitionStageS = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_TrialPSS', // optional
    description: 'Schema for WB_Modeling_Session_TrialPSS records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_TRIALPSS_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_TRIALPS_ID: {
            type: 'number'
        },
        PARTITION_ID: {
            type: 'string',
            length: 50
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        }
    }
})
export const WB_Modeling_Session_TrialPartitionStageS_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_Trial_PartitionStage]: {
            foreignKey: 'WB_MODELING_SESSION_TRIALPS_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionTrialPS'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Customer]: {
            foreignKey: 'WB_CUST_ID',
            foreignKeyImmutable: true,
            localField: 'Customer'
        }
    },
    hasMany: {
        [PASchema.esWB_Modeling_Session_Trial_PartitionStageSL]: {
            foreignKey: 'WB_MODELING_SESSION_TRIALPSS_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionTrialPSSLs'
        }
    }
}

export const WB_Modeling_Session_TrialPartitionStageSL = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_TrialPSSL', // optional
    description: 'Schema for WB_Modeling_Session_TrialPSSL records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_TRIALPSSL_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_TRIALPSS_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        ITERATION_CNT: {
            type: 'number'
        },
        TRIAL_ITERATION_CNT: {
            type: 'number'
        },
        OBJECTIVE_FCN_VALUE: {
            type: 'number'
        },
        SSE: {
            type: 'number'
        },
        MAPE: {
            type: 'number'
        }
    }
})
export const WB_Modeling_Session_TrialPartitionStageSL_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_Trial_PartitionStageS]: {
            foreignKey: 'WB_MODELING_SESSION_TRIALPSS_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionTrialPartitionSS'
        }
    }
}

export const WB_Modeling_Session_Log = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Log', // optional
    description: 'Schema for WB_Modeling_Session_Log records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_LOG_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_MODELING_SESSION_TRIAL_ID: {
            type: 'number'
        },
        LOG_DTTS: {
            type: 'number'
        },
        LOG_SORT: {
            type: 'number'
        },
        LOG_MESSAGE_CD: {
            type: 'string',
            length: 50
        },
        LOG_MESSAGE: {
            type: 'string',
            length: 256
        },
        CREATED_DTTS: {
            type: 'number'
        }
    }
})
export const WB_Modeling_Session_log_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_Trial]: {
            foreignKey: 'WB_MODELING_SESSION_TRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionTrial'
        },
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        }
    }
}

export const WB_Modeling_Session_Observation = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Observation', // optional
    description: 'Schema for WB_Modeling_Session_Observation records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_OBS_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        WB_PERIOD_ID: {
            type: 'number'
        },
        WB_TAG_ID: {
            type: 'number'
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        EXCLUDE_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Modeling_Session_Observation_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Period]: { foreignKey: 'WB_PERIOD_ID', foreignKeyImmutable: true, localField: 'Period' },
        [PASchema.esWB_Tag]: { foreignKey: 'WB_TAG_ID', foreignKeyImmutable: true, localField: 'Tag' },
        [PASchema.esWB_Model_Predictor]: {
            foreignKey: 'WB_MODEL_PREDICTOR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    }
}

export const WB_Modeling_Session_Tag_RuleR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session Tag RuleR', // optional
    description: 'Schema for WB_Modeling_Session Tag Rule Relationship records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_TAG_RULER_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        CANN_IND: {
            type: 'string',
            length: 1
        },
        WB_MODEL_CANNR_ID: {
            type: 'number'
        },
        WB_TAG_ID: {
            type: 'number'
        },
        JAVA_EXPRESSION: {
            type: 'string',
            length: 1333
        },
        RULE_TYPE: {
            type: 'string',
            length: 50
        },
        ACTIVE_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_Tag_RuleR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Tag]: { foreignKey: 'WB_TAG_ID', foreignKeyImmutable: true, localField: 'Tag' },
        [PASchema.esWB_Model_Cannibalization_Relationship]: {
            foreignKey: 'WB_MODEL_CANNR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCannTerm'
        }
    }
}

// Modeling Session Predictor Relationship
export const WB_Modeling_Session_Reference_Predictor_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Predictor_Relationship', // optional
    description: 'Schema for WB_Modeling_Session_Predictor_Relationship records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_REFPR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID_REF: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DETERMINATION_POLICY: {
            type: 'string',
            length: 50
        },
        USE_REF_PREDICTOR_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Modeling_Session_Reference_Predictor_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Model_Predictor]: {
            foreignKey: 'WB_MODEL_PREDICTOR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        }
    },
    hasMany: {}
}

// Modeling Session Predictor Relationship
export const WB_Modeling_Session_Reference_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Reference', // optional
    description: 'Schema for WB_Modeling_Session_Reference records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_REFR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        OVRD_IND: {
            type: 'string',
            length: 1
        },
        REF_VALUE: {
            type: 'number'
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_Reference_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Model_Predictor]: {
            foreignKey: 'WB_MODEL_PREDICTOR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        }
    },
    hasMany: {}
}

// Modeling Session Cann Type Relationship
export const WB_Modeling_Session_Cannibalization_Type_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Cannibalization_Type_Relationship', // optional
    description: 'Schema for WB_Modeling_Session_Cannibalization_Type_Relationship records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_CANNMR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_MODEL_CANNIBALIZATIONM_ID: {
            type: 'number'
        },
        WB_MODEL_CANNR_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_Cannibalization_Type_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Model_Cannibalization_Type]: {
            foreignKey: 'WB_MODEL_CANNIBALIZATIONM_ID',
            foreignKeyImmutable: true,
            localField: 'CannibalizationType'
        },
        [PASchema.esWB_Model_Cannibalization_Relationship]: {
            foreignKey: 'WB_MODEL_CANNR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCannR'
        }
    },
    hasMany: {
        [PASchema.esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship]: {
            foreignKey: 'WB_MODELING_SESSION_CANNMR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCannPMRs'
        },
        [PASchema.esWB_Modeling_Session_AffinitySet_Relationship]: {
            foreignKey: 'WB_MODELING_SESSION_CANNMR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionASRs'
        }
    }
}

// Modeling Session Cann Power Metric Relationship
export const WB_Modeling_Session_Cannibalization_Power_Metric_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Cannibalization_Power_Metric_Relationship', // optional
    description: 'Schema for WB_Modeling_Session_Cannibalization_Power_Metric_Relationship records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_CANNPMR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_CANNMR_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        WEIGHT: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_Cannibalization_Power_Metric_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Model_Predictor]: {
            foreignKey: 'WB_MODEL_PREDICTOR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        },
        [PASchema.esWB_Modeling_Session_Cannibalization_Type_Relationship]: {
            foreignKey: 'WB_MODELING_SESSION_CANNMR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCannMR'
        }
    },
    hasMany: {}
}

// Modeling Session AffinitySet Relationship
export const WB_Modeling_Session_AffinitySet_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_AffinitySet_Relationship', // optional
    description: 'Schema for WB_Modeling_Session_AffinitySet_Relationship records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_ASR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_CANNMR_ID: {
            type: 'number'
        },
        WB_AFFINITYSET_ID: {
            type: 'number'
        },
        STOCKPILING_PERIODS: {
            type: 'number'
        },
        PRIORITY: {
            type: 'number'
        },
        ENABLED_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_AffinitySet_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session_Cannibalization_Type_Relationship]: {
            foreignKey: 'WB_MODELING_SESSION_CANNMR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSessionCannMR'
        },
        [PASchema.esWB_AffinitySet]: {
            foreignKey: 'WB_AFFINITYSET_ID',
            foreignKeyImmutable: true,
            localField: 'AffinitySet'
        }
    },
    hasMany: {}
}

// Modeling Session Predictor Relationship
export const WB_Modeling_SessionPR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_SessionPR', // optional
    description: 'Schema for WB_Modeling_SessionPR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSIONPR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        WB_PERIOD_ID: {
            type: 'number'
        },
        DATASET_ID: {
            type: 'string',
            length: 50
        },
        QTY_UOM: {
            type: 'string',
            length: 20
        },
        TARGET_OBSERVATION_QTY: {
            type: 'number'
        },
        TARGET_OBSERVATION_UNITS: {
            type: 'number'
        },
        TARGET_OBSERVATION_RTLSLS: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        WB_TAG_IDS: {
            type: 'string',
            length: 150
        }
    }
})
export const WB_Modeling_SessionPR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        },
        [PASchema.esWB_Period]: { foreignKey: 'WB_PERIOD_ID', foreignKeyImmutable: true, localField: 'Period' }
    },
    hasMany: {}
}

// Modeling Session Elasticity
export const WB_Modeling_Session_El = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_El', // optional
    description: 'Schema for WB_Modeling_Session_El records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_EL_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_MODEL_VOLUME_COMPONENT_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        CALC_IND: {
            type: 'string',
            length: 1
        },
        NEUTRALIZING_METHOD: {
            type: 'string',
            length: 50
        },
        CALC_METHOD: {
            type: 'string',
            length: 50
        },
        CALC_VALUE_LOWERBOUND_PCT: {
            type: 'number'
        },
        CALC_VALUE_UPPERBOUND_PCT: {
            type: 'number'
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_El_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Model_Volume_Component]: {
            foreignKey: 'WB_MODEL_VOLUME_COMPONENT_ID',
            foreignKeyImmutable: true,
            localField: 'ModelVolumeComponent'
        },
        [PASchema.esWB_Model_Predictor]: {
            foreignKey: 'WB_MODEL_PREDICTOR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        }
    },
    hasMany: {}
}

// Modeling Session Elasticity R
export const WB_Modeling_Session_ElR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_ElR', // optional
    description: 'Schema for WB_Modeling_Session_ElR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_ELR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        NEUTRAL_VALUE: {
            type: 'number'
        },
        PREDICTOR_CALC_VALUE: {
            type: 'number'
        },
        PREDICTOR_CALC_VALUE_LOWERBOUND: {
            type: 'number'
        },
        PREDICTOR_CALC_VALUE_UPPERBOUND: {
            type: 'number'
        }
    }
})
export const WB_Modeling_Session_ElR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Model_Predictor]: {
            foreignKey: 'WB_MODEL_PREDICTOR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    },
    hasMany: {}
}

// Modeling Session Elasticity CR
export const WB_Modeling_Session_ElCR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_El', // optional
    description: 'Schema for WB_Modeling_Session_El records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_ELCR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        STEP_NUM: {
            type: 'number'
        },
        PREDICTOR_LOWERBOUND: {
            type: 'number'
        },
        PREDICTOR_MID: {
            type: 'number'
        },
        PREDICTOR_UPPERBOUND: {
            type: 'number'
        },
        VOLUME_LOWERBOUND: {
            type: 'number'
        },
        VOLUME_MID: {
            type: 'number'
        },
        VOLUME_UPPERBOUND: {
            type: 'number'
        },
        ELASTICITY: {
            type: 'number'
        },
        ELASTICITY_MID_TO_LOW: {
            type: 'number'
        },
        ELASTICITY_MID_TO_HIGH: {
            type: 'number'
        }
    }
})
export const WB_Modeling_Session_ElCR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Model_Predictor]: {
            foreignKey: 'WB_MODEL_PREDICTOR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    },
    hasMany: {}
}

// Modeling Session TermR
export const WB_Modeling_Session_TermR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_TermR', // optional
    description: 'Schema for WB_Modeling_Session_TermR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_TERMR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_MODEL_TERM_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        NEUTRALIZED_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_TermR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Model_Term]: {
            foreignKey: 'WB_MODEL_TERM_ID',
            foreignKeyImmutable: true,
            localField: 'ModelTerm'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    },
    hasMany: {}
}

//Modeling Session Constant Relationship
export const WB_Modeling_Session_ConstantR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_ConstantR', // optional
    description: 'Schema for WB_Modeling_Session_ConstantR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_CONSTANTR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_MODEL_CONSTANT_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        WB_CUST_ID_AGGR: {
            type: 'number'
        },
        WB_PRDGRP_ID_AGGR: {
            type: 'number'
        },
        WB_PROD_ID_AGGR: {
            type: 'number'
        },
        WB_CUST_ID_VICT: {
            type: 'number'
        },
        WB_PRDGRP_ID_VICT: {
            type: 'number'
        },
        WB_PROD_ID_VICT: {
            type: 'number'
        },
        WB_AFFINITYSET_ID: {
            type: 'number'
        },
        INDEX: {
            type: 'number'
        },
        CONSTANT_VALUE: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_ConstantR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Model_Constant]: {
            foreignKey: 'WB_MODEL_CONSTANT_ID',
            foreignKeyImmutable: true,
            localField: 'ModelConstant'
        },
        [PASchema.esWB_Customer]: [
            {
                foreignKey: 'WB_CUST_ID',
                foreignKeyImmutable: true,
                localField: 'Customer'
            },
            {
                foreignKey: 'WB_CUST_ID_AGGR',
                foreignKeyImmutable: true,
                localField: 'CustomerAggr'
            },
            {
                foreignKey: 'WB_CUST_ID_VICT',
                foreignKeyImmutable: true,
                localField: 'CustomerVict'
            }
        ],
        [PASchema.esWB_Product_Group]: [
            {
                foreignKey: 'WB_PRDGRP_ID',
                foreignKeyImmutable: true,
                localField: 'ProductGroup'
            },
            {
                foreignKey: 'WB_PRDGRP_ID_AGGR',
                foreignKeyImmutable: true,
                localField: 'ProductGroupAggr'
            },
            {
                foreignKey: 'WB_PRDGRP_ID_VICT',
                foreignKeyImmutable: true,
                localField: 'ProductGroupVict'
            }
        ],
        [PASchema.esWB_Finished_Product]: [
            {
                foreignKey: 'WB_PROD_ID',
                foreignKeyImmutable: true,
                localField: 'Product'
            },
            {
                foreignKey: 'WB_PROD_ID_AGGR',
                foreignKeyImmutable: true,
                localField: 'ProductAggr'
            },
            {
                foreignKey: 'WB_PROD_ID_VICT',
                foreignKeyImmutable: true,
                localField: 'ProductVict'
            }
        ],
        [PASchema.esWB_AffinitySet]: {
            foreignKey: 'WB_AFFINITYSET_ID',
            foreignKeyImmutable: true,
            localField: 'AffinitySet'
        }
    },
    hasMany: {}
}

// Modeling Session Seasonality Metrics
export const WB_Modeling_Session_SeasonalityMt = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_SeasonalityMt', // optional
    description: 'Schema for WB_Modeling_Session_SeasonalityMt records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_SEASONALITYMT_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        SUMMARY_ID: {
            type: 'string',
            length: 50
        },
        R2: {
            type: 'number'
        },
        MAPE: {
            type: 'number'
        },
        MAPE_WEIGHTED: {
            type: 'number'
        }
    }
})
export const WB_Modeling_Session_SeasonalityMt_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Customer]: {
            foreignKey: 'WB_CUST_ID',
            foreignKeyImmutable: true,
            localField: 'Customer'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    },
    hasMany: {}
}

//Modeling Session Seasonality De-promoted Metrics
export const WB_Modeling_Session_Seasonality_DepMt = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Seasonality_DepMt', // optional
    description: 'Schema for WB_Modeling_Session_Seasonality_DepMt records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_SEASONALITY_DEPMT_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        WB_PERIOD_ID: {
            type: 'number'
        },
        TOTAL_OBSERVATION_UNITS: {
            type: 'number'
        },
        TOTAL_OBSERVATION_UNITS_DEPROMOTED: {
            type: 'number'
        }
    }
})
export const WB_Modeling_Session_Seasonality_DepMt_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Customer]: {
            foreignKey: 'WB_CUST_ID',
            foreignKeyImmutable: true,
            localField: 'Customer'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        },
        [PASchema.esWB_Period]: {
            foreignKey: 'WB_PERIOD_ID',
            foreignKeyImmutable: true,
            localField: 'Period'
        }
    },
    hasMany: {}
}

//Modeling Session Seasonality Coefficient
export const WB_Modeling_Session_Seasonality_Coeff = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_Seasonality_DepMt', // optional
    description: 'Schema for WB_Modeling_Session_Seasonality_DepMt records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_SEASONALITY_COEFF_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        INTERCEPT: {
            type: 'number'
        },
        BASE_PRICE_COEFF: {
            type: 'number'
        },
        DISCOUNT_PCNT_COEFF: {
            type: 'number'
        },
        ACV_DIST_COEFF: {
            type: 'number'
        },
        ACV_FEAT_COEFF: {
            type: 'number'
        },
        ACV_DISP_COEFF: {
            type: 'number'
        },
        ACV_FEAT_DISP_COEFF: {
            type: 'number'
        },
        MOBILITY_COEFF: {
            type: 'number'
        }
    }
})
export const WB_Modeling_Session_Seasonality_Coeff_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Customer]: {
            foreignKey: 'WB_CUST_ID',
            foreignKeyImmutable: true,
            localField: 'Customer'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        },
        [PASchema.esWB_Period]: {
            foreignKey: 'WB_PERIOD_ID',
            foreignKeyImmutable: true,
            localField: 'Period'
        }
    },
    hasMany: {}
}

// Model Compare
export const WB_Model_Compare = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Compare', // optional
    description: 'Schema for WB_Model_Compare records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELCOMPARE_ID: {
            type: 'number',
            id: true,
            required: true
        },
        MODEL_COMPARE_ID: {
            type: 'string',
            length: 256
        },
        MODEL_COMPARE_NAME: {
            type: 'string',
            length: 256
        },
        COMPARE_TYPE: {
            type: 'string',
            length: 256
        },
        WB_MDSET_ID: {
            type: 'number'
        },
        WB_SALESORG_ID: {
            type: 'number'
        },
        MODEL_UOM: {
            type: 'string',
            length: 256
        },
        START_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        END_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        HOLDOUT_START_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        HOLDOUT_END_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        WB_ENTITY_ID_CUSTOMER: {
            type: 'number'
        },
        WB_CUSTH_ID: {
            type: 'number'
        },
        WB_ENTITY_ID_PRODUCT: {
            type: 'number'
        },
        WB_PRDH_ID: {
            type: 'number'
        },
        WB_ENTITY_ID_PERIOD: {
            type: 'number'
        },
        WB_PERIODH_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        }
    }
})
export const WB_Model_Compare_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: 'WB_MDSET_ID',
            foreignKeyImmutable: true,
            localField: 'MasterDataSet'
        },
        [PASchema.esWB_SalesOrg]: { foreignKey: 'WB_SALESORG_ID', foreignKeyImmutable: true, localField: 'SalesOrg' },
        [PASchema.esWB_Entity]: [
            { foreignKey: 'WB_ENTITY_ID_CUSTOMER', foreignKeyImmutable: true, localField: 'CustomerType' },
            { foreignKey: 'WB_ENTITY_ID_PRODUCT', foreignKeyImmutable: true, localField: 'ProductType' },
            { foreignKey: 'WB_ENTITY_ID_PERIOD', foreignKeyImmutable: true, localField: 'PeriodType' }
        ],
        [PASchema.esWB_Customer_Hierarchy]: {
            foreignKey: 'WB_CUSTH_ID',
            foreignKeyImmutable: true,
            localField: 'CustomerHierarchy'
        },
        [PASchema.esWB_Product_Hierarchy]: {
            foreignKey: 'WB_PRDH_ID',
            foreignKeyImmutable: true,
            localField: 'ProductHierarchy'
        },
        [PASchema.esWB_Period_Hierarchy]: {
            foreignKey: 'WB_PERIODH_ID',
            foreignKeyImmutable: true,
            localField: 'PeriodHierarchy'
        }
    },
    hasMany: {
        [PASchema.esWB_Model_Compare_Relationship]: {
            foreignKey: 'WB_MODELCOMPARE_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCompareRs'
        }
    }
}

export const WB_Model_CompareR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_Compare', // optional
    description: 'Schema for WB_Model_CompareR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELCOMPARER_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELCOMPARE_ID: {
            type: 'number'
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        PRIMARY_IND: {
            type: 'string',
            length: 1
        },
        PLOT_DATA_COLOR: {
            type: 'string',
            length: 50
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Model_CompareR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Model_Compare]: {
            foreignKey: 'WB_MODELCOMPARE_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCompare'
        }
    },
    hasMany: {}
}

//Modeling Session Constant Function Relationship
export const WB_Modeling_Session_ConstantFR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Modeling_Session_ConstantFR', // optional
    description: 'Schema for WB_Modeling_Session_ConstantFR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODELING_SESSION_CONSTANTFR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODELING_SESSION_ID: {
            type: 'number'
        },
        WB_MODEL_CONSTANT_ID: {
            type: 'number'
        },
        FUNCTION_ID: {
            type: 'string',
            length: 256
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Modeling_Session_ConstantFR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Modeling_Session]: {
            foreignKey: 'WB_MODELING_SESSION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelingSession'
        },
        [PASchema.esWB_Model_Constant]: {
            foreignKey: 'WB_MODEL_CONSTANT_ID',
            foreignKeyImmutable: true,
            localField: 'ModelConstant'
        }
    },
    hasMany: {}
}

//Published Model PASchema.esWB_Modeling_Session_AffinitySet_Relationship

export const WB_Published_Model = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Published_Model', // optional
    description: 'Schema for WB_Published_Model records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_PUBLISHED_MODEL_ID: {
            type: 'number',
            id: true,
            required: true
        },
        PUBLISHED_MODEL_ID: {
            type: 'string',
            length: 50
        },
        PUBLISHED_MODEL_NAME: {
            type: 'string',
            length: 256
        },
        PUBLISHED_MODEL_TYPE: {
            type: 'string',
            length: 50
        },
        COMMENTS: {
            type: 'string',
            length: 512
        },
        ACTIVE_IND: {
            type: 'string',
            length: 1
        },
        EFFECTIVE_START_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        WB_MODEL_ID: {
            type: 'number'
        },
        WB_MDSET_ID: {
            type: 'number'
        },
        WB_SALESORG_ID: {
            type: 'number'
        },
        WB_ENTITY_ID_CUSTOMER: {
            type: 'number'
        },
        WB_ENTITY_ID_PRODUCT: {
            type: 'number'
        },
        WB_ENTITY_ID_PERIOD: {
            type: 'number'
        },
        WB_CUSTH_ID_DS: {
            type: 'number'
        },
        WB_PRDH_ID_DS: {
            type: 'number'
        },
        WB_PERIODH_ID_DS: {
            type: 'number'
        },
        WB_MODEL_COEFF_SET_ID: {
            type: 'number'
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Published_Model_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: 'WB_MDSET_ID',
            foreignKeyImmutable: true,
            localField: 'MasterDataSet'
        },
        [PASchema.esWB_SalesOrg]: { foreignKey: 'WB_SALESORG_ID', foreignKeyImmutable: true, localField: 'SalesOrg' },
        [PASchema.esWB_Entity]: [
            { foreignKey: 'WB_ENTITY_ID_CUSTOMER', foreignKeyImmutable: true, localField: 'CustomerType' },
            { foreignKey: 'WB_ENTITY_ID_PRODUCT', foreignKeyImmutable: true, localField: 'ProductType' },
            { foreignKey: 'WB_ENTITY_ID_PERIOD', foreignKeyImmutable: true, localField: 'PeriodType' }
        ],
        [PASchema.esWB_Model_Coeff_Set]: {
            foreignKey: 'WB_MODEL_COEFF_SET_ID',
            foreignKeyImmutable: true,
            localField: 'ModelCoeffSet'
        },
        [PASchema.esWB_Model]: { foreignKey: 'WB_MODEL_ID', foreignKeyImmutable: true, localField: 'Model' },
        [PASchema.esWB_User]: {
            foreignKey: 'WB_AUTHUSR_ID_CREATEDBY',
            foreignKeyImmutable: true,
            localField: 'UserCreatedBy'
        }
    },
    hasMany: {}
}

//Promotion Simulation

export const WB_Simulation_Input = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Simulation_Input', // optional
    description: 'Schema for WB_Simulation_Input Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SIMULATION_INPUT_ID: {
            type: 'number',
            id: true,
            required: true
        },
        SIMULATION_INPUT_ID: {
            type: 'string',
            length: 50
        },
        SIMULATION_INPUT_NAME: {
            type: 'string',
            length: 256
        },
        SIMULATION_INPUT_TYPE: {
            type: 'string',
            length: 50
        },
        RATE_UOM: {
            type: 'string',
            length: 50
        },
        RATE_BASIS: {
            type: 'string',
            length: 50
        },
        AGGREGATION_METHOD: {
            type: 'string',
            length: 50
        },
        NUMBER_TYPE: {
            type: 'string',
            length: 50
        },
        DECIMAL_COUNT: {
            type: 'number'
        },
        MIN_VALUE_IND: {
            type: 'string',
            length: 1
        },
        MIN_VALUE_DECIMAL: {
            type: 'number'
        },
        MAX_VALUE_IND: {
            type: 'string',
            length: 1
        },
        MAX_VALUE_DECIMAL: {
            type: 'number'
        },
        SORT_ORDER_UI: {
            type: 'number'
        },
        RENDER_OPTIONS: {
            type: 'string',
            length: 1333
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        WB_FUNDTYPE_ID: {
            type: 'number'
        },
        PRD_CNDM_ID_STD: {
            type: 'number'
        },
        PRD_CNDM_ID_ADDL: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Simulation_Input_JSData_RELs = {}

export const WB_Simulation = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Simulation', // optional
    description: 'Schema for WB_Simulation Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SIMULATION_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: 'number'
        },
        WB_SALESORG_ID: {
            type: 'number'
        },
        SIMULATION_ID: {
            type: 'string',
            length: 50
        },
        SIMULATION_NAME: {
            type: 'string',
            length: 256
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        WB_PUBLISHED_MODEL_ID: {
            type: 'number'
        },
        WB_MODEL_PROFILE_ID: {
            type: 'number'
        },
        WB_SCNPLAN_ID: {
            type: 'number'
        },
        EMBEDDED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        WB_CUSTH_ID: {
            type: 'number'
        },
        WB_PRDH_ID: {
            type: 'number'
        },
        WB_PERIODH_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        START_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        END_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        SHARED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        WB_TREE_FOLDER_ID_SHARED: {
            type: 'number'
        },
        COMPARE_TABLE_OPTIONS: {
            type: 'string',
            default: '',
            length: 2500
        },
        COMPARE_PERSPECTIVE_OPTIONS: {
            type: 'string',
            default: '',
            length: 2500
        },
        LAST_CALC_DTTS: {
            type: 'number'
        },
        METRIC_PRD_COUNT: {
            type: 'number'
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: 'number'
        },
        WB_CBO_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})

export const WB_Simulation_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: 'WB_MDSET_ID',
            foreignKeyImmutable: true,
            localField: 'MasterDataSet'
        },
        [PASchema.esWB_SalesOrg]: { foreignKey: 'WB_SALESORG_ID', foreignKeyImmutable: true, localField: 'SalesOrg' },
        [PASchema.esWB_Model_Profile]: {
            foreignKey: 'WB_MODEL_PROFILE_ID',
            foreignKeyImmutable: true,
            localField: 'ModelProfile'
        },
        [PASchema.esWB_Published_Model]: {
            foreignKey: 'WB_PUBLISHED_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PublishedModel'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_CBO]: { foreignKey: 'WB_CBO_ID', foreignKeyImmutable: true, localField: 'CBO' },
        [PASchema.esWB_User]: {
            foreignKey: 'WB_AUTHUSR_ID_CREATEDBY',
            foreignKeyImmutable: true,
            localField: 'UserCreatedBy'
        }
    },
    hasMany: {
        [PASchema.esWB_Simulation_Product]: {
            foreignKey: 'WB_SIMULATION_ID',
            foreignKeyImmutable: true,
            localField: 'Products'
        },
        [PASchema.esWB_Simulation_Input_Relationship]: {
            foreignKey: 'WB_SIMULATION_ID',
            foreignKeyImmutable: true,
            localField: 'Inputs'
        },
        [PASchema.esWB_Simulation_Predictor_Relationship]: {
            foreignKey: 'WB_SIMULATION_ID',
            foreignKeyImmutable: true,
            localField: 'Predictors'
        },
        [PASchema.esWB_Simulation_Relationship]: {
            foreignKey: 'WB_SIMULATION_ID',
            foreignKeyImmutable: true,
            localField: 'SimulationRels'
        },
        [PASchema.esWB_Spend_Function_Relationship]: {
            foreignKey: 'WB_SIMULATION_ID',
            foreignKeyImmutable: true,
            localField: 'SimulationFunctionRels'
        },
        [PASchema.esWB_Simulation_Metrics]: {
            foreignKey: 'WB_SIMULATION_ID',
            foreignKeyImmutable: true,
            localField: 'SimulationMetrics'
        }
    }
}

export const WB_Model_API_Log = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_API_Log', // optional
    description: 'Schema for WB_Model_API_Log Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_API_LOG_ID: {
            type: 'number',
            id: true,
            required: true
        },
        STATUS: {
            type: 'string',
            length: 50
        },
        REQUEST_RECEIVE_DTTS: {
            type: 'number'
        },
        WB_PUBLISHED_MODEL_ID: {
            type: 'number'
        },
        PROCESS_START_DTTS: {
            type: 'number'
        },
        PROCESS_END_DTTS: {
            type: 'number'
        },
        PROCESS_DURATION: {
            type: 'number'
        },
        REQUEST_JSON: {
            type: 'string',
            length: 5000
        },
        RESPONSE_JSON: {
            type: 'string',
            length: 5000
        },
        CLIENT_CONFIG_JSON: {
            type: 'string',
            length: 5000
        },
        JAVA_RESPONSE_JSON: {
            type: 'string',
            length: 5000
        },
        HYPERFORCE_PAYLOAD_JSON: {
            type: 'string',
            length: 5000
        }
    }
})
export const WB_Model_API_Log_JSData_RELs = {}

export const WB_Simulation_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_SimulationSR', // optional
    description: 'Schema for WB_SimulationSR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SIMULATIONSR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_SIMULATION_ID: {
            type: 'number'
        },
        WB_SIMULATION_ID_REL: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Simulation_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Simulation]: [
            {
                foreignKey: 'WB_SIMULATION_ID',
                foreignKeyImmutable: true,
                localField: 'Simulation'
            },
            {
                foreignKey: 'WB_SIMULATION_ID_REL',
                foreignKeyImmutable: true,
                localField: 'SimulationRel'
            }
        ]
    }
}

export const WB_Simulation_Input_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Simulation_InputR', // optional
    description: 'Schema for WB_Simulation_Input Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SIMULATION_INPUTR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_SIMULATION_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        WB_PERIOD_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Simulation_Input_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Simulation]: {
            foreignKey: 'WB_SIMULATION_ID',
            foreignKeyImmutable: true,
            localField: 'Simulation'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        },
        [PASchema.esWB_Period]: { foreignKey: 'WB_PERIOD_ID', foreignKeyImmutable: true, localField: 'Period' }
    }
}

export const WB_Simulation_Predictor_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Simulation_PredictorR', // optional
    description: 'Schema for WB_Simulation_PredictorR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SIMULATION_PREDICTORR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_SIMULATION_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        WB_PERIOD_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Simulation_Predictor_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Simulation]: {
            foreignKey: 'WB_SIMULATION_ID',
            foreignKeyImmutable: true,
            localField: 'Simulation'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        },
        [PASchema.esWB_Period]: { foreignKey: 'WB_PERIOD_ID', foreignKeyImmutable: true, localField: 'Period' }
    }
}

export const WB_Simulation_Product = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Simulation_Prd', // optional
    description: 'Schema for WB_Simulation_Prd Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SIMULATION_PRD_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_SIMULATION_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Simulation_Product_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Simulation]: {
            foreignKey: 'WB_SIMULATION_ID',
            foreignKeyImmutable: true,
            localField: 'Simulation'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'SimulationProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'SimulationProduct'
        }
    }
}

// Demand Simulator
export const WB_Scenario_Plan = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlan', // optional
    description: 'Schema for WB_ScnPlan Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLAN_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: 'number',
            default: ''
        },
        WB_SALESORG_ID: {
            type: 'number',
            default: ''
        },
        PLAN_ID: {
            type: 'string',
            default: '',
            length: 50
        },
        PLAN_NAME: {
            type: 'string',
            default: '',
            length: 256
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        TEMPLATE_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        EVENT_MODE_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        WB_PUBLISHED_MODEL_ID: {
            type: 'number',
            default: ''
        },
        VOLUME_TYPE: {
            type: 'string',
            default: '',
            length: 50
        },
        WB_CUSTH_ID: {
            type: 'number'
        },
        WB_PRDH_ID: {
            type: 'number'
        },
        WB_PERIODH_ID: {
            type: 'number'
        },
        START_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        END_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        TABLE_OPTIONS: {
            type: 'string',
            default: '',
            length: 2500
        },
        PERSPECTIVE_OPTIONS: {
            type: 'string',
            default: '',
            length: 2500
        },
        METRIC_TABLE_OPTIONS: {
            type: 'string',
            default: '',
            length: 2500
        },
        METRIC_PERSPECTIVE_OPTIONS: {
            type: 'string',
            default: '',
            length: 2500
        },
        FINANCIAL_TABLE_OPTIONS: {
            type: 'string',
            default: '',
            length: 2500
        },
        FINANCIAL_PERSPECTIVE_OPTIONS: {
            type: 'string',
            default: '',
            length: 2500
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: 'number',
            default: ''
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        LOCKED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        LAST_CALC_DTTS: {
            type: 'number'
        },
        SHARED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        WB_TREE_FOLDER_ID_SHARED: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Scenario_Plan_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: 'WB_MDSET_ID',
            foreignKeyImmutable: true,
            localField: 'MasterDataSet'
        },
        [PASchema.esWB_SalesOrg]: { foreignKey: 'WB_SALESORG_ID', foreignKeyImmutable: true, localField: 'SalesOrg' },
        [PASchema.esWB_Published_Model]: {
            foreignKey: 'WB_PUBLISHED_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PublishedModel'
        },
        [PASchema.esWB_Period]: { foreignKey: 'WB_PERIOD_ID', foreignKeyImmutable: true, localField: 'Period' },
        [PASchema.esWB_User]: {
            foreignKey: 'WB_AUTHUSR_ID_CREATEDBY',
            foreignKeyImmutable: true,
            localField: 'UserCreatedBy'
        }
    },
    hasMany: {
        [PASchema.esWB_ScnPlan_EvtTypeR]: {
            foreignKey: 'WB_SCNPLAN_ID',
            foreignKeyImmutable: true,
            localField: 'EventTypes'
        },
        [PASchema.esWB_ScnPlan_CustR]: {
            foreignKey: 'WB_SCNPLAN_ID',
            foreignKeyImmutable: true,
            localField: 'Customers'
        },
        [PASchema.esWB_ScnPlan_PrdR]: {
            foreignKey: 'WB_SCNPLAN_ID',
            foreignKeyImmutable: true,
            localField: 'Products'
        },
        [PASchema.esWB_ScnPlan_PredictorR]: {
            foreignKey: 'WB_SCNPLAN_ID',
            foreignKeyImmutable: true,
            localField: 'Predictors'
        },
        [PASchema.esWB_ScnPlan_InputR]: {
            foreignKey: 'WB_SCNPLAN_ID',
            foreignKeyImmutable: true,
            localField: 'Inputs'
        },
        [PASchema.esWB_ScnPlan_CoeffR]: {
            foreignKey: 'WB_SCNPLAN_ID',
            foreignKeyImmutable: true,
            localField: 'Coefficients'
        },
        [PASchema.esWB_Spend_Function_Relationship]: {
            foreignKey: 'WB_SCNPLAN_ID',
            foreignKeyImmutable: true,
            localField: 'SpendFunctionRels'
        }
    }
}

export const WB_Scenario_Plan_Customer = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlan_CustR', // optional
    description: 'Schema for WB_ScnPlan_CustR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLAN_CUSTR_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLAN_ID: {
            type: 'number',
            default: ''
        },
        WB_CUST_ID: {
            type: 'number',
            default: ''
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Scenario_Plan_Customer_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlan]: { foreignKey: 'WB_SCNPLAN_ID', foreignKeyImmutable: true, localField: 'ScnPlan' },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' }
    }
}

export const WB_Scenario_Plan_Product = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlan_PrdR', // optional
    description: 'Schema for WB_ScnPlan_PrdR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLAN_PRDR_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLAN_ID: {
            type: 'number',
            default: ''
        },
        WB_PRDGRP_ID: {
            type: 'number',
            default: ''
        },
        WB_PROD_ID: {
            type: 'number',
            default: ''
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Scenario_Plan_Product_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlan]: { foreignKey: 'WB_SCNPLAN_ID', foreignKeyImmutable: true, localField: 'ScnPlan' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    }
}

export const WB_Scenario_Plan_EventType = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlan_EvtTypeR', // optional
    description: 'Schema for WB_ScnPlan_EvtTypeR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLAN_EVTTYPER_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLAN_ID: {
            type: 'number',
            default: ''
        },
        WB_MODEL_EVTTYPER_ID: {
            type: 'number',
            default: ''
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Scenario_Plan_EventType_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlan]: { foreignKey: 'WB_SCNPLAN_ID', foreignKeyImmutable: true, localField: 'ScnPlan' },
        [PASchema.esWB_Model_Event_Type_Relationship]: {
            foreignKey: 'WB_MODEL_EVTTYPER_ID',
            foreignKeyImmutable: true,
            localField: 'EventType'
        }
    }
}


export const WB_Scenario_Plan_Predictor = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlan_PredictorR', // optional
    description: 'Schema for WB_ScnPlan_PredictorR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLAN_PREDICTORR_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLAN_ID: {
            type: 'number',
            default: ''
        },
        WB_CUST_ID: {
            type: 'number',
            default: ''
        },
        WB_PRDGRP_ID: {
            type: 'number',
            default: ''
        },
        WB_PROD_ID: {
            type: 'number',
            default: ''
        },
        WB_PERIOD_ID: {
            type: 'number',
            default: ''
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Scenario_Plan_Predictor_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlan]: { foreignKey: 'WB_SCNPLAN_ID', foreignKeyImmutable: true, localField: 'ScnPlan' },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        },
        [PASchema.esWB_Period]: { foreignKey: 'WB_PERIOD_ID', foreignKeyImmutable: true, localField: 'Period' }
    }
}

export const WB_Scenario_Plan_Input = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlan_InputR', // optional
    description: 'Schema for WB_ScnPlan_InputR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLAN_INPUTR_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLAN_ID: {
            type: 'number',
            default: ''
        },
        WB_CUST_ID: {
            type: 'number',
            default: ''
        },
        WB_PRDGRP_ID: {
            type: 'number',
            default: ''
        },
        WB_PROD_ID: {
            type: 'number',
            default: ''
        },
        WB_PERIOD_ID: {
            type: 'number',
            default: ''
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Scenario_Plan_Input_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlan]: { foreignKey: 'WB_SCNPLAN_ID', foreignKeyImmutable: true, localField: 'ScnPlan' },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'SimulationProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'SimulationProduct'
        },
        [PASchema.esWB_Period]: { foreignKey: 'WB_PERIOD_ID', foreignKeyImmutable: true, localField: 'Period' }
    }
}

export const WB_Scenario_Plan_Coefficient = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlan_CoeffR', // optional
    description: 'Schema for WB_ScnPlan_CoeffR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLAN_COEFFR_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLAN_ID: {
            type: 'number',
            default: ''
        },
        WB_CUST_ID: {
            type: 'number',
            default: ''
        },
        WB_PRDGRP_ID: {
            type: 'number',
            default: ''
        },
        WB_PROD_ID: {
            type: 'number',
            default: ''
        },
        BASE_COEFF_VALUE: {
            type: 'number'
        },
        BASE_COEFF_VALUE_OVRD: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Scenario_Plan_Coefficient_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlan]: { foreignKey: 'WB_SCNPLAN_ID', foreignKeyImmutable: true, localField: 'ScnPlan' },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'SimulationProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'SimulationProduct'
        }
    }
}

//Constraint Based Optimizer
export const WB_CBO = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_CBO', // optional
    description: 'Schema for WB_CBO Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_CBO_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: 'number'
        },
        WB_SALESORG_ID: {
            type: 'number'
        },
        CBO_ID: {
            type: 'string',
            length: 50
        },
        CBO_NAME: {
            type: 'string',
            length: 256
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        WB_PUBLISHED_MODEL_ID: {
            type: 'number'
        },
        WB_MODEL_PROFILE_ID: {
            type: 'number'
        },
        WB_CUSTH_ID: {
            type: 'number'
        },
        WB_PRDH_ID: {
            type: 'number'
        },
        WB_PERIODH_ID: {
            type: 'number'
        },
        WB_SCNPLAN_ID: {
            type: 'number'
        },
        MD_LOCKED_IND: {
            type: 'string',
            length: 1
        },
        CNS_FORWARD_BUY_PCNT: {
            type: 'number'
        },
        RANKBY_ORDER: {
            type: 'string',
            length: 20
        },
        RANKBY_COUNT: {
            type: 'number'
        },
        RANKBY_METRIC: {
            type: 'string',
            length: 127
        },
        SCN_PLANNER_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        WB_SCNPLANNER_ID: {
            type: 'number',
            default: ''
        },
        WB_SCNPLANNERPRDPR_ID: {
            type: 'number',
            default: ''
        },
        SCN_PLANNER_PERIOD_PARTITION_IDS: {
            type: 'string',
            length: 1333
        },
        LAST_CALC_DTTS: {
            type: 'number'
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        SHARED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        WB_TREE_FOLDER_ID_SHARED: {
            type: 'number'
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_CBO_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: 'WB_MDSET_ID',
            foreignKeyImmutable: true,
            localField: 'MasterDataSet'
        },
        [PASchema.esWB_SalesOrg]: { foreignKey: 'WB_SALESORG_ID', foreignKeyImmutable: true, localField: 'SalesOrg' },
        [PASchema.esWB_Published_Model]: {
            foreignKey: 'WB_PUBLISHED_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PublishedModel'
        },
        [PASchema.esWB_Model_Profile]: {
            foreignKey: 'WB_MODEL_PROFILE_ID',
            foreignKeyImmutable: true,
            localField: 'ModelProfile'
        },
        [PASchema.esWB_User]: {
            foreignKey: 'WB_AUTHUSR_ID_CREATEDBY',
            foreignKeyImmutable: true,
            localField: 'UserCreatedBy'
        },
        [PASchema.esWB_ScnPlanner]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'ScenarioPlanner'
        },
        [PASchema.esWB_ScnPlannerPrdPR]: {
            foreignKey: 'WB_SCNPLANNERPRDPR_ID',
            foreignKeyImmutable: true,
            localField: 'ProductPartition'
        }
    },
    hasMany: {
        [PASchema.esWB_CBO_Set]: {
            foreignKey: 'WB_CBO_ID',
            foreignKeyImmutable: true,
            localField: 'CBOSets'
        },
        [PASchema.esWB_CBO_Input_Relationship]: {
            foreignKey: 'WB_CBO_ID',
            foreignKeyImmutable: true,
            localField: 'CBOInputs'
        },
        [PASchema.esWB_CBO_Constraint]: {
            foreignKey: 'WB_CBO_ID',
            foreignKeyImmutable: true,
            localField: 'CBOConstraints'
        },
        [PASchema.esWB_Spend_Function_Relationship]: {
            foreignKey: 'WB_CBO_ID',
            foreignKeyImmutable: true,
            localField: 'CBOSpendFunctions'
        },
        [PASchema.esWB_Simulation_Metrics]: {
            foreignKey: 'WB_CBO_ID',
            foreignKeyImmutable: true,
            localField: 'SimulationMetrics'
        }
    }
}

export const WB_CBO_SET = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_CBO_Set', // optional
    description: 'Schema for WB_CBO_SET Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_CBO_SET_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_CBO_ID: {
            type: 'number'
        },
        SET_ID: {
            type: 'string',
            length: 50
        },
        SET_NAME: {
            type: 'string',
            length: 256
        },
        SET_TYPE: {
            type: 'string',
            length: 10
        },
        WB_MODEL_PROFILEGR_ID: {
            type: 'number'
        },
        ITEM_COUNT: {
            type: 'number'
        },
        CUST_IND: {
            type: 'string',
            length: 1
        },
        PRD_IND: {
            type: 'string',
            length: 1
        },
        STEPS: {
            type: 'number'
        },
        MIN_VALUE: {
            type: 'number'
        },
        MAX_VALUE: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_CBO_SET_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_CBO]: { foreignKey: 'WB_CBO_ID', foreignKeyImmutable: true, localField: 'CBO' },
        [PASchema.esWB_Model_Profile_Group]: {
            foreignKey: 'WB_MODEL_PROFILEGR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelProfileGroup'
        }
    },
    hasMany: {
        [PASchema.esWB_CBO_Set_Item]: {
            foreignKey: 'WB_CBO_SET_ID',
            foreignKeyImmutable: true,
            localField: 'CBOSetItems'
        },
        [PASchema.esWB_CBO_Set_Predictor]: {
            foreignKey: 'WB_CBO_SET_ID',
            foreignKeyImmutable: true,
            localField: 'CBOSetPredictors'
        }
    }
}

export const WB_CBO_SET_ITEM = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_CBO_Set_Item', // optional
    description: 'Schema for WB_CBO_SET_ITEM Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_CBO_SET_ITEM_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_CBO_SET_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        START_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DURATION: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_CBO_SET_ITEM_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_CBO_Set]: { foreignKey: 'WB_CBO_SET_ID', foreignKeyImmutable: true, localField: 'CBOSet' },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    }
}

export const WB_CBO_SET_PR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_CBO_Set_PR', // optional
    description: 'Schema for WB_CBO_SET_PR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_CBO_SET_PR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_CBO_SET_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_CBO_SET_PR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_CBO_Set]: { foreignKey: 'WB_CBO_SET_ID', foreignKeyImmutable: true, localField: 'CBOSet' },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    }
}

export const WB_CBO_Input_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_CBO_InputR', // optional
    description: 'Schema for WB_CBO_InputR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_CBO_INPUTR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_CBO_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_CBO_Input_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_CBO]: { foreignKey: 'WB_CBO_ID', foreignKeyImmutable: true, localField: 'CBO' },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    }
}

export const WB_CBO_Constraint = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_CBO_Cstr', // optional
    description: 'Schema for WB_CBO_Cstr Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_CBO_CSTR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_CBO_ID: {
            type: 'number'
        },
        ACTIVE_IND: {
            type: 'string',
            length: 1
        },
        METRIC_ID: {
            type: 'string',
            length: 50
        },
        MIN_VALUE: {
            type: 'number'
        },
        MAX_VALUE: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_CBO_Constraint_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_CBO]: { foreignKey: 'WB_CBO_ID', foreignKeyImmutable: true, localField: 'CBO' }
    }
}

// Scenario Planner
export const WB_ScnPlanner = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlanner', // optional
    description: 'Schema for WB_ScnPlanner Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLANNER_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: 'number',
            default: ''
        },
        WB_SALESORG_ID: {
            type: 'number',
            default: ''
        },
        PLANNER_ID: {
            type: 'string',
            default: '',
            length: 50
        },
        PLANNER_NAME: {
            type: 'string',
            default: '',
            length: 256
        },
        WB_SCNPLAN_ID: {
            type: 'number',
            default: ''
        },
        WB_PUBLISHED_MODEL_ID: {
            type: 'number',
            default: ''
        },
        WB_MODEL_EVTTYPER_ID: {
            type: 'number',
            default: ''
        },
        SCENARIO_LOCKED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        LOCKED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        TRIAL_STRUCTURE_LOCKED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        PERIODPART_DURATION: {
            type: 'number'
        },
        PERIODPART_START_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        PERIODPART_END_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        EVENT_SUBTYPE_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        SINGLE_CUST_MODE_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        METRIC_ID_OBJECTIVE: {
            type: 'string',
            default: '',
            length: 50
        },
        WB_AUTOMATION_FLOW_ID: {
            type: 'number'
        },
        WB_SCNPLANNERTRIAL_ID_RAPID: {
            type: 'number'
        },
        CNVG_PCNTIMPR_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        CNVG_PCNTIMPR_AMT: {
            type: 'number'
        },
        CNVG_PCNTIMPR_ITR: {
            type: 'number'
        },
        STP_TOTAL_TIME_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        STP_TOTAL_TIME_MIN: {
            type: 'number'
        },
        STP_TOTAL_TIME_PER_GEN_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        STP_TOTAL_TIME_PER_GEN_MIN: {
            type: 'number'
        },
        STP_GEN_LIMIT_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        STP_GEN_LIMIT_COUNT: {
            type: 'number'
        },
        GEN_TRIALS_PER_GEN_COUNT: {
            type: 'number'
        },
        P_VALUE: {
            type: 'number'
        },
        TRIAL_GENERATION_POLICY: {
            type: 'string',
            default: '',
            length: 50
        },
        MONITORING_INTERVAL_SEC: {
            type: 'number'
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: 'number',
            default: ''
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_ScnPlanner_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: 'WB_MDSET_ID',
            foreignKeyImmutable: true,
            localField: 'MasterDataSet'
        },
        [PASchema.esWB_SalesOrg]: { foreignKey: 'WB_SALESORG_ID', foreignKeyImmutable: true, localField: 'SalesOrg' },
        [PASchema.esWB_Published_Model]: {
            foreignKey: 'WB_PUBLISHED_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PublishedModel'
        },
        [PASchema.esWB_ScnPlannerTrial]: {
            foreignKey: 'WB_SCNPLANNERTRIAL_ID_RAPID',
            foreignKeyImmutable: true,
            localField: 'RapidTrial'
        },
        [PASchema.esWB_User]: {
            foreignKey: 'WB_AUTHUSR_ID_CREATEDBY',
            foreignKeyImmutable: true,
            localField: 'UserCreatedBy'
        },
        [PASchema.esWB_Automation_Flow]: {
            foreignKey: 'WB_AUTOMATION_FLOW_ID',
            foreignKeyImmutable: true,
            localField: 'AutomationFlow'
        }
    },
    hasMany: {
        [PASchema.esWB_ScnPlannerCalc]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'Calcs'
        },
        [PASchema.esWB_ScnPlannerCnstr]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'Constraints'
        },
        [PASchema.esWB_ScnPlannerCR]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'Customers'
        },
        [PASchema.esWB_ScnPlannerPR]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'Products'
        },
        [PASchema.esWB_ScnPlannerESR]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'EventSubTypes'
        },
        [PASchema.esWB_ScnPlannerPPR]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'PeriodPartitions'
        },
        [PASchema.esWB_ScnPlannerPrdPR]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'ProductPartitions'
        },
        [PASchema.esWB_ScnPlannerPrmR]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'Promotions'
        },
        [PASchema.esWB_ScnPlannerTrial]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'Trials'
        },
        [PASchema.esWB_ScnPlannerTrialEvt]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'TrialEvents'
        }

    }
}

export const WB_ScnPlannerCalc = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlannerCalc', // optional
    description: 'Schema for WB_ScnPlannerCalc Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLANNERCALC_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLANNER_ID: {
            type: 'number',
            default: ''
        },
        CALC_ID: {
            type: 'string',
            default: '',
            length: 50
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        CALC_START_DTTS: {
            type: 'number',
            default: ''
        },
        CALC_END_DTTS: {
            type: 'number',
            default: ''

        },
        CREATED_DTTS: {
            type: 'number',
            default: ''

        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''

        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_ScnPlannerCalc_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlanner]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlanner'
        }
    },
    hasMany: {
        [PASchema.esWB_ScnPlannerCalcLog]: {
            foreignKey: 'WB_SCNPLANNERCALC_ID',
            foreignKeyImmutable: true,
            localField: 'CalcLogs'
        }
    }
}

export const WB_ScnPlannerCalcLog = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlannerCalcLog', // optional
    description: 'Schema for WB_ScnPlannerCalcLog Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLANNERCALCLOG_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLANNERCALC_ID: {
            type: 'number',
            default: ''

        },
        LOG_MSG_TYPE: {
            type: 'string',
            default: '',
            length: 50
        },
        TIMING_START_DTTS: {
            type: 'number',
            default: ''
        },
        TIMING_END_DTTS: {
            type: 'number',
            default: ''
        },
        GENERATION: {
            type: 'number',
            default: ''
        },
        LOG_MSG: {
            type: 'string',
            length: 1333

        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_ScnPlannerCalcLog_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlannerCalc]: {
            foreignKey: 'WB_SCNPLANNERCALC_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlannerCalc'
        }
    }
}

export const WB_ScnPlannerCnstr = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlannerCnst', // optional
    description: 'Schema for WB_ScnPlannerCnst Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLANNERCNSTR_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLANNER_ID: {
            type: 'number',
            default: ''
        },
        WB_SCNCONSTRAINTM_ID: {
            type: 'number',
            default: ''
        },
        SETTINGS: {
            type: 'string',
            length: 1333
        },
        EVALUATION_SCOPE: {
            type: 'string',
            length: 1333
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_ScnPlannerCnstr_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlanner]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlanner'
        },
        [PASchema.esWB_ScnConstraint]: {
            foreignKey: 'WB_SCNCONSTRAINTM_ID',
            foreignKeyImmutable: true,
            localField: 'Constraint'
        }
    }
}

export const WB_ScnPlannerCR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlannerCR', // optional
    description: 'Schema for WB_ScnPlannerCR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLANNERCR_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLANNER_ID: {
            type: 'number',
            default: ''
        },
        WB_CUST_ID: {
            type: 'number',
            default: ''
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',

            length: 8
        }
    }
})
export const WB_ScnPlannerCR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlanner]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlanner'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' }
    }
}

export const WB_ScnPlannerESR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlannerESR', // optional
    description: 'Schema for WB_ScnPlannerESR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLANNERESR_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLANNER_ID: {
            type: 'number',
            default: ''
        },
        SUBTYPE_CODE: {
            type: 'string',
            default: '',
            length: 20
        },
        SUBTYPE_NAME: {
            type: 'string',
            default: '',
            length: 256
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_ScnPlannerESR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlanner]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlanner'
        }
    }
}

export const WB_ScnPlannerPPR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlannerPPR', // optional
    description: 'Schema for WB_ScnPlannerPPR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLANNERPPR_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLANNER_ID: {
            type: 'number',
            default: ''
        },
        PERIOD_PARTITION_ID: {
            type: 'number',
            default: ''
        },
        START_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        END_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        WB_PERIOD_ID_CSV: {
            type: 'string',
            length: 1333
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_ScnPlannerPPR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlanner]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlanner'
        }
    }
}

export const WB_ScnPlannerPR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlannerPR', // optional
    description: 'Schema for WB_ScnPlannerPR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLANNERPR_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLANNER_ID: {
            type: 'number',
            default: ''
        },
        WB_PRDGRP_ID: {
            type: 'number',
            default: ''
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_ScnPlannerPR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlanner]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlanner'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        }
    }
}

export const WB_ScnPlannerPrdPPR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlannerPrdPPR', // optional
    description: 'Schema for WB_ScnPlannerPrdPPR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLANNERPRDPPR_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLANNERPRDPR_ID: {
            type: 'number',
            default: ''
        },
        WB_PRDGRP_ID: {
            type: 'number',
            default: ''
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_ScnPlannerPrdPPR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlannerPrdPR]: {
            foreignKey: 'WB_SCNPLANNERPRDPR_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlannerPrdPR'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        }
    }
}

export const WB_ScnPlannerPrdPR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlannerPrdPR', // optional
    description: 'Schema for WB_ScnPlannerPrdPR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLANNERPRDPR_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLANNER_ID: {
            type: 'number',
            default: ''
        },
        PRODUCT_PARTITION_ID: {
            type: 'string',
            default: '',
            length: 50
        },
        PRODUCT_PARTITION_NAME: {
            type: 'string',
            default: '',
            length: 256
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_ScnPlannerPrdPR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlanner]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlanner'
        }
    },
    hasMany: {
        [PASchema.esWB_ScnPlannerPrdPPR]: {
            foreignKey: 'WB_SCNPLANNERPRDPR_ID',
            foreignKeyImmutable: true,
            localField: 'PartitionProducts'
        }
    }
}

export const WB_ScnPlannerPrmR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlannerPrdPR', // optional
    description: 'Schema for WB_ScnPlannerPrdPR Records', // optional
    type: 'object',
    track: true,
    'properties': {
        'WB_SCNPLANNERPRMR_ID': {
            'type': 'number',
            'default': '',
            'id': true,
            'required': true
        },
        'WB_SCNPLANNER_ID': {
            'type': 'number',
            'default': ''
        },
        'WB_SCNPLANNERPRDPR_ID': {
            'type': 'number',
            'default': ''
        },
        'SUBTYPE_CODE': {
            'type': 'string',
            'default': '',
            'length': 20
        },
        'WB_CBO_ID': {
            'type': 'number',
            'default': ''
        },
        'CREATED_DTTS': {
            'type': 'number',
            'default': ''
        },
        'MODIFIED_DTTS': {
            'type': 'number',
            'default': ''
        },
        'DELETED_IND': {
            'type': 'string',
            'default': '',
            'length': 1
        },
        'DELETED_DT': {
            'type': 'string',
            'default': '18000101',
            'length': 8
        }
    }
})
export const WB_ScnPlannerPrmR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlanner]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlanner'
        },
        [PASchema.esWB_CBO]: { foreignKey: 'WB_CBO_ID', foreignKeyImmutable: true, localField: 'CBO' },
        [PASchema.esWB_ScnPlannerPrdPR]: {
            foreignKey: 'WB_SCNPLANNERPRDPR_ID',
            foreignKeyImmutable: true,
            localField: 'ProductPartition'
        }
    }
}


export const WB_ScnPlannerTrial = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlannerTrial', // optional
    description: 'Schema for WB_ScnPlannerTrial Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLANNERTRIAL_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLANNER_ID: {
            type: 'number',
            default: ''

        },
        TRIAL_ID: {
            type: 'string',
            default: '',
            length: 50
        },
        TRIAL_TYPE: {
            type: 'string',
            default: '',
            length: 50
        },
        GENERATION: {
            type: 'number',
            default: ''
        },
        KEEP_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        WB_SCNPLANNERCALC_ID: {
            type: 'number',
            default: ''
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_ScnPlannerTrial_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlanner]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlanner'
        }
    },
    hasMany: {
        [PASchema.esWB_ScnPlannerTrialPR]: {
            foreignKey: 'WB_SCNPLANNERTRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'Partitions'
        },
        [PASchema.esWB_ScnPlannerTrialCNR]: {
            foreignKey: 'WB_SCNPLANNERTRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'Constraints'
        }
    }
}

export const WB_ScnPlannerTrialPR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlannerTrial', // optional
    description: 'Schema for WB_ScnPlannerTrial Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLANNERTRIALPR_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLANNERTRIAL_ID: {
            type: 'number',
            default: ''
        },
        WB_CUST_ID: {
            type: 'number',
            default: ''
        },
        WB_SCNPLANNERPRDPR_ID: {
            type: 'number',
            default: ''
        },
        PERIOD_PARTITION_ID: {
            type: 'number',
            default: ''
        },
        PROMOTED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        SUBTYPE_CODE: {
            type: 'string',
            default: '',
            length: 20
        },
        WB_SCNPLANNERTRIALEVT_ID_CHOSEN: {
            type: 'number',
            default: ''
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }

})
export const WB_ScnPlannerTrialPR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlannerTrial]: {
            foreignKey: 'WB_SCNPLANNERTRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlannerTrial'
        },
        [PASchema.esWB_ScnPlannerPrdPR]: {
            foreignKey: 'WB_SCNPLANNERPRDPR_ID',
            foreignKeyImmutable: true,
            localField: 'ProductPartition'
        }
    }
}

export const WB_ScnPlannerTrialCNR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlannerTrial', // optional
    description: 'Schema for WB_ScnPlannerTrial Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLANNERTRIALCNR_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLANNERTRIAL_ID: {
            type: 'number',
            default: ''
        },
        WB_SCNPLANNERCNSTR_ID: {
            type: 'number',
            default: ''
        },
        NAME: {
            type: 'string',
            default: '',
            length: 256
        },
        PASS_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_ScnPlannerTrialCNR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlannerTrial]: {
            foreignKey: 'WB_SCNPLANNERTRIAL_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlannerTrial'
        },
        [PASchema.esWB_ScnPlannerCnstr]: {
            foreignKey: 'WB_SCNPLANNERCNSTR_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlannerConstraint'
        }

    }
}


export const WB_ScnPlannerTrialEvt = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnPlannerTrialEvt', // optional
    description: 'Schema for WB_ScnPlannerTrialEvt Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNPLANNERTRIALEVT_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        WB_SCNPLANNER_ID: {
            type: 'number',
            default: ''
        },
        EVENT_NAME: {
            type: 'string',
            default: '',
            length: 256
        },
        WB_MODEL_EVTTYPER_ID: {
            type: 'number',
            default: ''
        },
        WB_SCNPLANNERPRDPR_ID: {
            type: 'number'
        },
        PERIOD_PARTITION_ID: {
            type: 'number'
        },
        WB_CBO_ID: {
            type: 'number'
        },
        WB_CBO_SET_ID_CSV: {
            type: 'string',
            length: 1333
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_ScnPlannerTrialEvt_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_ScnPlanner]: {
            foreignKey: 'WB_SCNPLANNER_ID',
            foreignKeyImmutable: true,
            localField: 'ScnPlanner'
        }
    }
}

export const WB_ScnConstraint = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_ScnConstraint', // optional
    description: 'Schema for WB_ScnConstraint Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SCNCONSTRAINTM_ID: {
            type: 'number',
            default: '',
            id: true,
            required: true
        },
        CONSTRAINT_ID: {
            type: 'string',
            default: '',
            length: 50
        },
        CONSTRAINT_NAME: {
            type: 'string',
            default: '',
            length: 256
        },
        CONSTRAINT_TYPE: {
            type: 'string',
            default: '',
            length: 50
        },
        COMMENTS: {
            type: 'string',
            length: 1333
        },
        SETTINGS_TEMPLATE: {
            type: 'string',
            length: 1333
        },
        METRIC_ID: {
            type: 'string',
            default: '',
            length: 50
        },
        CREATED_DTTS: {
            type: 'number',
            default: ''
        },
        MODIFIED_DTTS: {
            type: 'number',
            default: ''
        },
        DELETED_IND: {
            type: 'string',
            default: '',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_ScnConstraint_JSData_RELs = {}


// Spend/ Shipment Function Definition
export const WB_Spend_Function = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Spend_Function', // optional
    description: 'Schema for WB_SPEND_FUNCTION Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SPEND_FUNCTION_ID: {
            type: 'number',
            id: true,
            required: true
        },
        SPEND_FUNCTION_ID: {
            type: 'string'
        },
        SPEND_FUNCTION_NAME: {
            type: 'string'
        },
        FUNCTION_USAGE: {
            type: 'string'
        },
        AMOUNT_LOCATION: {
            type: 'string'
        },
        WB_SPEND_FUNCTION_ID_SPECIFIC: {
            type: 'number'
        },
        FUNCTION_TYPE: {
            type: 'string'
        },
        FUNCTION_SUBTYPE: {
            type: 'string'
        },
        FIXED_IND: {
            type: 'string',
            length: 1
        },
        CALCULATION_DISPLAY: {
            type: 'string'
        },
        FUNCTION_DEFN_SRC: {
            type: 'string'
        },
        PROFILE_DEFAULT_IND: {
            type: 'string',
            length: 1
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Spend_Function_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Spend_Function_Input_Relationship]: {
            foreignKey: 'WB_SPEND_FUNCTION_ID',
            foreignKeyImmutable: true,
            localField: 'SpendFunctionInputRels'
        },
        [PASchema.esWB_Spend_Function_Term_Relationship]: {
            foreignKey: 'WB_SPEND_FUNCTION_ID',
            foreignKeyImmutable: true,
            localField: 'SpendFunctionTermRels'
        }
    }
}

export const WB_Spend_Function_Input_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Spend_Function_InputR', // optional
    description: 'Schema for WB_SPEND_FUNCTION_INPUTR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SPEND_FUNCTION_INPUTR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_SPEND_FUNCTION_ID: {
            type: 'number'
        },
        INPUT_SEQ: {
            type: 'number'
        },
        INPUT_NAME: {
            type: 'string',
            length: 256
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Spend_Function_Input_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Spend_Function]: {
            foreignKey: 'WB_SPEND_FUNCTION_ID',
            foreignKeyImmutable: true,
            localField: 'SpendFunction'
        }
    }
}

export const WB_Spend_Function_Term_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Spend_Function_TermR', // optional
    description: 'Schema for WB_SPEND_FUNCTION_TERMR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SPEND_FUNCTION_TERMR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_SPEND_FUNCTION_ID: {
            type: 'number'
        },
        TERM_SEQ: {
            type: 'number'
        },
        TERM_META_ID: {
            type: 'string',
            length: 256
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Spend_Function_Term_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Spend_Function]: {
            foreignKey: 'WB_SPEND_FUNCTION_ID',
            foreignKeyImmutable: true,
            localField: 'SpendFunction'
        }
    }
}

// Simulation Shipment/ Financial Model
export const WB_Spend_Function_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Spend_FunctionR', // optional
    description: 'Schema for WB_SPEND_FUNCTIONR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SPEND_FUNCTIONR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_SIMULATION_ID: {
            type: 'number'
        },
        WB_CBO_ID: {
            type: 'number'
        },
        WB_SCNPLAN_ID: {
            type: 'number'
        },
        SPEND_ID: {
            type: 'string'
        },
        SPEND_NAME: {
            type: 'string'
        },
        WB_SPEND_FUNCTION_ID: {
            type: 'number'
        },
        AMOUNT_LOCATION: {
            type: 'string'
        },
        RATE_AMT: {
            type: 'number'
        },
        RATE_UOM: {
            type: 'string'
        },
        REDEMPTION_PCNT: {
            type: 'number'
        },
        INPUT_VALUE_1: {
            type: 'number'
        },
        INPUT_VALUE_2: {
            type: 'number'
        },
        INPUT_VALUE_3: {
            type: 'number'
        },
        INPUT_VALUE_4: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Spend_Function_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Spend_Function]: {
            foreignKey: 'WB_SPEND_FUNCTION_ID',
            foreignKeyImmutable: true,
            localField: 'SpendFunction'
        },
        [PASchema.esWB_Simulation]: {
            foreignKey: 'WB_SIMULATION_ID',
            foreignKeyImmutable: true,
            localField: 'Simulation'
        },
        [PASchema.esWB_CBO]: { foreignKey: 'WB_CBO_ID', foreignKeyImmutable: true, localField: 'CBO' },
        [PASchema.esWB_ScnPlan]: { foreignKey: 'WB_SCNPLAN_ID', foreignKeyImmutable: true, localField: 'ScnPlan' }
    },
    hasMany: {
        [PASchema.esWB_Spend_Function_Relationship_Scope]: {
            foreignKey: 'WB_SPEND_FUNCTIONR_ID',
            foreignKeyImmutable: true,
            localField: 'Scope'
        }
    }
}

export const WB_Spend_Function_Relationship_Scope = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Spend_FunctionCPR', // optional
    description: 'Schema for WB_SPEND_FUNCTIONCPR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SPEND_FUNCTIONCPR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_SPEND_FUNCTIONR_ID: {
            type: 'number'
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        RATE_AMT: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Spend_Function_Relationship_Scope_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Spend_Function_Relationship]: {
            foreignKey: 'WB_SPEND_FUNCTIONR_ID',
            foreignKeyImmutable: true,
            localField: 'SpendFunctionR'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        }
    }
}

// Simulation Metric Output Model
export const WB_Simulation_Metrics = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Simulation_Metrics', // optional
    description: 'Schema for WB_SimMt Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SIMMT_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_SIMULATION_ID: {
            type: 'number'
        },
        WB_CBO_ID: {
            type: 'number'
        },
        WB_SCNPLAN_ID: {
            type: 'number'
        },
        WB_SCNPLANNER_ID: {
            type: 'number'
        },
        WB_SCNPLANNERTRIAL_ID: {
            type: 'number'
        },
        WB_SCNPLANNERTRIALEVT_ID: {
            type: 'number'
        },
        SUMMARY_LEVEL: {
            type: 'string',
            length: 50
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        WB_PERIOD_ID: {
            type: 'number'
        },
        TRIAL_ID: {
            type: 'number'
        },
        START_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        END_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        },
        DURATION: {
            type: 'number'
        },
        GROSS_LIST_PRICE: {
            type: 'number'
        },
        NET_LIST_PRICE: {
            type: 'number'
        },
        VCM: {
            type: 'number'
        },
        STD_FUNDING_RATE: {
            type: 'number'
        },
        ADDL_FUNDING_RATE: {
            type: 'number'
        },
        RETAILER_BASE_PRICE: {
            type: 'number'
        },
        RETAILER_PROMO_PRICE: {
            type: 'number'
        },
        FEATUREONLY_ACV_N: {
            type: 'number'
        },
        DISPLAYONLY_ACV_N: {
            type: 'number'
        },
        FEATUREDISPLAY_ACV_N: {
            type: 'number'
        },
        TPRONLY_ACV_N: {
            type: 'number'
        },
        PROMOTED_ACV_N: {
            type: 'number'
        },
        DIST_ACV_N: {
            type: 'number'
        },
        ACV_D: {
            type: 'number'
        },
        CNS_FORWARD_BUY_PCNT: {
            type: 'number'
        },
        CNS_BASE_UNITS: {
            type: 'number'
        },
        CNS_BASE_STAT: {
            type: 'number'
        },
        CNS_BASE_PRFTCNTRB: {
            type: 'number'
        },
        CNS_BASE_RTLSLS: {
            type: 'number'
        },
        CNS_BASE_LISTSLS: {
            type: 'number'
        },
        CNS_BASE_NETLISTSLS: {
            type: 'number'
        },
        CNS_BASE_FNDAMT: {
            type: 'number'
        },
        CNS_EDLP_UNITS: {
            type: 'number'
        },
        CNS_EDLP_STAT: {
            type: 'number'
        },
        CNS_EDLP_PRFTCNTRB: {
            type: 'number'
        },
        CNS_EDLP_RTLSLS: {
            type: 'number'
        },
        CNS_EDLP_LISTSLS: {
            type: 'number'
        },
        CNS_EDLP_NETLISTSLS: {
            type: 'number'
        },
        CNS_EDLP_FNDAMT: {
            type: 'number'
        },
        CNS_INCR_UNITS: {
            type: 'number'
        },
        CNS_INCR_STAT: {
            type: 'number'
        },
        CNS_INCR_PRFTCNTRB: {
            type: 'number'
        },
        CNS_INCR_RTLSLS: {
            type: 'number'
        },
        CNS_INCR_LISTSLS: {
            type: 'number'
        },
        CNS_INCR_NETLISTSLS: {
            type: 'number'
        },
        CNS_INCR_FNDAMT: {
            type: 'number'
        },
        CNS_TOTAL_UNITS: {
            type: 'number'
        },
        CNS_TOTAL_STAT: {
            type: 'number'
        },
        CNS_TOTAL_PRFTCNTRB: {
            type: 'number'
        },
        CNS_TOTAL_RTLSLS: {
            type: 'number'
        },
        CNS_TOTAL_LISTSLS: {
            type: 'number'
        },
        CNS_TOTAL_NETLISTSLS: {
            type: 'number'
        },
        CNS_TOTAL_FNDAMT: {
            type: 'number'
        },
        SHIP_UNITS: {
            type: 'number'
        },
        SHIP_LISTSLS: {
            type: 'number'
        },
        SHIP_NETLISTSLS: {
            type: 'number'
        },
        SHIP_FNDAMT: {
            type: 'number'
        },
        SHIP_PRFTCNTRB: {
            type: 'number'
        },
        SPEND_TOTAL: {
            type: 'number'
        },
        SPEND_FIXED: {
            type: 'number'
        },
        SPEND_CNS_VARIABLE: {
            type: 'number'
        },
        SPEND_SHIP_VARIABLE: {
            type: 'number'
        },
        SPEND_VARIABLE: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Simulation_Metrics_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Simulation]: {
            foreignKey: 'WB_SIMULATION_ID',
            foreignKeyImmutable: true,
            localField: 'Simulation'
        },
        [PASchema.esWB_CBO]: { foreignKey: 'WB_CBO_ID', foreignKeyImmutable: true, localField: 'CBO' },
        [PASchema.esWB_ScnPlan]: { foreignKey: 'WB_SCNPLAN_ID', foreignKeyImmutable: true, localField: 'ScnPlan' },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        },
        [PASchema.esWB_Period]: { foreignKey: 'WB_PERIOD_ID', foreignKeyImmutable: true, localField: 'Period' }
    },
    hasMany: {
        [PASchema.esWB_Simulation_Metrics_CBO_Set]: {
            foreignKey: 'WB_SIMMT_ID',
            foreignKeyImmutable: true,
            localField: 'CBOSets'
        }
    }
}

export const WB_Simulation_Metrics_CBO_Set = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Simulation_Metrics_CBO_Set', // optional
    description: 'Schema for WB_SimMtSR Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SIMMTSR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_SIMMT_ID: {
            type: 'number'
        },
        WB_CBO_SET_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Simulation_Metrics_CBO_Set_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Simulation_Metrics]: {
            foreignKey: 'WB_SIMMT_ID',
            foreignKeyImmutable: true,
            localField: 'Metrics'
        },
        [PASchema.esWB_CBO_Set]: { foreignKey: 'WB_CBO_SET_ID', foreignKeyImmutable: true, localField: 'CBOSet' }
    }
}

export const WB_Simulation_Spend_Metrics = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Simulation_Spend_Metrics', // optional
    description: 'Schema for WB_SimSMt Records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_SIMSMT_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_SIMULATION_ID: {
            type: 'number'
        },
        WB_CBO_ID: {
            type: 'number'
        },
        WB_SCNPLAN_ID: {
            type: 'number'
        },
        WB_SIMMT_ID_PRNT: {
            type: 'number'
        },
        WB_SCNPLANNER_ID: {
            type: 'number'
        },
        WB_SCNPLANNERTRIAL_ID: {
            type: 'number'
        },
        WB_SCNPLANNERTRIALEVT_ID: {
            type: 'number'
        },
        WB_SPEND_FUNCTIONR_ID: {
            type: 'number'
        },
        SUMMARY_LEVEL: {
            type: 'string',
            length: 50
        },
        WB_CUST_ID: {
            type: 'number'
        },
        WB_PRDGRP_ID: {
            type: 'number'
        },
        WB_PROD_ID: {
            type: 'number'
        },
        WB_PERIOD_ID: {
            type: 'number'
        },
        SPEND_AMT: {
            type: 'number'
        },
        VOLUME_BASIS_QTY: {
            type: 'number'
        },
        CNS_TOTAL_UNITS: {
            type: 'number'
        },
        CNS_TOTAL_LISTSLS: {
            type: 'number'
        },
        CNS_TOTAL_NETLISTSLS: {
            type: 'number'
        },
        SHIP_UNITS: {
            type: 'number'
        },
        SHIP_LISTSLS: {
            type: 'number'
        },
        SHIP_NETLISTSLS: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Simulation_Spend_Metrics_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Simulation]: {
            foreignKey: 'WB_SIMULATION_ID',
            foreignKeyImmutable: true,
            localField: 'Simulation'
        },
        [PASchema.esWB_CBO]: { foreignKey: 'WB_CBO_ID', foreignKeyImmutable: true, localField: 'CBO' },
        [PASchema.esWB_ScnPlan]: { foreignKey: 'WB_SCNPLAN_ID', foreignKeyImmutable: true, localField: 'ScnPlan' },
        [PASchema.esWB_Spend_Function_Relationship]: {
            foreignKey: 'WB_SPEND_FUNCTIONR_ID',
            foreignKeyImmutable: true,
            localField: 'SpendFunctionR'
        },
        [PASchema.esWB_Customer]: { foreignKey: 'WB_CUST_ID', foreignKeyImmutable: true, localField: 'Customer' },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID',
            foreignKeyImmutable: true,
            localField: 'Product'
        },
        [PASchema.esWB_Period]: { foreignKey: 'WB_PERIOD_ID', foreignKeyImmutable: true, localField: 'Period' }
    }
}

//Power Metric
export const WB_Power_Metric = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_PowerMetric', // optional
    description: 'Schema for WB_Model_PowerMetric records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_POWERMETRIC_ID: {
            type: 'number',
            id: true,
            required: true
        },
        POWERMETRIC_ID: {
            type: 'string',
            length: 50
        },
        POWERMETRIC_NAME: {
            type: 'string',
            length: 256
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        WB_TREE_FOLDER_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Power_Metric_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Power_Metric_Relationship]: {
            foreignKey: 'WB_MODEL_POWERMETRIC_ID',
            foreignKeyImmutable: true,
            localField: 'PowerMetricRels'
        }
    }
}

export const WB_Power_Metric_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Model_PowerMetric', // optional
    description: 'Schema for WB_Model_PowerMetric records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_MODEL_POWERMETRICR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_MODEL_POWERMETRIC_ID: {
            type: 'number'
        },
        WB_MODEL_PREDICTOR_ID: {
            type: 'number'
        },
        WB_MODEL_FUNCTION_ID: {
            type: 'number'
        },
        DEFAULT_WEIGHT: {
            type: 'number'
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_Power_Metric_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Power_Metric]: {
            foreignKey: 'WB_MODEL_POWERMETRIC_ID',
            foreignKeyImmutable: true,
            localField: 'PowerMetric'
        },
        [PASchema.esWB_Model_Predictor]: {
            foreignKey: 'WB_MODEL_PREDICTOR_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        },
        [PASchema.esWB_Model_Function]: {
            foreignKey: 'WB_MODEL_FUNCTION_ID',
            foreignKeyImmutable: true,
            localField: 'ModelFunction'
        }
    }
}

///Lift Calculations
export const WB_LiftAPI = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'Schedule', // optional
    description: 'Schema for Schedule records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_LIFTAPI_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_SALESORG_ID: {
            type: 'number'
        },
        WB_PUBLISHED_MODEL_ID: {
            type: 'number'
        },
        CALLER_ID: {
            type: 'string',
            length: 50
        },
        EXTERNAL_ID: {
            type: 'string',
            length: 20
        },
        MANUAL_IND: {
            type: 'string',
            length: 1
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})
export const WB_LiftAPI_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_SalesOrg]: {
            foreignKey: 'WB_SALESORG_ID',
            foreignKeyImmutable: true,
            localField: 'PowerMetric'
        },
        [PASchema.esWB_Published_Model]: {
            foreignKey: 'WB_PUBLISHED_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'ModelPredictor'
        }
    }
}

// Reference by mapper

_.defaults(dctSchemaByEntitySet, {
    [PASchema.esWB_AffinityGroup]: WB_AffinityGroup,
    [PASchema.esWB_AffinityGroupItem]: WB_AffinityGroupItem,
    [PASchema.esWB_AffinitySet]: WB_AffinitySet,
    [PASchema.esWB_Cannibalization_Set]: WB_Cannibalization_Set,
    [PASchema.esWB_Cannibalization_Set_Customer]: WB_Cannibalization_Set_Customer,
    [PASchema.esWB_Cannibalization_Set_Product]: WB_Cannibalization_Set_Product,
    [PASchema.esWB_Cannibalization_Set_Product_Group]: WB_Cannibalization_Set_Product_Group,
    [PASchema.esWB_LiftAPI]: WB_LiftAPI,
    [PASchema.esWB_Model]: WB_Model,
    [PASchema.esWB_Model_Coefficient]: WB_Model_Coefficient,
    [PASchema.esWB_Model_Coeff_SetR]: WB_Model_Coeff_SetR,
    [PASchema.esWB_Model_Coeff_SetRR]: WB_Model_Coeff_SetRR,
    [PASchema.esWB_Model_Coeff_SetCR]: WB_Model_Coeff_SetCR,
    [PASchema.esWB_Model_Coeff_Set]: WB_Model_Coeff_Set,
    [PASchema.esWB_Model_Coeff_Set_Rule]: WB_Model_Coeff_Set_Rule,
    [PASchema.esWB_Model_Coeff_SetPMR]: WB_Model_Coeff_SetPMR,
    [PASchema.esWB_Model_Coeff_SetASR]: WB_Model_Coeff_SetASR,
    [PASchema.esWB_Model_Coeff_SetTR]: WB_Model_Coeff_SetTR,
    [PASchema.esWB_Model_Profile]: WB_Model_Profile,
    [PASchema.esWB_Model_Profile_Predictor]: WB_Model_Profile_Predictor,
    [PASchema.esWB_Model_Profile_Group]: WB_Model_Profile_Group,
    [PASchema.esWB_Model_Profile_Group_Predictor]: WB_Model_Profile_Group_Predictor,
    [PASchema.esWB_Model_Profile_Spend_Function]: WB_Model_Profile_Spend_Function,
    [PASchema.esWB_Model_DataSource]: WB_Model_DataSource,
    [PASchema.esWB_Model_Function]: WB_Model_Function,
    [PASchema.esWB_Model_Input]: WB_Model_Input,
    [PASchema.esWB_Model_Predictor_Relationship]: WB_Model_Predictor_Relationship,
    [PASchema.esWB_Model_Predictor]: WB_Model_Predictor,
    [PASchema.esWB_Model_Tag_Relationship]: WB_Model_Tag_Relationship,
    [PASchema.esWB_Model_Constant]: WB_Model_Constant,
    [PASchema.esWB_Model_Term]: WB_Model_Term,
    [PASchema.esWB_Model_Term_Relationship]: WB_Model_Term_Relationship,
    [PASchema.esWB_Model_Event_Type_Relationship]: WB_Model_Event_Type_Relationship,
    [PASchema.esWB_Model_Compare]: WB_Model_Compare,
    [PASchema.esWB_Model_Compare_Relationship]: WB_Model_CompareR,
    [PASchema.esWB_Model_Volume_Component]: WB_Model_Volume_Component,
    [PASchema.esWB_Model_Volume_ComponentR]: WB_Model_Volume_Component_Relationship,
    [PASchema.esWB_Model_Volume_Component_ItemR]: WB_Model_Volume_Component_ItemR,
    [PASchema.esWB_Model_Cannibalization_Type]: WB_Model_Cannibalization_Type,
    [PASchema.esWB_Model_Cannibalization_Relationship]: WB_Model_Cannibalization_Relationship,
    [PASchema.esWB_Model_Cannibalization_Const_Relationship]: WB_Model_Cannibalization_Const_Relationship,
    [PASchema.esWB_Model_Cannibalization_Term_Relationship]: WB_Model_Cannibalization_Term_Relationship,
    [PASchema.esWB_Modeling_Session]: WB_Modeling_Session,
    [PASchema.esWB_Modeling_Session_Stage]: WB_Modeling_Session_Stage,
    [PASchema.esWB_Modeling_Session_StageAlgorithm]: WB_Modeling_Session_StageAR,
    [PASchema.esWB_Modeling_Session_StageCoeffRangePolicy]: WB_Modeling_Session_StageCRP,
    [PASchema.esWB_Modeling_Session_StageCoeffRangePolicyR]: WB_Modeling_Session_StageCRPR,
    [PASchema.esWB_Modeling_Session_StageCoeffRangePolicyMeta]: WB_Modeling_Session_StageCRP_Meta,
    [PASchema.esWB_Modeling_Session_Coeff_Rule]: WB_Modeling_Session_Coeff_Rule,
    [PASchema.esWB_Modeling_Session_Coeff_RuleR]: WB_Modeling_Session_Coeff_RuleR,
    [PASchema.esWB_Modeling_Session_Coeff_Grp]: WB_Modeling_Session_Coeff_Grp,
    [PASchema.esWB_Modeling_Session_Coeff_GrpSt]: WB_Modeling_Session_Coeff_GrpSt,
    [PASchema.esWB_Modeling_Session_Coeff_GrpStR]: WB_Modeling_Session_Coeff_GrpStR,
    [PASchema.esWB_Modeling_Session_CustR]: WB_Modeling_Session_CustR,
    [PASchema.esWB_Modeling_Session_Log]: WB_Modeling_Session_Log,
    [PASchema.esWB_Modeling_Session_ProdR]: WB_Modeling_Session_ProdR,
    [PASchema.esWB_Modeling_Session_Range]: WB_Modeling_Session_Range,
    [PASchema.esWB_Modeling_Session_Trial_Residual_Metric]: WB_Modeling_Session_Trial_Rsd_Metric,
    [PASchema.esWB_Modeling_Session_Trial]: WB_Modeling_Session_Trial,
    [PASchema.esWB_Modeling_Session_Trial_Metric]: WB_Modeling_Session_Trial_Metric,
    [PASchema.esWB_Modeling_Session_Trial_PredictorR_Metric]: WB_Modeling_Session_Trial_PredR_Metric,
    [PASchema.esWB_Modeling_Session_Trial_PartitionStage]: WB_Modeling_Session_TrialPartitionStage,
    [PASchema.esWB_Modeling_Session_Trial_PartitionStageS]: WB_Modeling_Session_TrialPartitionStageS,
    [PASchema.esWB_Modeling_Session_Trial_PartitionStageSL]: WB_Modeling_Session_TrialPartitionStageSL,
    [PASchema.esWB_Modeling_Session_Observation]: WB_Modeling_Session_Observation,
    [PASchema.esWB_Modeling_Session_Tag_RuleR]: WB_Modeling_Session_Tag_RuleR,
    [PASchema.esWB_Modeling_SessionPR]: WB_Modeling_SessionPR,
    [PASchema.esWB_Modeling_Session_El]: WB_Modeling_Session_El,
    [PASchema.esWB_Modeling_Session_ElR]: WB_Modeling_Session_ElR,
    [PASchema.esWB_Modeling_Session_ElCR]: WB_Modeling_Session_ElCR,
    [PASchema.esWB_Modeling_Session_TermR]: WB_Modeling_Session_TermR,
    [PASchema.esWB_Modeling_Session_ConstantR]: WB_Modeling_Session_ConstantR,
    [PASchema.esWB_Modeling_Session_ConstantFR]: WB_Modeling_Session_ConstantFR,
    [PASchema.esWB_Modeling_Session_SeasonalityMt]: WB_Modeling_Session_SeasonalityMt,
    [PASchema.esWB_Modeling_Session_Seasonality_DepMt]: WB_Modeling_Session_Seasonality_DepMt,
    [PASchema.esWB_Modeling_Session_Seasonality_Coeff]: WB_Modeling_Session_Seasonality_Coeff,
    [PASchema.esWB_Model_Coeff_SetConstR]: WB_Model_Coeff_SetConstR,
    [PASchema.esWB_Published_Model]: WB_Published_Model,
    [PASchema.esWB_ScnPlan]: WB_Scenario_Plan,
    [PASchema.esWB_ScnPlan_EvtTypeR]: WB_Scenario_Plan_EventType,
    [PASchema.esWB_ScnPlan_CustR]: WB_Scenario_Plan_Customer,
    [PASchema.esWB_ScnPlan_PrdR]: WB_Scenario_Plan_Product,
    [PASchema.esWB_ScnPlan_PredictorR]: WB_Scenario_Plan_Predictor,
    [PASchema.esWB_ScnPlan_InputR]: WB_Scenario_Plan_Input,
    [PASchema.esWB_ScnPlan_CoeffR]: WB_Scenario_Plan_Coefficient,

    [PASchema.esWB_ScnPlanner]: WB_ScnPlanner,
    [PASchema.esWB_ScnPlannerCalc]: WB_ScnPlannerCalc,
    [PASchema.esWB_ScnPlannerCalcLog]: WB_ScnPlannerCalcLog,
    [PASchema.esWB_ScnPlannerCnstr]: WB_ScnPlannerCnstr,
    [PASchema.esWB_ScnPlannerCR]: WB_ScnPlannerCR,
    [PASchema.esWB_ScnPlannerESR]: WB_ScnPlannerESR,
    [PASchema.esWB_ScnPlannerPPR]: WB_ScnPlannerPPR,
    [PASchema.esWB_ScnPlannerPR]: WB_ScnPlannerPR,
    [PASchema.esWB_ScnPlannerPrdPR]: WB_ScnPlannerPrdPR,
    [PASchema.esWB_ScnPlannerPrdPPR]: WB_ScnPlannerPrdPPR,
    [PASchema.esWB_ScnPlannerPrmR]: WB_ScnPlannerPrmR,
    [PASchema.esWB_ScnPlannerTrial]: WB_ScnPlannerTrial,
    [PASchema.esWB_ScnPlannerTrialPR]: WB_ScnPlannerTrialPR,
    [PASchema.esWB_ScnPlannerTrialCNR]: WB_ScnPlannerTrialCNR,
    [PASchema.esWB_ScnPlannerTrialEvt]: WB_ScnPlannerTrialEvt,

    [PASchema.esWB_ScnConstraint]: WB_ScnConstraint,

    [PASchema.esWB_Simulation_Input]: WB_Simulation_Input,

    [PASchema.esWB_Simulation_Input_Relationship]: WB_Simulation_Input_Relationship,
    [PASchema.esWB_Simulation]: WB_Simulation,
    [PASchema.esWB_Simulation_Relationship]: WB_Simulation_Relationship,
    [PASchema.esWB_Simulation_Predictor_Relationship]: WB_Simulation_Predictor_Relationship,
    [PASchema.esWB_Simulation_Product]: WB_Simulation_Product,
    [PASchema.esWB_Model_API_Log]: WB_Model_API_Log,
    [PASchema.esWB_CBO]: WB_CBO,
    [PASchema.esWB_CBO_Input_Relationship]: WB_CBO_Input_Relationship,
    [PASchema.esWB_CBO_Set]: WB_CBO_SET,
    [PASchema.esWB_CBO_Set_Item]: WB_CBO_SET_ITEM,
    [PASchema.esWB_CBO_Set_Predictor]: WB_CBO_SET_PR,
    [PASchema.esWB_CBO_Constraint]: WB_CBO_Constraint,
    [PASchema.esWB_Spend_Function]: WB_Spend_Function,
    [PASchema.esWB_Spend_Function_Input_Relationship]: WB_Spend_Function_Input_Relationship,
    [PASchema.esWB_Spend_Function_Term_Relationship]: WB_Spend_Function_Term_Relationship,
    [PASchema.esWB_Spend_Function_Relationship]: WB_Spend_Function_Relationship,
    [PASchema.esWB_Spend_Function_Relationship_Scope]: WB_Spend_Function_Relationship_Scope,
    [PASchema.esWB_Simulation_Metrics]: WB_Simulation_Metrics,
    [PASchema.esWB_Simulation_Metrics_CBO_Set]: WB_Simulation_Metrics_CBO_Set,
    [PASchema.esWB_Simulation_Spend_Metrics]: WB_Simulation_Spend_Metrics,
    [PASchema.esWB_Power_Metric]: WB_Power_Metric,
    [PASchema.esWB_Power_Metric_Relationship]: WB_Power_Metric_Relationship,
    [PASchema.esWB_Modeling_Session_Reference_Predictor_Relationship]:
    WB_Modeling_Session_Reference_Predictor_Relationship,
    [PASchema.esWB_Modeling_Session_Reference_Relationship]: WB_Modeling_Session_Reference_Relationship,
    [PASchema.esWB_Modeling_Session_Cannibalization_Type_Relationship]:
    WB_Modeling_Session_Cannibalization_Type_Relationship,
    [PASchema.esWB_Modeling_Session_AffinitySet_Relationship]: WB_Modeling_Session_AffinitySet_Relationship,
    [PASchema.esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship]:
    WB_Modeling_Session_Cannibalization_Power_Metric_Relationship
})

// These tables need to be moved into the JSData Schemas
_.defaults(dctTableNameByEntitySet, {
    [PASchema.esWB_AffinityGroup]: '/AZR/WB_AFFINITYGROUP',
    [PASchema.esWB_AffinityGroupItem]: '/AZR/WB_AFFINITYGROUPITEM',
    [PASchema.esWB_AffinitySet]: '/AZR/WB_AFFINITYSET',
    [PASchema.esWB_Cannibalization_Set]: '/AZR/WB_CANN',
    [PASchema.esWB_Cannibalization_Set_Customer]: '/AZR/WB_CANNCST',
    [PASchema.esWB_Cannibalization_Set_Product]: '/AZR/WB_CANNPRD',
    [PASchema.esWB_Cannibalization_Set_Product_Group]: '/AZR/WB_CANNPG',
    [PASchema.esWB_LiftAPI]: '/AZR/WB_LIFTAPI',
    [PASchema.esWB_Model]: '/AZR/WB_MODEL',
    [PASchema.esWB_Model_Coefficient]: '/AZR/WB_MODEL_COEFFICIENT',
    [PASchema.esWB_Model_Coeff_SetR]: '/AZR/WB_MODEL_COEFF_SETR',
    [PASchema.esWB_Model_Coeff_SetRR]: '/AZR/WB_MODEL_COEFF_SETRR',
    [PASchema.esWB_Model_Coeff_SetCR]: '/AZR/WB_MODEL_COEFF_SETCR',
    [PASchema.esWB_Model_Coeff_SetASR]: '/AZR/WB_MODEL_COEFF_SETASR',
    [PASchema.esWB_Model_Coeff_SetPMR]: '/AZR/WB_MODEL_COEFF_SETPMR',
    [PASchema.esWB_Model_Coeff_SetTR]: '/AZR/WB_MODEL_COEFF_SETTR',
    [PASchema.esWB_Model_Coeff_Set]: '/AZR/WB_MODEL_COEFF_SET',
    [PASchema.esWB_Model_Coeff_Set_Rule]: '/AZR/WB_MODEL_COEFF_SET_RULE',
    [PASchema.esWB_Model_Profile]: '/AZR/WB_MODEL_PROFILE',
    [PASchema.esWB_Model_Profile_Predictor]: '/AZR/WB_MODEL_PROFILEPR',
    [PASchema.esWB_Model_Profile_Group]: '/AZR/WB_MODEL_PROFILEGR',
    [PASchema.esWB_Model_Profile_Group_Predictor]: '/AZR/WB_MODEL_PROFILEGPR',
    [PASchema.esWB_Model_Profile_Spend_Function]: '/AZR/WB_MODEL_PROFILESFR',
    [PASchema.esWB_Model_DataSource]: '/AZR/WB_MODEL_DATASOURCE',
    [PASchema.esWB_Model_Function]: '/AZR/WB_MODEL_FUNCTION',
    [PASchema.esWB_Model_Input]: '/AZR/WB_MODEL_INPUT',
    [PASchema.esWB_Model_Predictor_Relationship]: '/AZR/WB_MODEL_PREDICTORR',
    [PASchema.esWB_Model_Predictor]: '/AZR/WB_MODEL_PREDICTOR',
    [PASchema.esWB_Model_Tag_Relationship]: '/AZR/WB_MODEL_TAGR',
    [PASchema.esWB_Model_Constant]: '/AZR/WB_MODEL_CONSTANT',
    [PASchema.esWB_Model_Term]: '/AZR/WB_MODEL_TERM',
    [PASchema.esWB_Model_Term_Relationship]: '/AZR/WB_MODEL_TERMR',
    [PASchema.esWB_Model_Event_Type_Relationship]: '/AZR/WB_MODEL_EVTTYPER',
    [PASchema.esWB_Model_Compare]: '/AZR/WB_MODEL_COMPARE',
    [PASchema.esWB_Model_Compare_Relationship]: '/AZR/WB_MODEL_COMPARER',
    [PASchema.esWB_Model_Volume_Component]: '/AZR/WB_MODEL_VOLUME_COMPONENT',
    [PASchema.esWB_Model_Volume_ComponentR]: '/AZR/WB_MODEL_VOLUME_COMPONENTR',
    [PASchema.esWB_Model_Volume_Component_ItemR]: '/AZR/WB_MODEL_VOLUME_COMPONENT_ITEMR',
    [PASchema.esWB_Model_Cannibalization_Type]: '/AZR/WB_MODEL_CANNIBALIZATIONM',
    [PASchema.esWB_Model_Cannibalization_Relationship]: '/AZR/WB_MODEL_CANNR',
    [PASchema.esWB_Model_Cannibalization_Const_Relationship]: '/AZR/WB_MODEL_CANNCR',
    [PASchema.esWB_Model_Cannibalization_Term_Relationship]: '/AZR/WB_MODEL_CANNTERMR',
    [PASchema.esWB_Modeling_Session]: '/AZR/WB_MODELING_SESSION',
    [PASchema.esWB_Modeling_Session_Stage]: '/AZR/WB_MODELING_SESSION_STAGE',
    [PASchema.esWB_Modeling_Session_StageAlgorithm]: '/AZR/WB_MODELING_SESSION_STAGEAR',
    [PASchema.esWB_Modeling_Session_StageCoeffRangePolicy]: '/AZR/WB_MODELING_SESSION_STAGECRP',
    [PASchema.esWB_Modeling_Session_StageCoeffRangePolicyR]: '/AZR/WB_MODELING_SESSION_STAGECRPR',
    [PASchema.esWB_Modeling_Session_StageCoeffRangePolicyMeta]: '/AZR/WB_MODELING_SESSION_STAGECRP_META',
    [PASchema.esWB_Modeling_Session_Coeff_Rule]: '/AZR/WB_MODELING_SESSION_COEFF_RULE',
    [PASchema.esWB_Modeling_Session_Coeff_RuleR]: '/AZR/WB_MODELING_SESSION_COEFF_RULER',
    [PASchema.esWB_Modeling_Session_Coeff_Grp]: '/AZR/WB_MODELING_SESSION_COEFF_GRP',
    [PASchema.esWB_Modeling_Session_Coeff_GrpSt]: '/AZR/WB_MODELING_SESSION_COEFF_GRPST',
    [PASchema.esWB_Modeling_Session_Coeff_GrpStR]: '/AZR/WB_MODELING_SESSION_COEFF_GRPSTR',
    [PASchema.esWB_Modeling_Session_CustR]: '/AZR/WB_MODELING_SESSION_CUSTR',
    [PASchema.esWB_Modeling_Session_Log]: '/AZR/WB_MODELING_SESSION_LOG',
    [PASchema.esWB_Modeling_Session_ProdR]: '/AZR/WB_MODELING_SESSION_PRODR',
    [PASchema.esWB_Modeling_Session_Range]: '/AZR/WB_MODELING_SESSION_RANGE',
    [PASchema.esWB_Modeling_Session_Trial_Residual_Metric]: '/AZR/WB_MODELING_SESSION_TRIALRSDMT',
    [PASchema.esWB_Modeling_Session_Trial]: '/AZR/WB_MODELING_SESSION_TRIAL',
    [PASchema.esWB_Modeling_Session_Trial_Metric]: '/AZR/WB_MODELING_SESSION_TRIALMT',
    [PASchema.esWB_Modeling_Session_Trial_PartitionStage]: '/AZR/WB_MODELING_SESSION_TRIALPS',
    [PASchema.esWB_Modeling_Session_Trial_PartitionStageS]: '/AZR/WB_MODELING_SESSION_TRIALPSS',
    [PASchema.esWB_Modeling_Session_Trial_PartitionStageSL]: '/AZR/WB_MODELING_SESSION_TRIALPSSL',
    [PASchema.esWB_Modeling_Session_Observation]: '/AZR/WB_MODELING_SESSION_OBS',
    [PASchema.esWB_Modeling_Session_Tag_RuleR]: '/AZR/WB_MODELING_SESSION_TAG_RULER',
    [PASchema.esWB_Modeling_SessionPR]: '/AZR/WB_MODELING_SESSIONPR',
    [PASchema.esWB_Modeling_Session_El]: '/AZR/WB_MODELING_SESSION_EL',
    [PASchema.esWB_Modeling_Session_ElR]: '/AZR/WB_MODELING_SESSION_ELR',
    [PASchema.esWB_Modeling_Session_ElCR]: '/AZR/WB_MODELING_SESSION_ELCR',
    [PASchema.esWB_Modeling_Session_TermR]: '/AZR/WB_MODELING_SESSION_TERMR',
    [PASchema.esWB_Modeling_Session_ConstantR]: '/AZR/WB_MODELING_SESSION_CONSTANTR',
    [PASchema.esWB_Modeling_Session_ConstantFR]: '/AZR/WB_MODELING_SESSION_CONSTANTFR',
    [PASchema.esWB_Modeling_Session_SeasonalityMt]: '/AZR/WB_MODELING_SESSION_SEASONALITYMT',
    [PASchema.esWB_Modeling_Session_Seasonality_DepMt]: '/AZR/WB_MODELING_SESSION_SEASONALITY_DEPMT',
    [PASchema.esWB_Modeling_Session_Seasonality_Coeff]: '/AZR/WB_MODELING_SESSION_SEASONALITY_COEFF',
    [PASchema.esWB_Model_Coeff_SetConstR]: '/AZR/WB_MODEL_COEFF_SETCONSTR',
    [PASchema.esWB_Published_Model]: '/AZR/WB_PUBLISHED_MODEL',
    [PASchema.esWB_Simulation_Input]: '/AZR/WB_SIMULATION_INPUT',
    [PASchema.esWB_Simulation]: '/AZR/WB_SIMULATION',
    [PASchema.esWB_Simulation_Relationship]: '/AZR/WB_SIMULATIONSR',
    [PASchema.esWB_Simulation_Input_Relationship]: '/AZR/WB_SIMULATION_INPUTR',
    [PASchema.esWB_Simulation_Predictor_Relationship]: '/AZR/WB_SIMULATION_PREDICTORR',
    [PASchema.esWB_Simulation_Product]: '/AZR/WB_SIMULATION_PRD',
    [PASchema.esWB_ScnPlan]: '/AZR/WB_SCNPLAN',
    [PASchema.esWB_ScnPlan_EvtTypeR]: '/AZR/WB_SCNPLAN_EVTTYPER',
    [PASchema.esWB_ScnPlan_CustR]: '/AZR/WB_SCNPLAN_CUSTR',
    [PASchema.esWB_ScnPlan_PrdR]: '/AZR/WB_SCNPLAN_PRDR',
    [PASchema.esWB_ScnPlan_PredictorR]: '/AZR/WB_SCNPLAN_PREDICTORR',
    [PASchema.esWB_ScnPlan_InputR]: '/AZR/WB_SCNPLAN_INPUTR',
    [PASchema.esWB_ScnPlan_CoeffR]: '/AZR/WB_SCNPLAN_COEFFR',

    [PASchema.esWB_ScnPlanner]: '/AZR/WB_SCNPLANNER',
    [PASchema.esWB_ScnPlannerCalc]: '/AZR/WB_SCNPLANNERCALC',
    [PASchema.esWB_ScnPlannerCalcLog]: '/AZR/WB_SCNPLANNERCALCLOG',
    [PASchema.esWB_ScnPlannerCnstr]: '/AZR/WB_SCNPLANNERCNSTR',
    [PASchema.esWB_ScnPlannerCR]: '/AZR/WB_SCNPLANNERCR',
    [PASchema.esWB_ScnPlannerESR]: '/AZR/WB_SCNPLANNERESR',
    [PASchema.esWB_ScnPlannerPPR]: '/AZR/WB_SCNPLANNERPPR',
    [PASchema.esWB_ScnPlannerPR]: '/AZR/WB_SCNPLANNERPR',
    [PASchema.esWB_ScnPlannerPrdPR]: '/AZR/WB_SCNPLANNERPRDPR',
    [PASchema.esWB_ScnPlannerPrdPPR]: '/AZR/WB_SCNPLANNERPRDPPR',
    [PASchema.esWB_ScnPlannerPrmR]: '/AZR/WB_SCNPLANNERPRMR',
    [PASchema.esWB_ScnPlannerTrial]: '/AZR/WB_SCNPLANNERTRIAL',
    [PASchema.esWB_ScnPlannerTrialPR]: '/AZR/WB_SCNPLANNERTRIALPR',
    [PASchema.esWB_ScnPlannerTrialCNR]: '/AZR/WB_SCNPLANNERTRIALCNR',
    [PASchema.esWB_ScnPlannerTrialEvt]: '/AZR/WB_SCNPLANNERTRIALEVT',

    [PASchema.esWB_ScnConstraint]: '/AZR/WB_SCNCONSTRAINTM',

    [PASchema.esWB_Model_API_Log]: '/AZR/WB_MODEL_API_LOG',
    [PASchema.esWB_CBO]: '/AZR/WB_CBO',
    [PASchema.esWB_CBO_Set]: '/AZR/WB_CBO_SET',
    [PASchema.esWB_CBO_Set_Item]: '/AZR/WB_CBO_SET_ITEM',
    [PASchema.esWB_CBO_Set_Predictor]: '/AZR/WB_CBO_SET_PR',
    [PASchema.esWB_CBO_Input_Relationship]: '/AZR/WB_CBO_INPUTR',
    [PASchema.esWB_CBO_Constraint]: '/AZR/WB_CBO_CSTR',
    [PASchema.esWB_Spend_Function]: '/AZR/WB_SPEND_FUNCTION',
    [PASchema.esWB_Spend_Function_Input_Relationship]: '/AZR/WB_SPEND_FUNCTION_INPUTR',
    [PASchema.esWB_Spend_Function_Term_Relationship]: '/AZR/WB_SPEND_FUNCTION_TERMR',
    [PASchema.esWB_Spend_Function_Relationship]: '/AZR/WB_SPEND_FUNCTIONR',
    [PASchema.esWB_Spend_Function_Relationship_Scope]: '/AZR/WB_SPEND_FUNCTIONCPR',
    [PASchema.esWB_Simulation_Metrics]: '/AZR/WB_SIMMT',
    [PASchema.esWB_Simulation_Metrics_CBO_Set]: '/AZR/WB_SIMMTSR',
    [PASchema.esWB_Simulation_Spend_Metrics]: '/AZR/WB_SIMSMT',
    [PASchema.esWB_Power_Metric]: '/AZR/WB_MODEL_POWERMETRIC',
    [PASchema.esWB_Power_Metric_Relationship]: '/AZR/WB_MODEL_POWERMETRICR',
    [PASchema.esWB_Modeling_Session_Reference_Predictor_Relationship]: '/AZR/WB_MODELING_SESSION_REFPR',
    [PASchema.esWB_Modeling_Session_Reference_Relationship]: '/AZR/WB_MODELING_SESSION_REFR',
    [PASchema.esWB_Modeling_Session_Cannibalization_Type_Relationship]: '/AZR/WB_MODELING_SESSION_CANNMR',
    [PASchema.esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship]: '/AZR/WB_MODELING_SESSION_CANNPMR',
    [PASchema.esWB_Modeling_Session_AffinitySet_Relationship]: '/AZR/WB_MODELING_SESSION_ASR',
    [PASchema.esWB_Modeling_Session_Trial_Predictor_Metric]: '/AZR/WB_MODELING_SESSION_TRIAL_PMT',
    [PASchema.esWB_Modeling_Session_Trial_PredictorR_Metric]: '/AZR/WB_MODELING_SESSION_TRIAL_PRMT'
})

// TODO: Complete logical keys for metadata export
_.defaults(dctLogicalKeysByEntitySet, {
    [PASchema.esWB_AffinitySet]: ['AFFINITYSET_ID'],
    [PASchema.esWB_AffinityGroup]: ['AFFINITYGROUP_ID', 'WB_AFFINITYSET_ID'],
    [PASchema.esWB_AffinityGroupItem]: ['WB_AFFINITYGROUP_ID', 'WB_CUST_ID', 'WB_PROD_ID', 'WB_PRDGRP_ID'],
    [PASchema.esWB_LiftAPI]: [],
    [PASchema.esWB_Model]: ['MODEL_ID'],
    [PASchema.esWB_Model_Coefficient]: ['MODEL_COEFFICIENT_ID'],
    [PASchema.esWB_Model_Coeff_Set]: ['MODEL_COEFF_SET_ID', 'WB_MODEL_ID'],
    [PASchema.esWB_Model_Input]: ['MODEL_INPUT_ID'],
    [PASchema.esWB_Model_Constant]: ['CONSTANT_ID'],
    [PASchema.esWB_Model_DataSource]: ['DATASOURCE_ID'],
    [PASchema.esWB_Modeling_Session]: ['MODELING_SESSION_ID', 'WB_MODEL_ID'],
    [PASchema.esWB_Modeling_Session_Coeff_Rule]: ['WB_MODELING_SESSION_ID', 'WB_MODEL_COEFFICIENT_ID', 'RULE_ID'],
    [PASchema.esWB_Modeling_Session_Coeff_RuleR]: [
        'WB_MODELING_SESSION_COEFF_RULE_ID',
        'WB_CUST_ID',
        'WB_PRDGRP_ID',
        'WB_PROD_ID'
    ],
    [PASchema.esWB_Modeling_Session_Coeff_Grp]: [
        'WB_MODELING_SESSION_ID',
        'WB_MODEL_COEFFICIENT_ID',
        'GROUP_NAME',
        'GROUP_META_ID'
    ],
    [PASchema.esWB_Modeling_Session_Coeff_GrpSt]: ['WB_MODELING_SESSION_COEFF_GRP_ID', 'CUSTOMER_NAME', 'PRODUCT_NAME'],
    [PASchema.esWB_Modeling_Session_Coeff_GrpStR]: [
        'WB_MODELING_SESSION_COEFF_GRPST_ID',
        'WB_CUST_ID',
        'WB_PRDGRP_ID',
        'WB_PROD_ID'
    ],
    [PASchema.esWB_Modeling_Session_CustR]: ['WB_MODELING_SESSION_ID', 'WB_CUST_ID'],
    [PASchema.esWB_Modeling_Session_ProdR]: ['WB_MODELING_SESSION_ID', 'WB_PRDGRP_ID'],
    [PASchema.esWB_Modeling_Session_Log]: ['WB_MODELING_SESSION_ID', 'WB_MODELING_SESSION_TRIAL_ID'],
    [PASchema.esWB_Modeling_Session_Trial]: ['WB_MODELING_SESSION_ID', 'WB_MODEL_COEFF_SET_ID'],
    [PASchema.esWB_Modeling_Session_Trial_Metric]: [
        'WB_MODELING_SESSION_TRIAL_ID',
        'WB_CUST_ID',
        'WB_PRDGRP_ID',
        'WB_PERIOD_ID'
    ],
    [PASchema.esWB_Modeling_Session_Trial_Residual_Metric]: [
        'WB_MODELING_SESSION_TRIAL_ID',
        'WB_MODEL_PREDICTOR_ID',
        'WB_CUST_ID',
        'WB_PRDGRP_ID',
        'WB_PERIOD_ID'
    ],
    [PASchema.esWB_Modeling_Session_Trial_PredictorR_Metric]: [
        'WB_MODELING_SESSION_TRIAL_ID',
        'WB_MODEL_PREDICTOR_ID_A',
        'WB_MODEL_PREDICTOR_ID_B',
        'WB_CUST_ID',
        'WB_PRDGRP_ID'
    ],
    [PASchema.esWB_Modeling_Session_Range]: ['WB_MODELING_SESSION_ID', 'WB_MODEL_COEFFICIENT_ID'],
    [PASchema.esWB_Modeling_Session_Observation]: [
        'WB_MODELING_SESSION_ID',
        'WB_MODELING_SESSION_TRIAL_ID',
        'WB_CUST_ID'
    ],
    [PASchema.esWB_Modeling_Session_Tag_RuleR]: ['WB_MODELING_SESSION_ID', 'WB_TAG_ID'],
    [PASchema.esWB_Modeling_SessionPR]: [
        'WB_MODELING_SESSION_ID',
        'WB_CUST_ID',
        'WB_PRDGRP_ID',
        'WB_PERIOD_ID',
        'WB_PROD_ID'
    ],
    [PASchema.esWB_Modeling_Session_El]: [],
    [PASchema.esWB_Modeling_Session_ElR]: [],
    [PASchema.esWB_Modeling_Session_ElCR]: [],
    [PASchema.esWB_Modeling_Session_TermR]: [],
    [PASchema.esWB_Modeling_Session_ConstantR]: [],
    [PASchema.esWB_Modeling_Session_ConstantFR]: [],
    [PASchema.esWB_Modeling_Session_SeasonalityMt]: [],
    [PASchema.esWB_Modeling_Session_Seasonality_DepMt]: [],
    [PASchema.esWB_Modeling_Session_Seasonality_Coeff]: [],
    [PASchema.esWB_Model_Coeff_SetConstR]: [],
    [PASchema.esWB_Published_Model]: ['WB_MODEL_ID', 'WB_MODEL_COEFF_SET_ID'],
    [PASchema.esWB_Cannibalization_Set]: ['CANN_NAME', 'CANNIB_TYPE_ID'],
    [PASchema.esWB_Cannibalization_Set_Customer]: ['WB_CANN_ID', 'WB_CUST_ID'],
    [PASchema.esWB_Cannibalization_Set_Product_Group]: [],
    [PASchema.esWB_Cannibalization_Set_Product]: [],
    [PASchema.esWB_Model_Predictor]: ['MODEL_PREDICTOR_ID'],
    [PASchema.esWB_Model_Function]: ['MODEL_FUNCTION_ID'],
    [PASchema.esWB_Model_Term]: ['TERM_ID'],
    [PASchema.esWB_Model_Term_Relationship]: ['WB_MODEL_ID', 'WB_MODEL_TERM_ID'],
    [PASchema.esWB_Model_Event_Type_Relationship]: ['WB_MODEL_ID', 'TYPE_NAME'],
    [PASchema.esWB_Model_Compare]: [],
    [PASchema.esWB_Model_Compare_Relationship]: [],
    [PASchema.esWB_Model_Cannibalization_Type]: ['CANNIBALIZATION_TYPE_ID'],
    [PASchema.esWB_Model_Cannibalization_Relationship]: [
        'WB_MODEL_ID',
        'WB_MODEL_CANNIBALIZATIONM_ID',
        'WB_MODEL_FUNCTION_ID',
        'WB_MODEL_COEFFICIENT_ID',
        'WB_MODEL_COEFFICIENT_ID2',
        'WB_MODEL_POWERMETRIC_ID'
    ],
    [PASchema.esWB_Model_Cannibalization_Const_Relationship]: ['WB_MODEL_ID', 'WB_MODEL_CONSTANT_ID'],
    [PASchema.esWB_Model_Cannibalization_Term_Relationship]: ['WB_MODEL_CANNR_ID', 'WB_MODEL_TERM_ID'],
    [PASchema.esWB_Model_Predictor_Relationship]: ['WB_MODEL_PREDICTOR_ID', 'WB_MODEL_ID'],
    [PASchema.esWB_Model_Volume_Component]: ['VOLUME_COMPONENT_ID'],
    [PASchema.esWB_Model_Coeff_Set_Rule]: ['WB_MODEL_COEFF_SET_ID', 'WB_MODEL_TERM_ID'],
    [PASchema.esWB_Model_Coeff_SetR]: ['WB_MODEL_COEFF_SET_ID', 'WB_CUST_ID', 'WB_PRDGRP_ID', 'WB_PROD_ID'],
    [PASchema.esWB_Model_Coeff_SetRR]: [
        'WB_MODEL_COEFF_SET_ID',
        'WB_CUST_ID',
        'WB_PRDGRP_ID',
        'WB_PROD_ID',
        'WB_MODEL_PREDICTOR_ID'
    ],
    [PASchema.esWB_Model_Coeff_SetCR]: [
        'WB_MODEL_COEFF_SET_ID',
        'WB_MODEL_CANNIBALIZATIONM_ID',
        'WB_AFFINITYGROUP_ID_AGGR',
        'WB_AFFINITYGROUP_ID_VCTM'
    ],
    [PASchema.esWB_Model_Coeff_SetPMR]: [
        'WB_MODEL_COEFF_SET_ID',
        'WB_MODEL_CANNIBALIZATIONM_ID',
        'WB_MODEL_PREDICTOR_ID'
    ],
    [PASchema.esWB_Model_Coeff_SetASR]: ['WB_MODEL_COEFF_SET_ID', 'WB_AFFINITYSET_ID'],
    [PASchema.esWB_Model_Coeff_SetTR]: [
        'WB_MODEL_COEFF_SET_ID',
        'WB_CUST_ID',
        'WB_PRDGRP_ID',
        'WB_PROD_ID',
        'WB_MODEL_TERM_ID'
    ],
    [PASchema.esWB_Model_Volume_ComponentR]: ['WB_MODEL_ID', 'WB_MODEL_VOLUME_COMPONENT_ID'],
    [PASchema.esWB_Model_Volume_Component_ItemR]: [
        'WB_MODEL_VOLUME_COMPONENTR_ID',
        'WB_MODEL_PREDICTOR_ID',
        'WB_TAG_ID'
    ],
    [PASchema.esWB_Model_Tag_Relationship]: ['WB_MODEL_ID', 'WB_TAG_ID'],
    [PASchema.esWB_Simulation_Input]: ['SIMULATION_INPUT_ID'],
    [PASchema.esWB_Simulation]: ['WB_SIMULATIONM_ID', 'SIMULATION_ID'],
    [PASchema.esWB_Simulation_Input_Relationship]: ['WB_SIMULATION_ID', 'WB_PRDGRP_ID', 'WB_PERIOD_ID'],
    [PASchema.esWB_Simulation_Relationship]: ['WB_SIMULATION_ID', 'WB_SIMULATION_ID_REL'],
    [PASchema.esWB_Simulation_Predictor_Relationship]: ['WB_SIMULATION_ID', 'WB_PRDGRP_ID', 'WB_PERIOD_ID'],
    [PASchema.esWB_Simulation_Product]: ['WB_SIMULATION_ID', 'WB_PRDGRP_ID', 'WB_PROD_ID'],
    [PASchema.esWB_CBO]: ['WB_CUST_ID', 'WB_SIMULATION_ID', 'WB_PUBLISHED_MODEL_ID'],
    [PASchema.esWB_CBO_Set]: ['SET_ID', 'WB_CBO_ID'],
    [PASchema.esWB_CBO_Set_Item]: ['WB_CBO_SET_ID', 'WB_CUST_ID', 'WB_PRDGRP_ID', 'WB_PRODUCT_ID'],
    [PASchema.esWB_CBO_Input_Relationship]: ['WB_CBO_ID', 'WB_CUST_ID', 'WB_PRDGRP_ID', 'WB_PRODUCT_ID'],
    [PASchema.esWB_CBO_Constraint]: ['WB_CBO_ID', 'METRIC_ID'],
    [PASchema.esWB_Spend_Function_Relationship]: [
        'WB_CBO_ID',
        'WB_SIMULATION_INPUT_ID',
        'WB_SIMULATION_ID',
        'WB_SPEND_FUNCTION_ID'
    ],
    [PASchema.esWB_Spend_Function]: ['SPEND_FUNCTION_ID'],
    [PASchema.esWB_Spend_Function_Input_Relationship]: ['WB_SPEND_FUNCTION_ID', 'INPUT_SEQ'],
    [PASchema.esWB_Spend_Function_Term_Relationship]: ['WB_SPEND_FUNCTION_ID', 'TERM_META_ID'],
    [PASchema.esWB_ScnConstraint]: ['CONSTRAINT_ID'],

    [PASchema.esWB_Power_Metric]: ['POWERMETRIC_ID'],
    [PASchema.esWB_Power_Metric_Relationship]: [
        'WB_MODEL_PREDICTOR_ID',
        'WB_MODEL_FUNCTION_ID',
        'WB_MODEL_POWERMETRIC_ID'
    ],
    [PASchema.esWB_Modeling_Session_Reference_Predictor_Relationship]: [],
    [PASchema.esWB_Modeling_Session_Reference_Relationship]: [],
    [PASchema.esWB_Modeling_Session_Cannibalization_Type_Relationship]: [],
    [PASchema.esWB_Modeling_Session_AffinitySet_Relationship]: [],
    [PASchema.esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship]: [],
    [PASchema.esWB_Modeling_Session_StageCoeffRangePolicyMeta]: ['POLICY_ID']
})

//maps tables to foreign keys that aren't part of JSDataRels for dataexporter/importer
//TODO: Fill out foreign key references that aren't part of the natural key
_.defaults(dctNonParentForeignKeysByEntitySet, {
    [PASchema.esWB_Model]: {
        ['WB_CUSTH_ID']: PASchema.esWB_Customer_Hierarchy,
        ['WB_PRDH_ID']: PASchema.esWB_Product_Hierarchy,
        ['WB_PERIODH_ID']: PASchema.esWB_Period_Hierarchy,
        ['WB_PERIODM_ID']: PASchema.esWB_Period_Type,
        ['WB_AUTHUSR_ID_CREATEDBY']: PASchema.esWB_User
    },
    [PASchema.esWB_Model_Coeff_Set]: {
        ['WB_MODEL_ID']: PASchema.esWB_Model,
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session,
        ['WB_MODELING_SESSION_TRIAL_ID']: PASchema.esWB_Modeling_Session_Trial,
        ['WB_PERIOD_ID_ANCHOR']: PASchema.esWB_Period,
        ['WB_AUTHUSR_ID_CREATEDBY']: PASchema.esWB_User
    },
    [PASchema.esWB_Model_Constant]: {},
    [PASchema.esWB_Modeling_Session]: {
        ['WB_MODEL_ID']: PASchema.esWB_Model,
        ['WB_AUTHUSR_ID_CREATEDBY']: PASchema.esWB_User
    },
    [PASchema.esWB_Modeling_Session_Coeff_Rule]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session,
        ['WB_MODEL_COEFFICIENT_ID']: PASchema.esWB_Model_Coefficient
    },
    [PASchema.esWB_Modeling_Session_Coeff_RuleR]: {
        ['WB_MODELING_SESSION_COEFF_RULE_ID']: PASchema.esWB_Modeling_Session
    },
    [PASchema.esWB_Modeling_Session_Coeff_Grp]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session,
        ['WB_MODEL_COEFFICIENT_ID']: PASchema.esWB_Model_Coefficient
    },
    [PASchema.esWB_Modeling_Session_Coeff_GrpSt]: {
        ['WB_MODELING_SESSION_COEFF_GRP_ID']: PASchema.esWB_Modeling_Session_Coeff_Grp
    },
    [PASchema.esWB_Modeling_Session_Coeff_GrpStR]: {
        ['WB_MODELING_SESSION_COEFF_GRPST_ID']: PASchema.esWB_Modeling_Session_Coeff_GrpSt
    },
    [PASchema.esWB_Modeling_Session_CustR]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session,
        ['WB_CUST_ID']: PASchema.esWB_Customer
    },
    [PASchema.esWB_Modeling_Session_ProdR]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session,
        ['WB_PRDGRP_ID']: PASchema.esWB_Product_Group
    },
    [PASchema.esWB_Modeling_Session_Log]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session,
        ['WB_MODELING_SESSION_TRIAL_ID']: PASchema.esWB_Modeling_Session_Trial
    },
    [PASchema.esWB_Modeling_Session_Trial]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session,
        ['WB_MODEL_COEFF_SET_ID']: PASchema.esWB_Model_Coeff_Set
    },
    [PASchema.esWB_Modeling_Session_Trial_Metric]: {
        ['WB_MODELING_SESSION_TRIAL_ID']: PASchema.esWB_Modeling_Session_Trial
    },
    [PASchema.esWB_Modeling_Session_Trial_PredictorR_Metric]: {},
    [PASchema.esWB_Modeling_Session_Trial_Residual_Metric]: {
        ['WB_MODELING_SESSION_TRIAL_ID']: PASchema.esWB_Modeling_Session_Trial,
        ['WB_MODEL_PREDICTOR_ID']: PASchema.esWB_Model_Predictor,
        ['WB_CUST_ID']: PASchema.esWB_Customer,
        ['WB_PRDGRP_ID']: PASchema.esWB_Product_Group,
        ['WB_PERIOD_ID']: PASchema.esWB_Period
    },
    [PASchema.esWB_Modeling_Session_Range]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session,
        ['WB_MODELING_COEFFICIENT_ID']: PASchema.esWB_Model_Coefficient
    },
    [PASchema.esWB_Modeling_Session_Trial_PartitionStage]: {},
    [PASchema.esWB_Modeling_Session_Trial_PartitionStageS]: {},
    [PASchema.esWB_Modeling_Session_Trial_PartitionStageSL]: {},
    [PASchema.esWB_Modeling_Session_Observation]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session,
        ['WB_MODELING_SESSION_TRIAL_ID']: PASchema.esWB_Modeling_Session_Trial,
        ['WB_CUST_ID']: PASchema.esWB_Customer,
        ['WB_PRDGRP_ID']: PASchema.esWB_Product_Group,
        ['WB_PROD_ID']: PASchema.esWB_Finished_Product,
        ['WB_PERIOD_ID']: PASchema.esWB_Period,
        ['WB_TAG_ID']: PASchema.esWB_Tag
    },
    [PASchema.esWB_Modeling_Session_Tag_RuleR]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session,
        ['WB_TAG_ID']: PASchema.esWB_Tag
    },
    [PASchema.esWB_Modeling_SessionPR]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session,
        ['WB_CUST_ID']: PASchema.esWB_Customer,
        ['WB_PRDGRP_ID']: PASchema.esWB_Product_Group,
        ['WB_PROD_ID']: PASchema.esWB_Finished_Product,
        ['WB_PERIOD_ID']: PASchema.esWB_Period
    },
    [PASchema.esWB_Modeling_Session_El]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session
    },
    [PASchema.esWB_Modeling_Session_ElR]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session
    },
    [PASchema.esWB_Modeling_Session_ElCR]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session
    },
    [PASchema.esWB_Modeling_Session_TermR]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session
    },
    [PASchema.esWB_Modeling_Session_ConstantR]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session
    },
    [PASchema.esWB_Modeling_Session_ConstantFR]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session
    },
    [PASchema.esWB_Modeling_Session_SeasonalityMt]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session
    },
    [PASchema.esWB_Modeling_Session_Seasonality_DepMt]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session
    },
    [PASchema.esWB_Modeling_Session_Seasonality_Coeff]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session
    },
    [PASchema.esWB_Model_Coeff_SetConstR]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session
    },
    [PASchema.esWB_Published_Model]: {
        ['WB_MODEL_ID']: PASchema.esWB_Model,
        ['WB_MODEL_COEFF_SET_ID']: PASchema.esWB_Model_Coeff_Set,
        ['WB_AUTHUSR_ID_CREATEDBY']: PASchema.esWB_User
    },
    [PASchema.esWB_Cannibalization_Set]: {
        ['WB_PRDGRP_ID_AFFSET']: PASchema.esWB_Product_Group,
        ['WB_AUTHUSR_ID']: PASchema.esWB_User
    },
    [PASchema.esWB_Cannibalization_Set_Customer]: {
        ['WB_CANN_ID']: PASchema.esWB_Cannibalization_Set,
        ['WB_CUST_ID']: PASchema.esWB_Customer
    },
    [PASchema.esWB_Cannibalization_Set_Product_Group]: {
        ['WB_CANN_ID']: PASchema.esWB_Cannibalization_Set,
        ['WB_CUST_ID_PLANNING_VICT']: PASchema.esWB_Customer,
        ['WB_PRDGRP_ID_VICT']: PASchema.esWB_Product_Group,
        ['WB_CUST_ID_PLANNING_AGGR']: PASchema.esWB_Customer,
        ['WB_PRDGRP_ID_AGGR']: PASchema.esWB_Product_Group
    },
    [PASchema.esWB_Cannibalization_Set_Product]: {
        ['WB_CANNPG_ID']: PASchema.esWB_Cannibalization_Set_Product_Group,
        ['WB_PROD_ID']: PASchema.esWB_Finished_Product
    },
    [PASchema.esWB_Model_Predictor]: { ['WB_TAG_ID']: PASchema.esWB_Tag },
    [PASchema.esWB_Model_Function]: {},
    [PASchema.esWB_Model_Term]: {
        ['WB_MODEL_FUNCTION_ID']: PASchema.esWB_Model_Function,
        ['WB_MODEL_PREDICTOR_ID']: PASchema.esWB_Model_Predictor,
        ['WB_MODEL_COEFFICIENT_ID']: PASchema.esWB_Model_Coefficient
    },
    [PASchema.esWB_Model_Term_Relationship]: {},
    [PASchema.esWB_Model_Event_Type_Relationship]: {
        ['WB_MODEL_VOLUME_COMPONENT_ID']: PASchema.esWB_Model_Volume_Component
    },
    [PASchema.esWB_Model_Compare]: {
        ['WB_CUSTH_ID']: PASchema.esWB_Customer_Hierarchy,
        ['WB_PRDH_ID']: PASchema.esWB_Product_Hierarchy,
        ['WB_PERIODM_ID']: PASchema.esWB_Period_Type,
        ['WB_PERIODH_ID']: PASchema.esWB_Period_Hierarchy
    },
    [PASchema.esWB_Model_Compare_Relationship]: {},
    [PASchema.esWB_Model_Cannibalization_Term_Relationship]: {
        ['WB_MODEL_TERM_ID']: PASchema.esWB_Model_Term,
        ['WB_MODEL_CANNR_ID']: PASchema.esWB_Model_Cannibalization_Relationship
    },
    [PASchema.esWB_Model_Cannibalization_Relationship]: {
        ['WB_MODEL_CANNIBALIZATIONM_ID']: PASchema.esWB_Model_Cannibalization_Type,
        ['WB_MODEL_ID']: PASchema.esWB_Model,
        ['WB_MODEL_COEFFICIENT_ID']: PASchema.esWB_Model_Coefficient,
        ['WB_MODEL_COEFFICIENT_ID2']: PASchema.esWB_Model_Coefficient,
        ['WB_MODEL_FUNCTION_ID']: PASchema.esWB_Model_Function,
        ['WB_MODEL_POWERMETRIC_ID']: PASchema.esWB_Power_Metric
    },
    [PASchema.esWB_Model_Cannibalization_Type]: {},
    [PASchema.esWB_Model_Predictor_Relationship]: {
        ['WB_MODEL_ID']: PASchema.esWB_Model,
        ['WB_MODEL_PREDICTOR_ID']: PASchema.esWB_Model_Predictor
    },
    [PASchema.esWB_Custom_Column]: {},
    [PASchema.esWB_Model_Volume_Component]: {},
    [PASchema.esWB_Model_DataSource]: {},
    [PASchema.esWB_Model_Coeff_Set_Rule]: {
        ['WB_MODEL_COEFF_SET_ID']: PASchema.esWB_Model_Coeff_Set,
        ['WB_PRDH_ID']: PASchema.esWB_Product_Hierarchy,
        ['WB_PERIODH_ID']: PASchema.esWB_Period_Hierarchy,
        ['WB_PERIODM_ID']: PASchema.esWB_Period_Type
    },
    [PASchema.esWB_Model_Coeff_SetCR]: {
        ['WB_MODEL_COEFF_SET_ID']: PASchema.esWB_Model_Coeff_Set,
        ['WB_MODEL_CANNIBALIZATIONM_ID']: PASchema.esWB_Model_Cannibalization_Type,
        ['WB_AFFINITYGROUP_ID_AGGR']: PASchema.esWB_Product_Group,
        ['WB_AFFINITYGROUP_ID_VCTM']: PASchema.esWB_Product_Group
    },
    [PASchema.esWB_Model_Coeff_SetASR]: {
        ['WB_MODEL_COEFF_SET_ID']: PASchema.esWB_Model_Coeff_Set,
        ['WB_AFFINITYSET_ID']: PASchema.esWB_AffinitySet
    },
    [PASchema.esWB_Model_Coeff_SetPMR]: {
        ['WB_MODEL_COEFF_SET_ID']: PASchema.esWB_Model_Coeff_Set,
        ['WB_MODEL_CANNIBALIZATIONM_ID']: PASchema.esWB_Model_Cannibalization_Type,
        ['WB_MODEL_PREDICTOR_ID']: PASchema.esWB_Model_Predictor
    },
    [PASchema.esWB_Model_Coeff_SetR]: {
        ['WB_MODEL_COEFF_SET_ID']: PASchema.esWB_Model_Coeff_Set,
        ['WB_CUST_ID']: PASchema.esWB_Customer,
        ['WB_PRDGRP_ID']: PASchema.esWB_Product_Group,
        ['WB_PROD_ID']: PASchema.esWB_Finished_Product
    },
    [PASchema.esWB_Model_Coeff_SetRR]: {
        ['WB_MODEL_COEFF_SET_ID']: PASchema.esWB_Model_Coeff_Set,
        ['WB_CUST_ID']: PASchema.esWB_Customer,
        ['WB_PRDGRP_ID']: PASchema.esWB_Product_Group,
        ['WB_PROD_ID']: PASchema.esWB_Finished_Product,
        ['WB_MODEL_PREDICTOR_ID']: PASchema.esWB_Model_Predictor
    },
    [PASchema.esWB_Model_Coeff_SetTR]: {
        ['WB_MODEL_COEFF_SET_ID']: PASchema.esWB_Model_Coeff_Set,
        ['WB_CUST_ID']: PASchema.esWB_Customer,
        ['WB_PRDGRP_ID']: PASchema.esWB_Product_Group,
        ['WB_PROD_ID']: PASchema.esWB_Finished_Product,
        ['WB_MODEL_TERM_ID']: PASchema.esWB_Model_Term
    },
    [PASchema.esWB_Model_Volume_ComponentR]: {
        ['WB_MODEL_ID']: PASchema.esWB_Model,
        ['WB_MODEL_VOLUME_COMPONENT_ID']: PASchema.esWB_Model_Volume_Component
    },
    [PASchema.esWB_Model_Volume_Component_ItemR]: {
        ['WB_MODEL_VOLUME_COMPONENTR_ID']: PASchema.esWB_Model_Volume_ComponentR,
        ['WB_MODEL_PREDICTOR_ID']: PASchema.esWB_Model_Predictor,
        ['WB_TAG_ID']: PASchema.esWB_Tag
    },
    [PASchema.esWB_Model_Input]: {},
    [PASchema.esWB_Model_Tag_Relationship]: {
        ['WB_MODEL_ID']: PASchema.esWB_Model,
        ['WB_TAG_ID']: PASchema.esWB_Tag
    },
    [PASchema.esWB_Simulation_Input]: {},
    [PASchema.esWB_Simulation_Input_Relationship]: {
        ['WB_SIMULATION_ID']: PASchema.esWB_Simulation,
        ['WB_PRDGRP_ID']: PASchema.esWB_Product_Group,
        ['WB_PERIOD_ID']: PASchema.esWB_Period
    },
    [PASchema.esWB_Simulation_Predictor_Relationship]: {
        ['WB_SIMULATION_ID']: PASchema.esWB_Simulation,
        ['WB_PRDGRP_ID']: PASchema.esWB_Product_Group,
        ['WB_PERIOD_ID']: PASchema.esWB_Period
    },
    [PASchema.esWB_Simulation_Product]: {
        ['WB_SIMULATION_ID']: PASchema.esWB_Simulation,
        ['WB_PRDGRP_ID']: PASchema.esWB_Product_Group,
        ['WB_PRODUCT_ID']: PASchema.esWB_Finished_Product
    },
    [PASchema.esWB_Simulation]: {},
    [PASchema.esWB_Simulation_Relationship]: {},
    [PASchema.esWB_CBO]: {
        ['WB_PUBLISHED_MODEL_ID']: PASchema.esWB_Published_Model
    },
    [PASchema.esWB_CBO_Set]: {
        ['WB_CBO_ID']: PASchema.esWB_CBO
    },
    [PASchema.esWB_CBO_Set_Item]: {
        ['WB_CBO_ID']: PASchema.esWB_CBO,
        ['WB_CBO_SET_ID']: PASchema.esWB_CBO_Set
    },
    [PASchema.esWB_CBO_Input_Relationship]: {
        ['WB_CBO_ID']: PASchema.esWB_CBO,
        ['WB_PRDGRP_ID']: PASchema.esWB_Product_Group
    },
    [PASchema.esWB_Spend_Function_Relationship]: {
        ['WB_CBO_ID']: PASchema.esWB_CBO,
        ['WB_SIMULATION_ID']: PASchema.esWB_Simulation,
        ['WB_SPEND_FUNCTION_ID']: PASchema.esWB_Spend_Function
    },
    [PASchema.esWB_Spend_Function]: {
        ['WB_SPEND_FUNCTION_ID_SPECIFIC']: PASchema.esWB_Spend_Function
    },
    [PASchema.esWB_Spend_Function_Input_Relationship]: {},
    [PASchema.esWB_Spend_Function_Term_Relationship]: {},
    [PASchema.esWB_Power_Metric]: {},
    [PASchema.esWB_Power_Metric_Relationship]: {
        ['WB_MODEL_FUNCTION_ID']: PASchema.esWB_Model_Function,
        ['WB_MODEL_PREDICTOR_ID']: PASchema.esWB_Model_Predictor,
        ['WB_MODEL_POWERMETRIC_ID']: PASchema.esWB_Power_Metric
    },
    [PASchema.esWB_Modeling_Session_Reference_Predictor_Relationship]: {},
    [PASchema.esWB_Modeling_Session_Reference_Relationship]: {},
    [PASchema.esWB_Modeling_Session_Cannibalization_Type_Relationship]: {
        ['WB_MODELING_SESSION_ID']: PASchema.esWB_Modeling_Session,
        ['WB_MODEL_CANNR_ID']: PASchema.esWB_Model_Cannibalization_Relationship,
        ['WB_MODEL_CANNM_ID']: PASchema.esWB_Model_Cannibalization_Type
    },
    [PASchema.esWB_Modeling_Session_AffinitySet_Relationship]: {},
    [PASchema.esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship]: {
        ['WB_MODEL_PREDICTOR_ID']: PASchema.esWB_Model_Predictor,
        ['WB_MODELING_SESSION_CANNMR_ID']: PASchema.esWB_Modeling_Session_Cannibalization_Type_Relationship
    }
})

//WB_PREDICTOR table and WB_MODEL_DATASOURCE tables should share the same key generator so unique keys won't overlap
const modelPredictorKeyGenSpecs: IKeyGeneratorSpecs = {
    sequence_name: '/AZR/WB_MODEL_PREDICTOR_SEQ',
    ...KeyGenSpecs_default
}

_.defaults(dctMapperToKeyGenSpecs, {
    [PASchema.esWB_AffinityGroup]: { sequence_name: '/AZR/WB_AFFINITYGROUP_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_AffinityGroupItem]: { sequence_name: '/AZR/WB_AFFINITYGROUPITEM_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_AffinitySet]: { sequence_name: '/AZR/WB_AFFINITYSET_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Cannibalization_Set]: { sequence_name: '/AZR/WB_CANN_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Cannibalization_Set_Customer]: { sequence_name: '/AZR/WB_CANNCST_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Cannibalization_Set_Product_Group]: { sequence_name: '/AZR/WB_CANNPG_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Cannibalization_Set_Product]: { sequence_name: '/AZR/WB_CANNPRD_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_LiftAPI]: { sequence_name: '/AZR/WB_LIFTAPI_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model]: { sequence_name: '/AZR/WB_MODEL_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Constant]: { sequence_name: '/AZR/WB_MODEL_CONSTANT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Modeling_Session]: { sequence_name: '/AZR/WB_MODELING_SESSION_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Modeling_Session_Stage]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_STAGE_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_StageCoeffRangePolicy]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_STAGECRP_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_StageCoeffRangePolicyR]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_STAGECRPR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_StageCoeffRangePolicyMeta]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_STAGECRP_META_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_StageAlgorithm]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_STAGEAR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_CustR]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_CUSTR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Coeff_Rule]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_COEFF_RULE_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Coeff_RuleR]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_COEFF_RULER_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Coeff_Grp]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_COEFF_GRP_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Coeff_GrpSt]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_COEFF_GRPST_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Coeff_GrpStR]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_COEFF_GRPSTR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Log]: { sequence_name: '/AZR/WB_MODELING_SESSION_LOG_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Modeling_Session_Reference_Relationship]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_REFR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Observation]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_OBS_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_ProdR]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_PRODR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Range]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_RANGE_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Trial]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_TRIAL_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Trial_Metric]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_TRIALMT_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Trial_Residual_Metric]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_TRIALRSDMT_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Trial_Predictor_Metric]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_TRIAL_PMT_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Trial_PredictorR_Metric]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_TRIAL_PRMT_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Trial_PartitionStage]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_TRIALPS_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Trial_PartitionStageS]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_TRIALPSS_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Trial_PartitionStageSL]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_TRIALPSSL_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Tag_RuleR]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_TAG_RULER_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_SessionPR]: { sequence_name: '/AZR/WB_MODELING_SESSIONPR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Modeling_Session_El]: { sequence_name: '/AZR/WB_MODELING_SESSION_EL_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Modeling_Session_ElR]: { sequence_name: '/AZR/WB_MODELING_SESSION_ELR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Modeling_Session_ElCR]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_ELCR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_TermR]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_TERMR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_ConstantR]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_CONSTANTR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_ConstantFR]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_CONSTANTFR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_SeasonalityMt]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_SEASONALITYMT_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Seasonality_DepMt]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_SEASONALITY_DEPMT_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Seasonality_Coeff]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_SEASONALITY_COEFF_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Model_Coeff_SetConstR]: {
        sequence_name: '/AZR/WB_MODEL_COEFF_SETCONSTR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Model_Coefficient]: { sequence_name: '/AZR/WB_MODEL_COEFFICIENT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Coeff_Set]: { sequence_name: '/AZR/WB_MODEL_COEFF_SET_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Coeff_SetR]: { sequence_name: '/AZR/WB_MODEL_COEFF_SETR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Coeff_SetRR]: { sequence_name: '/AZR/WB_MODEL_COEFF_SETRR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Coeff_SetCR]: { sequence_name: '/AZR/WB_MODEL_COEFF_SETCR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Coeff_SetPMR]: { sequence_name: '/AZR/WB_MODEL_COEFF_SETPMR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Coeff_SetASR]: { sequence_name: '/AZR/WB_MODEL_COEFF_SETASR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Coeff_SetTR]: { sequence_name: '/AZR/WB_MODEL_COEFF_SETTR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Coeff_Set_Rule]: { sequence_name: '/AZR/WB_MODEL_COEFF_SET_RULE_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Function]: { sequence_name: '/AZR/WB_MODEL_FUNCTION_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Input]: { sequence_name: '/AZR/WB_MODEL_INPUT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Predictor]: modelPredictorKeyGenSpecs,
    [PASchema.esWB_Model_Predictor_Relationship]: {
        sequence_name: '/AZR/WB_MODEL_PREDICTORR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Model_Tag_Relationship]: { sequence_name: '/AZR/WB_MODEL_TAGR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Term]: { sequence_name: '/AZR/WB_MODEL_TERM_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Term_Relationship]: { sequence_name: '/AZR/WB_MODEL_TERMR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Event_Type_Relationship]: {
        sequence_name: '/AZR/WB_MODEL_EVTTYPER_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Model_Compare]: { sequence_name: '/AZR/WB_MODEL_COMPARE_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Compare_Relationship]: { sequence_name: '/AZR/WB_MODEL_COMPARER_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Cannibalization_Relationship]: {
        sequence_name: '/AZR/WB_MODEL_CANNR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Model_Cannibalization_Const_Relationship]: {
        sequence_name: '/AZR/WB_MODEL_CANNCR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_CANNPMR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Model_Cannibalization_Term_Relationship]: {
        sequence_name: 'WB_MODEL_CANNTERMR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Model_Cannibalization_Type]: {
        sequence_name: '/AZR/WB_MODEL_CANNIBALIZATIONM_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Model_Profile]: { sequence_name: '/AZR/WB_MODEL_PROFILE_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Profile_Predictor]: { sequence_name: '/AZR/WB_MODEL_PROFILEPR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Profile_Group]: { sequence_name: '/AZR/WB_MODEL_PROFILEGR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Model_Profile_Group_Predictor]: {
        sequence_name: '/AZR/WB_MODEL_PROFILEGPR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Model_Profile_Spend_Function]: {
        sequence_name: '/AZR/WB_MODEL_PROFILESFR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Model_DataSource]: modelPredictorKeyGenSpecs,
    [PASchema.esWB_Model_Volume_Component]: {
        sequence_name: '/AZR/WB_MODEL_VOLUME_COMPONENT_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Model_Volume_ComponentR]: {
        sequence_name: '/AZR/WB_MODEL_VOLUME_COMPONENTR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Model_Volume_Component_ItemR]: {
        sequence_name: '/AZR/WB_MODEL_VOLUME_COMPONENT_ITEMR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Published_Model]: { sequence_name: '/AZR/WB_PUBLISHED_MODEL_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Simulation_Input]: { sequence_name: '/AZR/WB_SIMULATION_INPUT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Simulation_Input_Relationship]: {
        sequence_name: '/AZR/WB_SIMULATION_INPUTR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Simulation]: { sequence_name: '/AZR/WB_SIMULATION_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Simulation_Relationship]: { sequence_name: '/AZR/WB_SIMULATIONSR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Simulation_Predictor_Relationship]: {
        sequence_name: '/AZR/WB_SIMULATION_PREDICTORR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Simulation_Product]: { sequence_name: '/AZR/WB_SIMULATION_PRD_SEQ', ...KeyGenSpecs_default },

    [PASchema.esWB_ScnPlan]: { sequence_name: '/AZR/WB_SCNPLAN_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlan_EvtTypeR]: { sequence_name: '/AZR/WB_SCNPLAN_EVTTYPER_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlan_CustR]: { sequence_name: '/AZR/WB_SCNPLAN_CUSTR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlan_PrdR]: { sequence_name: '/AZR/WB_SCNPLAN_PRDR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlan_PredictorR]: { sequence_name: '/AZR/WB_SCNPLAN_PREDICTORR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlan_InputR]: { sequence_name: '/AZR/WB_SCNPLAN_INPUTR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlan_CoeffR]: { sequence_name: '/AZR/WB_SCNPLAN_COEFFR_SEQ', ...KeyGenSpecs_default },

    [PASchema.esWB_ScnPlanner]: { sequence_name: '/AZR/WB_SCNPLANNER_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlannerCalc]: { sequence_name: '/AZR/WB_SCNPLANNERCALC_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlannerCalcLog]: { sequence_name: '/AZR/WB_SCNPLANNERCALCLOG_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlannerCnstr]: { sequence_name: '/AZR/WB_SCNPLANNERCNSTR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlannerCR]: { sequence_name: '/AZR/WB_SCNPLANNERCR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlannerESR]: { sequence_name: '/AZR/WB_SCNPLANNERESR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlannerPPR]: { sequence_name: '/AZR/WB_SCNPLANNERPPR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlannerPR]: { sequence_name: '/AZR/WB_SCNPLANNERPR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlannerPrdPR]: { sequence_name: '/AZR/WB_SCNPLANNERPRDPR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlannerPrdPPR]: { sequence_name: '/AZR/WB_SCNPLANNERPRDPPR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlannerPrmR]: { sequence_name: '/AZR/WB_SCNPLANNERPRMR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlannerTrial]: { sequence_name: '/AZR/WB_SCNPLANNERTRIAL_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlannerTrialPR]: { sequence_name: '/AZR/WB_SCNPLANNERTRIALPR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlannerTrialCNR]: { sequence_name: '/AZR/WB_SCNPLANNERTRIALCNR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_ScnPlannerTrialEvt]: { sequence_name: '/AZR/WB_SCNPLANNERTRIALEVT_SEQ', ...KeyGenSpecs_default },

    [PASchema.esWB_ScnConstraint]: { sequence_name: '/AZR/WB_SCNCONSTRAINTM_SEQ', ...KeyGenSpecs_default },

    [PASchema.esWB_Model_API_Log]: { sequence_name: '/AZR/WB_MODEL_API_LOG_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_CBO]: { sequence_name: '/AZR/WB_CBO_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_CBO_Set]: { sequence_name: '/AZR/WB_CBO_SET_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_CBO_Set_Item]: { sequence_name: '/AZR/WB_CBO_SET_ITEM_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_CBO_Set_Predictor]: { sequence_name: '/AZR/WB_CBO_SET_PR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_CBO_Input_Relationship]: { sequence_name: '/AZR/WB_CBO_INPUTR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_CBO_Constraint]: { sequence_name: '/AZR/WB_CBO_CSTR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Spend_Function]: { sequence_name: '/AZR/WB_SPEND_FUNCTION_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Spend_Function_Input_Relationship]: {
        sequence_name: '/AZR/WB_SPEND_FUNCTION_INPUT_RELATIONSHIP_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Spend_Function_Term_Relationship]: {
        sequence_name: '/AZR/WB_SPEND_FUNCTION_TERM_RELATIONSHIP_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Spend_Function_Relationship]: {
        sequence_name: '/AZR/WB_SPEND_FUNCTION_RELATIONSHIP_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Spend_Function_Relationship_Scope]: {
        sequence_name: '/AZR/WB_SPEND_FUNCTION_RELATIONSHIP_SCOPE_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Simulation_Metrics]: { sequence_name: '/AZR/WB_SIMMT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Simulation_Metrics_CBO_Set]: { sequence_name: '/AZR/WB_SIMMTSR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Simulation_Spend_Metrics]: { sequence_name: '/AZR/WB_SIMSMT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Power_Metric]: { sequence_name: '/AZR/WB_MODEL_POWERMETRIC_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Power_Metric_Relationship]: {
        sequence_name: '/AZR/WB_MODEL_POWERMETRICR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Reference_Predictor_Relationship]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_REFPR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_Cannibalization_Type_Relationship]: {
        [PASchema.esWB_Modeling_Session_AffinitySet_Relationship]: {
            sequence_name: '/AZR/WB_MODELING_SESSION_ASR_SEQ',
            ...KeyGenSpecs_default
        },
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Modeling_Session_AffinitySet_Relationship]: {
        sequence_name: '/AZR/WB_MODELING_SESSION_ASR_SEQ',
        ...KeyGenSpecs_default
    }
})
